import React, { useEffect, useMemo, useRef, useState } from "react";
import Select from "react-select";
import eyeOpen from "../assets/icons/eyeOpen.svg";
import downloadBtn from "../assets/icons/downloadBtn.svg";
import dangerIcon from "../assets/icons/dangerIcon.svg";
import { toast } from "react-toastify";
import {
  AiFillCaretDown,
  AiFillCloseCircle,
  AiFillInfoCircle,
  AiOutlineArrowRight,
  AiOutlineArrowsAlt,
  AiOutlineCheck,
  AiOutlineDown,
  AiOutlineExclamationCircle,
  AiOutlineFileText,
  AiOutlinePlus,
  AiOutlineWarning,
} from "react-icons/ai";
import AreaChart from "../components/charts/areaChart";
import { TagCloud } from "react-tagcloud";
import ReactStars from "react-stars";
import Backdrop from "../components/backdrop";
import Dropdown from "../components/dropdown";
import PaceReport from "./dashboard/Tables/PaceReport";
import RevenueReportTable from "./dashboard/Tables/RevenueReport";
import channelImg from "../assets/channelPerformance.svg";
import eventsImg from "../assets/eventsImg.svg";
import cancellationImg from "../assets/cancellationImg.svg";
import sentimental from "../assets/sentimentalImg.svg";
import reputationImg from "../assets/reputation.svg";
import {
  useGetForecastedDataQuery,
  useGetPerformanceMatricesQuery,
  useGetSentimentalAnalysisQuery,
  useGetDropDownDataQuery,
  usePostQuickReportMutation,
  useGetQuickReportQuery,
  useGetAdvertisementDataQuery,
  useGetQuickActionQuery,
  useGetRatingsQuery,
  useDashboardUrgentActionQuery,
  useGetChannelManagerFaultsQuery,
  useGetHotelPerformanceDashboardQuery,
  useGetHotelPerformanceDetailQuery,
  useGetRateAnalysisDynamicRateSingleDayQuery,
  useGetHotelPerformanceQuery,
} from "../redux/slices/dashboard";
import { CurrentProperty, UserId } from "../utils/impVars";
import BackdropLoader from "../components/newLoader";
import { calculatePercentage } from "../utils/calculatePercentage";
import Notification from "../components/notificationCard/Notification";
import { addDays, format } from "date-fns";
import {
  useGetActionsToTakeQuery,
  useGetAllWidgetQuery,
  useGetWidgetsQuery,
  usePostWidgetsMutation,
  useGetCancellationQuery,
  useGetUpcomingEventQuery,
  useGetChannelQuery,
  useAcceptRateMutation,
  useVerifyRatesMutation,
} from "../redux/slices/newDashboard";
import { useLocation, useNavigate } from "react-router-dom";
import formatCurrency from "../utils/formatCurrency";
import SolutionTile from "../components/newDashboard/solutionTitle";
import { useGetLoginInfoQuery } from "../redux/slices/settings/userManagement";
import { useDispatch, useSelector } from "react-redux";
import { setLoginData } from "../redux/states/login";
import InfoToolTip from "../components/tooltip/InfoToolTip";
import SourceReport from "./dashboard/Tables/SourceReport";
import SegmentReport from "./dashboard/Tables/SegmentReport";
import QuarterlyReport from "./dashboard/Tables/QuarterlyReport";
import ParityReport from "./dashboard/Tables/ParityReport";
import {
  useArcrEdRateDataQuery,
  useArcrEdRateFluctuationDataQuery,
  useArcrEdReputationRankReviewDataQuery,
  useArcrIdMetricsDataQuery,
  useArcrIdPaceDataQuery,
  useDynamicRateChangeReportQuery,
  useGetMonthEndReportQuery,
  useGetPaceReportQuery,
  useGetParityReportQuery,
  useGetPickUpReportQuery,
  useGetQuarterlyReportQuery,
  useGetRateChangeReportQuery,
  useGetRatesReportQuery,
  useGetRevenueReportQuery,
  useGetSegmentReportQuery,
  useGetSourceReportQuery,
  useGetYearEndReportQuery,
  useHotelProductivityReportQuery,
  useGetRevenueDeckReportQuery
} from "../redux/slices/reports";
import { DownloadMonthEndReport } from "./dashboard/DownloadExcel/MonthEndReport";
import { DownloadRevenueReport } from "./dashboard/DownloadExcel/RevenueReport";
import { DownloadSourceReport } from "./dashboard/DownloadExcel/SourceReport";
import { DownloadSegmentReport } from "./dashboard/DownloadExcel/SegmentReport";
import { DownloadQuaterlyReport } from "./dashboard/DownloadExcel/QuaterlyReport";
import { DownloadPaceReport } from "./dashboard/DownloadExcel/PaceReport";
import { DownloadParityReport } from "./dashboard/DownloadExcel/ParityReport";
import PickUpReport from "./dashboard/Tables/PickUpReport";
import YearEndReport from "./dashboard/Tables/YearEndReport";
import MonthEndTable from "./dashboard/Tables/MonthEndReport";
import { YearEndReportdownload } from "./dashboard/DownloadExcel/YearEndReport";
import CustomSkeleton from "../components/Skeleton";
import { useIsIpad } from "../utils/isIpad";
import { Tooltip } from "react-tooltip";
import { ratesReportDownload } from "./dashboard/DownloadExcel/RatesReport";
import RatesReport from "./dashboard/Tables/RatesReport";
import { downloadPickUPReport } from "./dashboard/DownloadExcel/pickupReprot";
import RazorpayPayment from "../components/razorpayPayment";
import { ActiveOtaOptions } from "../utils/otaOptions";
import useIntelligenceDateRange from "../utils/dateRange";
import useRatePulseDateRange from "../utils/ratepulseDateRange";
import OccupencyReport from "./dashboard/Tables/OccupencyReport";
import { useGetInventoryQuery } from "../redux/slices/ratesInventory";
import { DownloadOccupencyReport } from "./dashboard/DownloadExcel/OccupencyReport";
import revens from "../assets/icons/revens.svg";
import {
  useGetActualAndSuggestedRatesQuery,
  useOverrideRateMutation,
  usePushRateBifercationMutation,
  usePushRateMutation,
} from "../redux/slices/rateSuggestions";
import { useChannelManagerListQuery } from "../redux/slices/onBoarding";
import passwordExpire from "../assets/icons/passwordExpire.svg";
import {
  useAddNewPropertyChannelManagerMutation,
  useUpdateCMPasswordMutation,
} from "../redux/slices/settings/myProperties";
import Alert from "../components/alerts";
import PropertyName from "../utils/propertyName";
import CancellationReport from "./dashboard/Tables/CancellationReport";
import { DownloadCancellationReport } from "./dashboard/DownloadExcel/CancellationReport";
import RevensHey from "../assets/icons/revens.svg";
import { RxCross2 } from "react-icons/rx";
import { FaChevronLeft, FaChevronRight, FaLastfmSquare } from "react-icons/fa";
import { ProgressBar } from "./newRatePulseDashboard";
import { increaseByPercentage } from "./rateSuggestion/rateAnalysis";
import RateChangeReport from "./dashboard/Tables/RateChangeReport";
import "../pages/HeartProgress.css";
import { LiaMapMarkerAltSolid } from "react-icons/lia";
import CheckBox from "../components/checkbox/CheckBox";
import DynamicRateChangeReport from "./dashboard/Tables/DynamicRateChangeReport";
import { DownloadDynamicRateChangeReport } from "./dashboard/DownloadExcel/DynamicRateChangeReport";
import HotelProductivityReportTable from "./dashboard/Tables/HotelProductivityReport";
import RevenueDeckReport from "./dashboard/Tables/RevenueDeckReport";
import { DownloadRevenueDeckReportExcel } from "./dashboard/DownloadExcel/RevenueDeckReportExcel";

export const calculateDifference = (currentValue, pastValue, isCurrency) => {
  const diff = parseInt(currentValue) - parseInt(pastValue);
  return isCurrency ? formatCurrency(diff, { isShortFormat: true }) : diff;
};

function countCategoriesWithSolutions(data) {
  if (!data.status || data.code !== 200) {
    throw new Error("Invalid data");
  }

  let count = 0;

  data?.data.forEach((task) => {
    if (task.solution && task.solution.length > 0) {
      count++;
    }
  });

  return count;
}

function transformApiData(apiData) {
  const transformedData = [
    ...apiData.positiveSentiment?.slice(0, 10).map((item) => ({
      value: (item?.keyword?.positive + " ").split(",")[0],
      count: item?.severityRating * 20,
      sentiment: "positive", // Custom property to distinguish sentiment
    })),
    ...apiData?.negativeSentiment?.slice(0, 10).map((item) => ({
      value: (item?.keyword?.negative + " ").split(",")[0],
      count: item?.severityRating * 20,
      sentiment: "negative", // Custom property to distinguish sentiment
    })),
  ];
  return transformedData;
}

const NewDashboard = () => {
  // const { data: SelectedWidgets, refetch: refetchWidget , isLoading } = useGetWidgetsQuery({
  //   userId: UserId(),
  //   hId: CurrentProperty(),
  // });

  const [isToggled, setIsToggle] = useState(false);
  const [showCM_Modal, setShowCM_Modal] = useState(false);
  const [actionCount, setActionCount] = useState();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const targetRef = useRef(null);
  const [addWidget, setAddWidget] = useState(false);
  const [propUser, setPropUser] = useState();
  const [propNamee, setPropNamee] = useState();
  const [selectedForcastedRange, setSelectedForeCastedRange] = useState({
    label: "7D",
    value: "7D",
  });
  const [getCmId, setGetCmId] = useState();
  const [timePeriod, setTimePeriod] = useState("past30Days");
  const [options, setOptions] = useState(null);
  const [selectedItem, setSelectedItem] = useState(
    (options && options[0]?.type) || "Revenue"
  );

  const scrollToTarget = () => {
    if (targetRef.current) {
      targetRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const [rating, setRating] = useState(4.7);

  const colorOptions = {
    luminosity: "white",
    hue: "red",
  };

  const { data: loginInfo } = useGetLoginInfoQuery({
    userId: UserId(),
    hId: CurrentProperty(),
  });

  const {
    data: getPerformanceMatrices,
    isFetching: getPerformanceMatricesIsFetching,
    isLoading: getPerformanceMatricesIsLoading,
  } = useGetPerformanceMatricesQuery(
    {
      hId: CurrentProperty(),
      userId: UserId(),
      timePeriod: timePeriod,
      chartData:
        selectedItem?.toLowerCase() === "revenue"
          ? "revenue"
          : selectedItem?.toLowerCase() === "adr"
            ? "ADR"
            : selectedItem?.toLowerCase() === "room nights"
              ? "roomNights"
              : selectedItem?.toLowerCase() === "los"
                ? "los"
                : selectedItem?.toLowerCase() === "occupancy" && "occupancy",
    },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  const {
    data: getSentimentalAnalysis,
    isLoading: sentimentalAnalysisIsLoading,
    isFetching: sentimentalAnalysisIsFetching,
  } = useGetSentimentalAnalysisQuery({
    userId: UserId(),
    hId: CurrentProperty(),
  });
  const {
    data: getForecastedData,
    isLoading: forecastIsloading,
    isFetching: forecastIsFetching,
    error,
  } = useGetForecastedDataQuery(
    {
      userId: UserId(),
      hId: CurrentProperty(),
      rangeType: selectedForcastedRange?.value,
    },
    {
      refetchOnMountOrArgChange: true,
      selectFromResult: (result) => ({
        ...result,
        error: result.error, // Ensure we have access to the error field
      }),
    }
  );
  const [nextPricingDate, setNextPricingDate] = useState(
    format(new Date(), "yyyy-MM-dd")
  );
  useEffect(() => {
    const handle401Error = async () => {
      if (error && error.status === 401) {
        await window.localStorage.clear();

        navigate("/login");

        window.location.reload();
      }
    };

    handle401Error();
  }, [error, navigate]);

  const {
    data: quickAction,
    isFetching: quickActionIsFetching,
    isLoading: quickActionIsLoading,
  } = useGetQuickActionQuery({
    userId: UserId(),
    hId: CurrentProperty(),
  });

  const [ShowCMModal, setShowCMModal] = useState(false);
  const isCMVerified = window.localStorage.getItem("isCMVerified");

  useEffect(() => {
    if (isCMVerified) {
      setShowCM_Modal(false);
    }
    if (isCMVerified === false) {
      setShowCM_Modal(true);
    }
  }, [isCMVerified]);

  useEffect(() => {
    if (showCM_Modal) {
      setTimeout(() => {
        setShowCMModal(true);
      }, [8000]);
    }
  }, [showCM_Modal]);

  useEffect(() => {
    if (loginInfo) {
      const cmId = loginInfo.data.propertiesList?.filter((item) => {
        return (
          item?.propertyName === loginInfo.data.currentProperty.propertyName
        );
      });

      const savedCmId = cmId ? cmId[0]?.cmId : "";
      if (savedCmId) {
        setGetCmId(savedCmId);
      }
      window.localStorage.setItem("isCMVerified", loginInfo.data.isCMVerified);
      setShowCM_Modal(loginInfo.data.isCMVerified === true ? false : true);
      window.localStorage.setItem(
        "rateshopperDateRange",
        JSON.stringify(loginInfo?.data?.dataDateRange?.e)
      );

      window.localStorage.setItem(
        "channelManagerDetail",
        JSON.stringify(loginInfo?.data?.channelManagerDetail)
      );

      setPropNamee(loginInfo?.data?.currentProperty?.propertyName);
      window.localStorage.setItem(
        "intelligenceDateRange",
        JSON.stringify(loginInfo?.data?.dataDateRange?.i)
      );
      setPropUser(loginInfo.data.name);
      // console.log('dashboard',loginInfo.data.name)
      window.localStorage.setItem("name", loginInfo?.data?.name);
      window.localStorage.setItem("designation", loginInfo?.data?.designation);
      window.localStorage.setItem(
        "profilePic",
        loginInfo?.data?.profilePicture
      );
      window.localStorage.setItem(
        "activeOta",
        JSON.stringify(loginInfo?.data?.activeOtas)
      );
      window.localStorage.setItem(
        "permissions",
        JSON.stringify(loginInfo?.data?.permissions)
      );
      window.localStorage.setItem(
        "propertiesList",
        JSON.stringify(loginInfo?.data?.propertiesList)
      );
      window.localStorage.setItem(
        "extractionDate",
        JSON.stringify(loginInfo?.data?.lastExtraction)
      );
      // dispatch(setLoginData(loginInfo?.data));
    }
  }, [loginInfo?.data]);
  const { data: getChannelManagerFault } = useGetChannelManagerFaultsQuery(
    {
      cmId: getCmId,
    },
    {
      skip: getCmId ? false : true,
    }
  );
  const [faultMsg, setFaultMsg] = useState();
  const [showFaultAlert, setShowFaultAlert] = useState(false);

  useEffect(() => {
    if (getChannelManagerFault?.data) {
      setFaultMsg(getChannelManagerFault?.data);
      setShowFaultAlert(true);
    }
  }, [getChannelManagerFault]);
  useEffect(() => {
    if (getPerformanceMatrices && getPerformanceMatrices?.data) {
      setOptions([
        { type: "Revenue", typeValue: getPerformanceMatrices?.data?.revenue },
        {
          type: "Occupancy",
          typeValue: getPerformanceMatrices?.data?.occupancy,
        },
        { type: "ADR", typeValue: getPerformanceMatrices?.data?.ADR },
        { type: "LOS", typeValue: getPerformanceMatrices?.data?.los },
        {
          type: "Room Nights",
          typeValue: getPerformanceMatrices?.data?.roomNights,
        },
      ]);
    }
  }, [getPerformanceMatrices && getPerformanceMatrices?.data]);

  const { data: quickReportData } = useGetQuickReportQuery({
    userId: UserId(),
    hId: CurrentProperty(),
  });
  const [reportData, setReportData] = useState(
    quickReportData?.data ? quickReportData?.data : []
  );
  const {
    data: urgentAction,
    isLoading: urgentActionIsLoading,
    isFetching: urgentActionIsFetching,
    refetch: urgentRefetch,
  } = useDashboardUrgentActionQuery({
    userId: UserId(),
    hId: CurrentProperty(),
    startDate: format(new Date(nextPricingDate), "yyyy-MM-dd"),
    type: isToggled ? "dynamic" : "suggestion",
  });
  const userName = propUser ? propUser : window.localStorage.getItem("name");
  const [quickActionModal, setQuickActionModal] = useState(false);
  const [pushRateModal, setPushRateModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());

  const [showIncomplete, setShowIncomplete] = useState(true);
  const [showComplete, setShowComplete] = useState(false);
  const [hotelPerformanceIsOpen, setHotelPerformanceIsOpen] = useState(false);
  const quickActionStorage = window.localStorage
    .getItem("quickAction")
    ?.toString();

  useEffect(() => {
    if (quickActionStorage === "false") {
      setQuickActionModal(false);
    } else {
      setTimeout(() => {
        setQuickActionModal(true);
        window.localStorage.setItem("quickAction", false);
      }, [5500]);
    }
  }, []);
  useEffect(() => {
    setReportData(quickReportData?.data ? quickReportData?.data : []);
  }, [quickReportData?.data]);

  const {
    data: SelectedWidgets,
    refetch: refetchWidget,
    isLoading: widgetIsLoading,
  } = useGetWidgetsQuery({
    userId: UserId(),
    hId: CurrentProperty(),
  });

  useEffect(() => {
    if (
      // getPerformanceMatricesIsFetching ||
      // getPerformanceMatricesIsLoading ||
      sentimentalAnalysisIsLoading ||
      sentimentalAnalysisIsFetching ||
      forecastIsloading ||
      forecastIsFetching ||
      widgetIsLoading
      // ||
      // urgentActionIsLoading ||
      // urgentActionIsFetching
    ) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [
    // getPerformanceMatricesIsFetching,
    // getPerformanceMatricesIsLoading,
    sentimentalAnalysisIsLoading,
    sentimentalAnalysisIsFetching,
    forecastIsloading,
    forecastIsFetching,
    widgetIsLoading,
    // urgentActionIsLoading,
    // urgentActionIsFetching,
  ]);
  const isCompleteTask =
    quickAction &&
    quickAction?.data.filter((task) => {
      return task.taskStatus === true;
    });
  const inCompleteTask =
    quickAction &&
    quickAction?.data.filter((task) => {
      return task.taskStatus === false;
    });
  const isIpad = useIsIpad();
  const propertyName = PropertyName();

  const handleSuccess = (response) => {
    console.log("Payment Successful:", response);
    // Handle successful payment here (e.g., update the backend, show a success message)
  };

  const handleError = (error) => {
    console.error("Payment Error:", error);
    // Handle error in payment here (e.g., show an error message)
  };
  const [hpIsRefreshing, sethpIsRefreshing] = useState(false);

  console.log(isLoading, "State Is Loading...");

  return (
    <div className={`p-5  flex flex-col gap-4`}>
      {/* <div className="-mt-5">
        {faultMsg && showFaultAlert && (
          <Alert
            heading={faultMsg?.faultIssue}
            description={faultMsg?.faultDescription}
          />
        )}
      </div> */}

      {ShowCMModal && (
        <ChannelManagerPasswordModal hideModal={() => setShowCMModal(false)} />
      )}

      {/* <RazorpayPayment
        amount={500} // Amount in INR
        currency="INR"
        description="Test Transaction"
        onSuccess={handleSuccess}
        onError={handleError}
      /> */}

      {addWidget && (
        <WidgetModal
          refetchWidget={refetchWidget}
          onClick={() => setAddWidget(false)}
          SelectedWidgets={SelectedWidgets}
          widgetIsLoading={widgetIsLoading}
        />
      )}
      {quickActionModal && (
        <Backdrop>
          <div
            className="w-[80%] mx-auto  h-[80%] rounded-lg relative p-5"
            style={{
              background: "linear-gradient(45deg, #ffffffc4, #ffffff9c)",
            }}
          >
            <div>
              <div className="text-lg font-sans">Quick actions</div>
              <div
                onClick={() => setQuickActionModal(false)}
                className="absolute right-2 top-4 bg-red-50 text-red-600 text-sm py-1 px-2 rounded-lg hover:bg-red-500 hover:text-white cursor-pointer"
              >
                Close
              </div>
              <div className="mt-8">
                <div
                  className="flex justify-between items-center cursor-pointer"
                  onClick={() => setShowIncomplete(!showIncomplete)}
                >
                  <div className="text-md font-medium mb-4">
                    Incomplete ({inCompleteTask?.length})
                  </div>
                  <div
                    className={`text-lg font-medium mb-4  transition-all ease-in-out duration-150 ${showIncomplete ? "rotate-180" : ""}`}
                  >
                    <AiFillCaretDown />
                  </div>
                </div>
                <div className="overflow-y-scroll scrollHide max-h-[200px]">
                  {showIncomplete &&
                    Array.isArray(inCompleteTask) &&
                    inCompleteTask.map((task) => {
                      return (
                        <Notification
                          title={task?.taskName}
                          description={task?.taskDescription}
                          status={task?.taskPriority}
                          data={inCompleteTask && inCompleteTask}
                          veiwAll={() => setQuickActionModal(true)}
                          path={task?.taskLocation}
                        />
                      );
                    })}
                </div>
              </div>
              <div className="mt-8">
                <div
                  className="flex justify-between items-center cursor-pointer"
                  onClick={() => setShowComplete(!showComplete)}
                >
                  <div className="text-md font-medium mb-4">
                    Completed ({isCompleteTask?.length})
                  </div>
                  <div
                    className={`text-lg font-medium mb-4 transition-all ease-in-out duration-150 ${showComplete ? "rotate-180" : ""}`}
                  >
                    <AiFillCaretDown />
                  </div>
                </div>
                <div className="overflow-y-scroll scrollHide max-h-[200px]">
                  {showComplete &&
                    Array.isArray(isCompleteTask) &&
                    isCompleteTask.map((task) => {
                      return (
                        <Notification
                          title={task?.taskName}
                          description={task?.taskDescription}
                          path={task?.taskLocation}
                          showFixNow={false}
                          isCompleted={true}
                        />
                      );
                    })}
                </div>
              </div>
            </div>
          </div>
        </Backdrop>
      )}
      {pushRateModal && (
        <Backdrop>
          <div
            className="w-[80%] mx-auto  h-auto rounded-lg relative p-5"
            style={{
              background: "linear-gradient(45deg, #ffffffc4, #ffffff9c)",
            }}
          >
            <PushRateModal
              selectedDate={selectedDate}
              setPushRateModal={setPushRateModal}
              pushRateModal={pushRateModal}
              toastAction={(res, val) => {
                if (res) {
                  toast.success("Rates Push Request Successfully", {
                    position: "bottom-right",
                  });
                } else {
                  toast.error(val, {
                    position: "bottom-right",
                  });
                }
              }}
            />
          </div>
        </Backdrop>
      )}
      {/* <BackdropLoader loading={isLoading} /> */}
      {propUser && (
        <div className="md:flex  md:items-center md:flex-row sm:flex-col -mt-4 sm:flex sm:justify-centre">
          <div className="lg:w-[70%] sm:w-[100%]">
            <TitleBarWithButton
              title={`Hi ${propUser ? propUser?.split(" ")[0] : userName?.split(" ")[0]}, Welcome back to ${propNamee ? propNamee : propertyName}!`}
              subHeading={"Streamlined Decision Making with RateX"}
              buttonTitle={"Export"}
              onClick={() => null}
            />
          </div>
          <div className="lg:w-[30%] sm:w-full flex  items-center lg:justify-end">
            <div
              className="text-sm text-[#ff5a81] -mt-1 gap-2 flex hover:bg-red-100 duration-150 ease-in-out transition-all w-fit border border-[#ff5a81] bg-[#202439] py-2 px-2 rounded-md relative cursor-pointer"
              onClick={scrollToTarget}
            >
              <div>
                <img src={dangerIcon} />
              </div>
              <div className="">Urgent Action Needed</div>
              <div className="w-8 h-8 -left-4 -top-4 rounded-full bg-[#E62E2E] text-white flex justify-center items-center absolute">
                {actionCount}
              </div>
            </div>
          </div>
        </div>
      )}
      {/* <div className="w-[100%] flex justify-end">
        <div
          className="bg-[#0062ff] p-2  cursor-pointer rounded-lg w-fit"
          onClick={() => setHotelPerformanceIsOpen(!hotelPerformanceIsOpen)}
        >
          <AiOutlineArrowsAlt color="white" size={18} />
        </div>
      </div> */}

      <div className="w-[100%] bg-newGradient  dark:bg-lightGradient  backdrop-blur-lg drop-shadow-lg shadow-lg rounded-lg">
        <div className="flex justify-between items-center p-4">
          <div className="text-lg dark:text-white text-white font-semibold">
            Hotel Performance
          </div>
          <div
            className="bg-[#0062ff] p-2  mb-2 text-white cursor-pointer text-sm rounded-lg w-fit"
            onClick={() => navigate("/hotel_performance")}
          >
            Know more
          </div>
        </div>
        <div className="w-[100%] flex justify-between items-center">
          <HotelPerformanceTile
            setHotelPerformanceIsOpen={setHotelPerformanceIsOpen}
            Open
            isOpen={hotelPerformanceIsOpen}
            setIsRefreshing={sethpIsRefreshing}
          />
        </div>
      </div>

      {!urgentActionIsFetching || !urgentActionIsLoading ? (
        <div className="flex gap-4 bg-newGradient dark:bg-lightGradient backdrop-blur-lg drop-shadow-lg shadow-lg rounded-lg items-start">
          <div className="w-[70%]">
            <Urgentactions
              data={urgentAction?.data}
              refetch={urgentRefetch}
              date={nextPricingDate}
              pushRateModal={pushRateModal}
              setPushRateModal={setPushRateModal}
              isToggled={isToggled}
              setIsToggle={setIsToggle}
            />
          </div>

          <div className="w-[30%]">
            <Next7DayPricing
              setSelectedDate={setNextPricingDate}
              selectedDate={nextPricingDate}
              data={urgentAction?.data}
            />
          </div>
        </div>
      ) : (
        <div className="w-[100%]">
          <CustomSkeleton height={400} />
        </div>
      )}

      {/* <div className="flex flex-col md:flex-row gap-4">
        <div
          className={`${isIpad ? "w-[69%]" : "w-[70%] overflow-x-hidden  "} `}
        >
          <div
            className={`w-[100%]  ${isIpad ? "h-[150px]" : "h-[210px]"} rounded-md overflow-hidden`}
          >
            {isLoading ? (
              <CustomSkeleton height={isIpad ? 150 : 210} />
            ) : (
              <CarouselComp data={getAds?.data} />
            )}
          </div>
        </div>
        <div className={`${isIpad ? "w-[30%]" : "w-[30%] "} `}>
          {isLoading ? (
            <CustomSkeleton height={isIpad ? 150 : 210} />
          ) : (
            <QuickAction
              height={isIpad ? " auto" : 210}
              title={"Quick Action"}
              subHeading={"These actions needs immediate attention"}
              // data={data}
              data={inCompleteTask && inCompleteTask}
              veiwAll={() => setQuickActionModal(true)}
            />
          )}
        </div>
      </div> */}
      <div className="flex gap-4 flex-col md:flex-row">
        <div className={`${isIpad ? "w-[69%]" : "w-[70%]"} `}>
          {getPerformanceMatricesIsFetching ||
            getPerformanceMatricesIsLoading ? (
            <CustomSkeleton height={440} />
          ) : (
            <ChartWithTabs
              data={getPerformanceMatrices && getPerformanceMatrices?.data}
              chartHeight={220}
              isPermission={true}
              options={options}
              selectedItem={selectedItem}
              setSelectedItem={setSelectedItem}
              title={"Performance Key Metrics"}
              subHeading={
                "Metrics to which the hotel perform while on the current date range in comparision to selected period"
              }
              setTimePeriod={setTimePeriod}
              timePeriod={timePeriod}
              downloadButtonData={getPerformanceMatrices?.data}
              isIpad={isIpad}
            />
          )}
        </div>
        <div className={`${isIpad ? "w-[30%]" : "w-[30%]"} `}>
          {!quickReportData ? (
            <CustomSkeleton height={440} />
          ) : (
            <ReportSection
              title={"Quick Report"}
              height={440}
              reportData={reportData}
              setReportData={setReportData}
              isIpad={isIpad}
            />
          )}
        </div>
      </div>
      <div className="w-[100%] flex gap-4 flex-col md:flex-row">
        {/* <div className={`${isIpad ? "w-[70%]" : "w-[70%]"} `}>
          {isLoading ? (
            <CustomSkeleton height={700} />
          ) : (
            <RateSuggestions
              isPermission={true}
              title={"7 Days Pricing"}
              compCol={columns}
              compData={NextSevenDays?.data}
              isTransparent={true}
              tableBgColor={""}
            />
          )}
        </div>
        <div className={`${isIpad ? "w-[30%]" : "w-[30%]"} `}>
          {isLoading ? (
            <CustomSkeleton height={400} />
          ) : (
            <ForecastedComp
              data={getForecastedData && getForecastedData?.data}
              selectedForcastedRange={selectedForcastedRange}
              setSelectedForeCastedRange={setSelectedForeCastedRange}
              isIpad={isIpad}
            />
          )}
        </div> */}
      </div>
      {SelectedWidgets?.data?.length == 3 && (
        <div className="flex w-full justify-end">
          <span
            onClick={() => setAddWidget(true)}
            className="text-blue-500 cursor-pointer text-[14px]"
          >
            Edit Widget{" "}
          </span>
          {/* <AddWidgetCard height={410} onClick={() => setAddWidget(true)} /> */}
        </div>
      )}
      <div className="w-[100%] flex flex-col md:flex-row gap-4">
        {Array.isArray(SelectedWidgets?.data) &&
          SelectedWidgets?.data?.map((widget, index) => {
            const renderWidget =
              widget?.widgetName === "Channel Performance" ? (
                <div className="md:w-[35%] w-full">
                  {" "}
                  <Channel />{" "}
                </div>
              ) : widget?.widgetName === "Cancellation" ? (
                <div className="md:w-[35%] w-full">
                  {" "}
                  <CancellationMonth />
                </div>
              ) : widget?.widgetName === "Sentiment Analysis" ? (
                <div className="md:w-[35%] w-full">
                  {" "}
                  <SimpleCloud
                    data={
                      getSentimentalAnalysis &&
                      transformApiData(getSentimentalAnalysis?.data)
                    }
                    options={colorOptions}
                    height={410}
                  />{" "}
                </div>
              ) : widget?.widgetName === "Reputation" ? (
                <div className="md:w-[35%] w-full">
                  <Ratings rating={rating} />
                </div>
              ) : widget?.widgetName === "Upcoming Event" ? (
                <div className="md:w-[35%] w-full">
                  <UpcomingEvent />
                </div>
              ) : null; // Add a default value if none of the conditions match

            return renderWidget;
          })}

        {!(SelectedWidgets?.data?.length === 3) && (
          <div className="w-[35%]">
            <AddWidgetCard height={410} onClick={() => setAddWidget(true)} />
          </div>
        )}
      </div>
      <div className="w-[100%]" ref={targetRef} id="targetDiv">
        <ActionComponent setActionCount={setActionCount} />
      </div>
      {/* <div className="flex gap-4">
        <div className="w-[300px] bg-white rounded-lg">
          <img src={channelImg} />
        </div>
        <div className="w-[300px] bg-white rounded-lg">
          <img src={eventsImg} />
        </div>
        <div className="w-[300px] bg-white rounded-lg">
          <img src={cancellationImg} />
        </div>
        <div className="w-[300px] bg-white rounded-lg">
          <img src={sentimental} />
        </div>
        <div className="w-[300px] bg-white rounded-lg">
          <img src={reputationImg} />
        </div>
      </div>

      <Channel />
      <UpcomingEvent />
      <CancellationMonth /> */}
    </div>
  );
};

export default NewDashboard;

export const TitleBarWithButton = ({
  title,
  subHeading,
  buttonTitle,
  showCancel,
  onClick,
}) => {
  const isIpad = useIsIpad();
  const [isTypingComplete, setTypingComplete] = useState(false);

  useEffect(() => {
    const typingDuration = 3500; // Duration of the typing animation in milliseconds
    const timer = setTimeout(() => {
      setTypingComplete(true);
    }, typingDuration);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="">
      <div className="flex items-center justify-between">
        <div className="">
          <div
            className={` text-[#ffffff] dark:text-black ${isIpad ? "text-[15px] " : "text-[22px]"} typewriter ${isTypingComplete ? "no-caret" : ""}`}
          >
            {title}
          </div>
          <div className="text-[#ffffff]  dark:text-black text-sm">
            {subHeading}
          </div>
        </div>
        {/* <div>
          <div
            className="bg-[#3E5c76] w-fit px-4 py-2 text-white rounded-lg cursor-pointer"
            onClick={onClick}
          >
            {buttonTitle}
          </div>
        </div> */}
      </div>
    </div>
  );
};
const QuickAction = ({ height, title, subHeading, data, onClick, veiwAll }) => {
  const navigate = useNavigate();
  const isIpad = useIsIpad();
  return (
    <div
      className={` w-[100%]  border  overflow-hidden ${isIpad ? " h-[150px] " : "h-full"}  border-[#FF0000] rounded-lg p-4`}
      // style={{ height: `${height}px` }}
      style={{ background: "linear-gradient(279deg, #0d1a3a, #254b72)" }}
      onClick={onClick}
    >
      <div className="flex justify-between items-center">
        <div>
          <div className="text-[#ECECEC] font-medium flex items-center gap-2">
            <AiFillInfoCircle />
            {title}
          </div>
        </div>
        <div
          className="text-[#ECECEC] font-medium text-xs cursor-pointer"
          onClick={veiwAll}
        >
          View More
        </div>
      </div>
      <div
        className={`mx-4  ${isIpad ? " p-2 pb-8  h-full overflow-y-scroll " : ""}`}
      >
        {Array.isArray(data) &&
          data?.length > 0 &&
          data?.slice(0, 4)?.map((action) => {
            return (
              <div
                className="flex justify-between cursor-pointer items-center py-2 border-b border-b-[#444379]"
                onClick={() =>
                  navigate(`/${action?.taskLocation?.path}`, {
                    state: { address: action?.taskLocation },
                  })
                }
              >
                <div className="flex items-center gap-2">
                  <div>
                    <img src={action?.actionIcon} />
                    <AiOutlineWarning color="red" />
                  </div>
                  <div className="text-[#D9D9D9] font-light text-[12px]">
                    {action?.taskName}
                  </div>
                </div>
                <div
                  className={` text-${action?.taskPriority === "High" ? "red" : action?.taskPriority === "Medium" ? "orange" : action?.taskPriority === "Low" ? "yellow" : "green"}-500 text-sm`}
                >
                  {action?.taskPriority}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};
const ChartWithTabs = ({
  setTimePeriod,
  timePeriod,
  options,
  selectedItem,
  setSelectedItem,
  title,
  subHeading,
  chartHeight,
  data,
  isIpad,
}) => {
  const convertDate = (dateArray) => {
    return dateArray?.map((date) => {
      return format(new Date(date), "dd-MMM-yy");
    });
  };

  return (
    <div
      className={`bg-newGradient dark:bg-lightGradient p-4 rounded-lg backdrop-blur-lg drop-shadow-lg shadow-lg w-[100%] overflow-hidden dark:text-white dark:bg-[#060d2e]`}
    >
      {/* <TimeRange /> */}

      <div className="flex items-center justify-between">
        <div className="text-white font-bold">{title}</div>
        <div className="flex gap-4 items-center">
          <div className="flex text-sm bg-[#f3f3f300] text-[#8794AD]">
            <div
              className={`${timePeriod === "past30Days" ? "bg-[#F0F0F0] text-[#131926] " : "text-white bg-[#F0F0F020]"} text-xs md:text-sm p-2 rounded-l-lg  border-[#F0F0F0] cursor-pointer`}
              onClick={() => setTimePeriod("past30Days")}
            >
              Past 30 days
            </div>
            <div
              className={`${timePeriod === "next30Days" ? "bg-[#F0F0F0] text-[#131926] " : "text-white bg-[#F0F0F020]"} text-xs md:text-sm p-2 rounded-r-lg  border-[#F0F0F0] cursor-pointer`}
              onClick={() => setTimePeriod("next30Days")}
            >
              Next 30 days
            </div>
          </div>
          <div>
            <InfoToolTip
              content={
                "These metrics provide valuable insights into various aspects of a hotel's performance."
              }
              position={"left"}
              index={"23"}
            />
          </div>
        </div>
      </div>
      <div className="text-[#e2e3e6] text-sm dark:text-white">{subHeading}</div>

      {/* Selectable Tabs */}

      <div className="flex gap-4 mx-10 mt-8 w-[100%] scroll-container">
        {Array?.isArray(options) &&
          options?.map((option) => {
            return (
              <div
                className={`${selectedItem === option.type ? "text-[#e9ffcd] border-t-2 border-t-[#e9ffcd]" : "text-[#ffffff]"} text-sm cursor-pointer`}
                onClick={() => setSelectedItem(option.type)}
              >
                <div
                  className={` pt-2  px-2 w-[120px] text-center ${selectedItem === option.type ? "text-[#e9ffcd]" : "text-[#ffffff]"} cursor-pointer`}
                >
                  {option?.type}
                </div>
                <div
                  className={`${selectedItem === option.type ? " text-[#e9ffcd]" : "text-[#ffffff]"} text-center text-[18px] mt-1`}
                >
                  {option?.type === "Revenue" || option?.type === "ADR"
                    ? formatCurrency(option?.typeValue)
                    : option?.type === "Occupancy"
                      ? `${option?.typeValue === undefined || option?.typeValue === "NaN" ? "--" : `${option?.typeValue}%`}`
                      : !option?.typeValue
                        ? "--"
                        : option?.typeValue}
                </div>
              </div>
            );
          })}
        <div>
          {/* <ExcelDownloadButton data={""} filename={"Performance Key Metrics"}/> */}
        </div>
      </div>
      <div className="w-[100%]">
        <AreaChart
          height={chartHeight}
          xaxisShow={true}
          yaxisShow={true}
          showSingleSeries={true}
          currentSeriesData={data?.value}
          currentSeriesName={convertDate(data?.date)}
          currentLabel={selectedItem}
          isCurrency={
            selectedItem === "Revenue" || selectedItem === "ADR" ? true : false
          }
          showToolTip={false}
          isPercentage={selectedItem === "Occupancy" && true}
          isFormat={true}
          labelDivideValue={3}
          textWhite={true}
        />
      </div>
    </div>
  );
};
export const ReportSection = ({
  title,
  height,
  reportData,
  setReportData,
  isIpad,
}) => {

  const location = useLocation();

  const getQueryParams = (param) => {
    return new URLSearchParams(location.search).get(param);
  };

  const [hotelProductivityWhatsApp, setHotelProductivityWhatsApp] =
    useState(false);

  const [skipHotelProductivityReport, setSkipHotelProductivityReport] =
    useState(false);

  // Send to WhatsApp
  const [parityWhatsApp, setParityWhatsApp] = useState(false);
  const [parityWhatsAppAdmin, setParityWhatsAppAdmin] = useState(false);
  const intelligenceDateRange = useIntelligenceDateRange();
  const ratePulseDateRange = useRatePulseDateRange();

  // const [pickUpWhatsApp, setPickUpWhatsApp] = useState(false);
  const [pickUpWhatsAppAdmin, setPickUpWhatsAppAdmin] = useState(false);

  const [quaterlyWhatsApp, setQuaterlyWhatsApp] = useState(false);
  const [QuaterlyWhatsAppAdmin, setQuaterlyWhatsAppAdmin] = useState(false);

  const [revenueWhatsApp, setRevenueWhatsApp] = useState(false);
  const [revenueWhatsAppAdmin, setRevenueWhatsAppAdmin] = useState(false);
  const [monthEndWhatsApp, setMonthEndWhatsApp] = useState(false);
  const [monthEndWhatsAppAdmin, setMonthEndWhatsAppAdmin] = useState(false);
  const [yearEndWhatsApp, setYearEndWhatsApp] = useState(false);
  const [yearEndWhatsAppAdmin, setYearEndWhatsAppAdmin] = useState(false);

  const [sourceWhatsApp, setSourceWhatsApp] = useState(false);
  const [sourceWhatsAppAdmin, setSourceWhatsAppAdmin] = useState(false);
  const [paceWhatsApp, setPaceWhatsApp] = useState(false);
  const [paceWhatsAppAdmin, setPaceWhatsAppAdmin] = useState(false);
  const [pickUpWhatsApp, setPickUpWhatsApp] = useState(false);
  const [ratesWhatsApp, setRatesWhatsApp] = useState(false);
  const [ratesWhatsAppAdmin, setRatesWhatsAppAdmin] = useState(false);
  const [rateChangeWhatsApp, setRateChangeWhatsApp] = useState(false);
  const [revenueDeckWhatsApp, setRevenueDeckWhatsApp] = useState(false);

  const [dynamicRateChangeWhatsApp, setDynamicRateChangeWhatsApp] =
    useState(false);

  const [dynamicRateChangeWhatsAppAdmin, setDynamicRateChangeWhatsAppAdmin] =
    useState(false);
  const [segmentWhatsApp, setSegmentWhatsApp] = useState(false);
  // other states
  const [viewQuickReport, setViewQuickReport] = useState(false);
  const [renderComponent, setRenderComponent] = useState("");
  const [quaterlyDate, setQuaterlyDate] = useState(new Date());

  const [monthEndDateRange, setMonthEndDateRange] = useState([
    formatDate(
      new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      "dd-MM-yyyy"
    ),
    formatDate(
      new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0),
      "dd-MM-yyyy"
    ),
  ]);

  const [rateChangeDateRange, setRateChangeDateRange] = useState(new Date());
  const [MetricSourceSelector, setMetricSourceSelectorr] = useState();
  const [paceSourceSelector, setPaceSourceSelector] = useState();
  const newDate = new Date();
  const [parityDateRange, setParityDateRange] = useState([
    {
      startDate: newDate,
      endDate: new Date(
        newDate.getFullYear(),
        newDate.getMonth(),
        newDate.getDate() + 10
      ), // Setting endDate to 10 days ago from today
      id: "range 1",
    },
  ]);

  const [pickUpDateRange, setPickUpDateRange] = useState([
    {
      startDate: newDate,
      endDate: new Date(
        newDate.getFullYear(),
        newDate.getMonth(),
        newDate.getDate() + 10
      ), // Setting endDate to 10 days ago from today
      id: "range 1",
    },
  ]);

  const [ratesDateRange, setRatesDateRange] = useState([
    {
      startDate: new Date(
        newDate.getFullYear(),
        newDate.getMonth() - 1,
        newDate.getDate() - 10
      ),
      endDate: new Date(
        newDate.getFullYear(),
        newDate.getMonth() - 1,
        newDate.getDate() + 10
      ),
      id: "range 1",
    },
  ]);

  const [selectedInventryDateRange, setSelectedInventryDateRange] = useState(
    new Date()
  );
  const [cancellationDateRange, setCancellationDateRange] = useState([
    {
      startDate: newDate,
      endDate: new Date(
        newDate.getFullYear(),
        newDate.getMonth(),
        newDate.getDate() + 10
      ), // Setting endDate to 10 days ago from today
      id: "range 1",
    },
  ]);

  function getDate30DaysAfter() {
    const today = new Date();
    const thirtyDaysLater = new Date(today);
    thirtyDaysLater.setDate(today.getDate() + 365);
    return thirtyDaysLater;
  }
  const [dynamicRateChangeDateRange, setDynamicRateChangeDateRange] = useState([
    {
      startDate: new Date(),
      endDate: getDate30DaysAfter(), // Setting endDate to 10 days ago from today
      id: "range 1",
    },
  ]);
  useEffect(() => {
    if (ratePulseDateRange?.fromDate) {
      const startDate = new Date(ratePulseDateRange.toDate);
      const endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 30);
      setRatesDateRange([
        {
          startDate: startDate,
          endDate: endDate,
          id: "range 1",
        },
      ]);
    }
  }, [ratePulseDateRange]);

  // Update ratesDateRange when intelligenceDateRange changes

  useEffect(() => {
    if (ratePulseDateRange?.fromDate) {
      const startDate = new Date(ratePulseDateRange.toDate);
      const endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 30);
      setParityDateRange([
        {
          startDate: startDate,
          endDate: endDate,
          id: "range 1",
        },
      ]);
    }
  }, [ratePulseDateRange]);

  const [quarterlyDateRange, setQuaterlyDateRange] = useState([
    formatDate(
      new Date(newDate.getFullYear(), newDate.getMonth() - 3, 1),
      "dd-MM-yyyy"
    ),
    formatDate(
      new Date(newDate.getFullYear(), newDate.getMonth(), 0),
      "dd-MM-yyyy"
    ),
  ]);
  const [revenueDateRange, setRevenueDateRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(
        newDate.getFullYear(),
        newDate.getMonth() + 1,
        newDate.getDate()
      ),
      id: "range 1",
    },
  ]);
  const [paceDateRange, setPaceDateRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(
        newDate.getFullYear(),
        newDate.getMonth() + 1,
        newDate.getDate()
      ),
      id: "range 1",
    },
  ]);
  const [sourceDateRange, setSourceDateRange] = useState([
    {
      startDate: new Date(
        newDate.getFullYear(),
        newDate.getMonth() - 1,
        newDate.getDate()
      ),
      endDate: newDate,
      id: "range 1",
    },
  ]);
  const [yearDateRange, setYearDateRange] = useState([
    formatDate(new Date(newDate.getFullYear() - 1, 0, 1), "dd-MM-yyyy"),
    formatDate(new Date(newDate.getFullYear() - 1, 11, 31), "dd-MM-yyyy"),
  ]);
  const [segmentDate, setSegmentDate] = useState(newDate);
  const [parityDate, setParityDate] = useState(newDate);
  const [pickUpDate, setPickupDate] = useState(new Date());
  const [paceDate, setPaceDate] = useState(newDate);

  const [skipMonthEnd, setSkipMonthEnd] = useState(true);
  const [skipQuaterly, setSkipQuaterly] = useState(true);
  const [skipParity, setSkipParity] = useState(true);
  const [skipPace, setSkipPace] = useState(true);
  const [skipYearEnd, setSkipYearEnd] = useState(true);
  const [skipSegment, setSkipSegment] = useState(true);
  const [skipRevenue, setSkipRevenue] = useState(true);
  const [skipRates, setSkipRates] = useState(true);
  const [skipPickUp, setSkipPickUp] = useState(true);
  const [skipSource, setSkipSource] = useState(true);
  const [skipInventory, setSkipInventory] = useState(true);
  const [skipRevenueDeck, setSkipRevenueDeck] = useState(true);
  const [skipRateChange, setSkipRateChange] = useState(true);
  const [sourceDate, setSourceDate] = useState(newDate);

  const [downloadMonthEnd, setDownloadMonthEnd] = useState(false);
  const [downloadQuarterly, setDownloadQuarterly] = useState(false);
  const [downloadParity, setDownloadParity] = useState(false);
  const [downloadPace, setDownloadPace] = useState(false);
  const [downloadYearEnd, setDownloadYearEnd] = useState(false);
  const [downloadSegment, setDownloadSegment] = useState(false);
  const [downloadRevenue, setDownloadRevenue] = useState(false);
  const [downloadPickUp, setDownloadPickUp] = useState(false);
  const [downloadSource, setDownloadSource] = useState(false);
  const [downloadRates, setDownloadRates] = useState(false);
  const [donwloadInventory, setDonwloadInventory] = useState(false);

  const [downloadQuaterly, setDownloadQuaterly] = useState();

  const [revenueDate, setRevenueDate] = useState(newDate);

  const [yearEndDate, setYearEndDate] = useState(newDate);

  function formatDate(date) {
    // Get year, month, and day
    let year = date.getFullYear();
    let month = date.getMonth() + 1; // Months are zero-based
    let day = date.getDate();

    // Pad month and day with leading zeros if necessary
    month = month < 10 ? "0" + month : month;
    day = day < 10 ? "0" + day : day;
    // Construct the formatted date string
    return `${year}-${month}-${day}`;
  }

  // const [downloadComponent , setDownloadComponent]=useState('')
  const [addReport, setAddReport] = useState();
  const [error, setError] = useState();
  // const [downloadComponent , setDownloadComponent]=useState('')
  const [postQuickReport] = usePostQuickReportMutation();
  const hId = CurrentProperty();
  const userId = UserId();

  const [metricSourceSelector, setMetricSourceSelector] = useState("");
  const [metricDateRangeSelector, setMetricDateRangeSelector] = useState("day");
  // const [paceSourceSelector, setPaceSourceSelector] = useState("");
  const [paceDateRangeSelector, setPaceDateRangeSelector] = useState("day");
  const [fluctuationDateRangeType, setFluctuationDateRangeType] = useState({
    value: "last7",
    label: "Last 7 Days",
  });

  const [bifercationType, setBifercationType] = useState("none");
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedRevenueDeckDate, setSelectedRevenueDeckDate] = useState(new Date());

  const {
    data: dropDownData,
    isLoading: dropDownIsLoading,
    isFetching: dropDownIsFetching,
    refetch: dorpDownRefetch,
  } = useGetDropDownDataQuery({
    userId: UserId(),
    hId: CurrentProperty(),
  });

  const { data: quickReportData, refetch } = useGetQuickReportQuery({
    userId: UserId(),
    hId: CurrentProperty(),
  });

  const {
    data: revenueData,
    isLoading: revenueLoading,
    isFetching: revenueIsFetching,
    isSuccess: revenueSuccess,
  } = useGetRevenueReportQuery(
    {
      userId: UserId(),
      hId: CurrentProperty(),
      startDate: formatDate(revenueDateRange[0]?.startDate),
      endDate: formatDate(revenueDateRange[0]?.endDate),
      isPrimary: revenueWhatsApp,
      isSecondary: revenueWhatsAppAdmin,
    },
    { skip: skipRevenue, refetchOnMountOrArgChange: true }
  );
  useEffect(() => {
    if (revenueSuccess && (revenueWhatsApp || revenueWhatsAppAdmin)) {
      setRevenueWhatsApp(false);
      setRevenueWhatsAppAdmin(false);
      toast.success("Report send to whatsapp successfull", {
        position: "bottom-right",
      });
    }
  }, [revenueLoading, revenueIsFetching, revenueSuccess]);
  const {
    data: paceData,
    refetch: paceDataRefetch,
    isLoading: paceLoading,
    isFetching: paceFetching,
    isSuccess: paceSuccess,
  } = useGetPaceReportQuery(
    {
      userId: UserId(),
      hId: CurrentProperty(),
      startDate: formatDate(paceDateRange[0]?.startDate),
      endDate: formatDate(paceDateRange[0]?.endDate),
      isPrimary: paceWhatsApp,
      isSecondary: paceWhatsAppAdmin,
    },
    { skip: skipPace, refetchOnMountOrArgChange: true }
  );
  useEffect(() => {
    if (paceSuccess && (paceWhatsApp || paceWhatsAppAdmin)) {
      setPaceWhatsApp(false);
      setPaceWhatsAppAdmin(false);
      toast.success("Report send to whatsapp successfull", {
        position: "bottom-right",
      });
    }
  }, [paceLoading, paceFetching, paceSuccess]);

  const {
    data: monthEndData,
    isLoading: monthLoading,
    isFetching: monthFetching,
    isSuccess: monthSuccess,
  } = useGetMonthEndReportQuery(
    {
      userId: UserId(),
      hId: CurrentProperty(),
      startDate: monthEndDateRange[0],
      endDate: monthEndDateRange[1],
      isPrimary: monthEndWhatsApp,
      isSecondary: monthEndWhatsAppAdmin,
    },
    { skip: skipMonthEnd, refetchOnMountOrArgChange: true }
  );

  useEffect(() => {
    if (monthSuccess && (monthEndWhatsApp || monthEndWhatsAppAdmin)) {
      setMonthEndWhatsApp(false);
      setMonthEndWhatsAppAdmin(false);
      toast.success("Report send to whatsapp successfull", {
        position: "bottom-right",
      });
    }
  }, [monthLoading, monthFetching, monthSuccess]);

  const {
    data: yearEndData,
    isLoading: yearLoading,
    isFetching: yearFetching,
    isSuccess: yearSuccess,
  } = useGetYearEndReportQuery(
    {
      userId: UserId(),
      hId: CurrentProperty(),
      startDate: yearDateRange[0],
      endDate: yearDateRange[1],
      isPrimary: yearEndWhatsApp,
      isSecondary: yearEndWhatsAppAdmin,
    },
    { skip: skipYearEnd, refetchOnMountOrArgChange: true }
  );

  useEffect(() => {
    if (yearSuccess && (yearEndWhatsApp || yearEndWhatsAppAdmin)) {
      setYearEndWhatsApp(false);
      setYearEndWhatsAppAdmin(false);
      toast.success("Report send to whatsapp successfull", {
        position: "bottom-right",
      });
    }
  }, [yearLoading, yearFetching, yearSuccess]);
  const {
    data: quarterlyData,
    isLoading: quarterlyLoading,
    isFetching: quaterlyFetching,
    refetch: quaterlyRefetch,
    isSuccess: quaterlySuccess,
  } = useGetQuarterlyReportQuery(
    {
      userId: UserId(),
      hId: CurrentProperty(),
      startDate: quarterlyDateRange[0],
      endDate: quarterlyDateRange[1],
      isPrimary: quaterlyWhatsApp,
      isSecondary: QuaterlyWhatsAppAdmin,
    },
    { skip: skipQuaterly, refetchOnMountOrArgChange: true }
  );
  useEffect(() => {
    if (quaterlySuccess && (quaterlyWhatsApp || QuaterlyWhatsAppAdmin)) {
      setQuaterlyWhatsAppAdmin(false);
      setQuaterlyWhatsApp(false);
      toast.success("Report send to whatsapp successfull", {
        position: "bottom-right",
      });
    }
  }, [quarterlyLoading, quaterlyFetching, quaterlySuccess]);

  const {
    data: sourceData,
    isLoading: sourceLoading,
    isFetching: sourceFetching,
    isSuccess: sourceSuccess,
  } = useGetSourceReportQuery(
    {
      userId: UserId(),
      hId: CurrentProperty(),
      startDate: formatDate(sourceDateRange[0].startDate),
      endDate: formatDate(sourceDateRange[0].endDate),
      isPrimary: sourceWhatsApp,
      isSecondary: sourceWhatsAppAdmin,
    },
    { skip: skipSource, refetchOnMountOrArgChange: true }
  );
  useEffect(() => {
    if (sourceSuccess && (sourceWhatsApp || sourceWhatsAppAdmin)) {
      setSourceWhatsApp(false);
      setSourceWhatsAppAdmin(false);
      toast.success("Report send to whatsapp successfull", {
        position: "bottom-right",
      });
    }
  }, [sourceLoading, sourceFetching, sourceSuccess]);

  const {
    data: segmentData,
    isFetching: segmentFetching,
    isLoading: segmentLoading,
  } = useGetSegmentReportQuery(
    {
      userId: UserId(),
      hId: CurrentProperty(),
      startDate: formatDate(segmentDate),
      isPrimary: segmentWhatsApp,
    },
    { skip: skipSegment, refetchOnMountOrArgChange: true }
  );
  const {
    data: parityData,
    isFetching: parityFetching,
    isLoading: parityLoading,
    isSuccess: paritySuccess,
  } = useGetParityReportQuery(
    {
      userId: UserId(),
      hId: CurrentProperty(),
      startDate: formatDate(parityDateRange[0].startDate),
      endDate: formatDate(parityDateRange[0].endDate),
      isPrimary: parityWhatsApp,
      isSecondary: parityWhatsAppAdmin,
    },
    { skip: skipParity, refetchOnMountOrArgChange: true }
  );
  useEffect(() => {
    if (paritySuccess && (parityWhatsApp || parityWhatsAppAdmin)) {
      setParityWhatsAppAdmin(false);
      setParityWhatsApp(false);
      toast.success("Report send to whatsapp successfull", {
        position: "bottom-right",
      });
    }
  }, [parityLoading, parityFetching, paritySuccess]);

  const {
    data: pickUpData,
    isFetching: pickupFetching,
    isLoading: pickupLoading,
  } = useGetPickUpReportQuery(
    {
      userId: UserId(),
      hId: CurrentProperty(),
      startDate: formatDate(pickUpDate),
      // endDate: formatDate(pickUpDateRange[0].endDate),
      isPrimary: pickUpWhatsApp,
      isSecondary: setPickUpWhatsAppAdmin,
    },
    { skip: skipPickUp, refetchOnMountOrArgChange: true }
  );

  const {
    data: ratesData,
    isFetching: ratesFetching,
    isLoading: ratesLoading,
    isSuccess: ratesSuccess,
  } = useGetRatesReportQuery(
    {
      userId: UserId(),
      hId: CurrentProperty(),
      startDate: formatDate(ratesDateRange[0].startDate),
      endDate: formatDate(ratesDateRange[0].endDate),
      isPrimary: ratesWhatsApp,
      isSecondary: ratesWhatsAppAdmin,
    },
    { skip: skipRates, refetchOnMountOrArgChange: true }
  );

  const {
    data: getInventory,
    isFetching: inventoryFetching,
    isLoading: inventoryLoading,
  } = useGetInventoryQuery(
    {
      userId: UserId(),
      hId: CurrentProperty(),
      asPer: format(selectedInventryDateRange, "yyy-MM-dd"),
      asOn: format(new Date(), "yyy-MM-dd"),
      // otaId: selectOta?.join(", "),
      // mealPlanId: selectMealPlan?.join(", "),
      // otaId: selectOta && selectOta?.value,
    },
    {
      refetchOnMountOrArgChange: true,
      skip: skipInventory,
    }
  );
  const {
    data: cancelllationData,
    isFetching: cancellationIsFetching,
    isLoading: cancellationIsLoading,
    isSuccess: cancellationSuccess,
  } = useGetRateChangeReportQuery({
    userId: UserId(),
    hId: CurrentProperty(),
    startDate: format(
      new Date(cancellationDateRange[0]?.startDate),
      "yyyy-MM-dd"
    ),
    endDate: format(new Date(cancellationDateRange[0]?.endDate), "yyyy-MM-dd"),
    isPrimary: rateChangeWhatsApp,
  });

  const {
    data: revenueDeckReport,
    isFetching: revenueDeckReportIsFetching,
    isLoading: revenueDeckReportIsLoading,
    isSuccess: revenueDeckReportSuccess,
  } = useGetRevenueDeckReportQuery({
    userId: UserId(),
    hId: CurrentProperty(),
    startDate: format(selectedRevenueDeckDate, "yyy-MM-dd"),
    isPrimary: revenueDeckWhatsApp,
  },
    {
      refetchOnMountOrArgChange: true,
      skip: skipRevenueDeck,
    });

  const {
    data: dynamicRateChangeData,
    isLoading: dynamicRateChangeLoading,
    isFetching: dynamicRateChangeFetching,
    isSuccess: dynamicRateChangeSuccess,
  } = useDynamicRateChangeReportQuery({
    userId: UserId(),
    hId: CurrentProperty(),
    startDate: formatDate(dynamicRateChangeDateRange[0].startDate),
    endDate: formatDate(dynamicRateChangeDateRange[0].endDate),
    isPrimary: dynamicRateChangeWhatsApp,
    isSecondary: dynamicRateChangeWhatsAppAdmin,
  });

  const {
    data: useArcrIdMetricsData,
    isFetching: useArcrIdMetricsFetching,
    isLoading: useArcrIdMetricsLoading,
  } = useArcrIdMetricsDataQuery(
    {
      userId: UserId(),
      hId: CurrentProperty(),
      date: format(selectedDate, "yyy-MM-dd"),
      bifercationType: bifercationType,
      dateRangeType: metricDateRangeSelector,
      source: metricSourceSelector,
      // asPer: format(selectedInventryDateRange, "yyy-MM-dd"),
      // asOn: format(new Date(), "yyy-MM-dd"),
      // whatsAppNotify: inventoryWhatsApp,
      // admin: inventoryWhatsAppAdmin,
      // otaId: selectOta?.join(", "),
      // mealPlanId: selectMealPlan?.join(", "),
      // otaId: selectOta && selectOta?.value,
    },
    {
      // refetchOnMountOrArgChange: true,
      // skip: skipArcrIdMetricsChange,
    }
  );
  const {
    data: useArcrIdPaceData,
    isFetching: useArcrIdPaceFetching,
    isLoading: useArcrIdPaceLoading,
  } = useArcrIdPaceDataQuery(
    {
      userId: UserId(),
      hId: CurrentProperty(),
      date: format(selectedDate, "yyy-MM-dd"),
      bifercationType: bifercationType,
      dateRangeType: paceDateRangeSelector,
      source: paceSourceSelector,
      // asPer: format(selectedInventryDateRange, "yyy-MM-dd"),
      // asOn: format(new Date(), "yyy-MM-dd"),
      // whatsAppNotify: inventoryWhatsApp,
      // admin: inventoryWhatsAppAdmin,
      // otaId: selectOta?.join(", "),
      // mealPlanId: selectMealPlan?.join(", "),
      // otaId: selectOta && selectOta?.value,
    },
    {
      // refetchOnMountOrArgChange: true,
      // skip: skipArcrIdPaceChange,
    }
  );
  const {
    data: useArcrEdRateData,
    isFetching: useArcrEdRateFetching,
    isLoading: useArcrEdRateLoading,
  } = useArcrEdRateDataQuery(
    {
      userId: UserId(),
      hId: CurrentProperty(),
      date: format(selectedDate, "yyy-MM-dd"),
      bifercationType: bifercationType,
      // asPer: format(selectedInventryDateRange, "yyy-MM-dd"),
      // asOn: format(new Date(), "yyy-MM-dd"),
      // whatsAppNotify: inventoryWhatsApp,
      // admin: inventoryWhatsAppAdmin,
      // otaId: selectOta?.join(", "),
      // mealPlanId: selectMealPlan?.join(", "),
      // otaId: selectOta && selectOta?.value,
    },
    {
      // refetchOnMountOrArgChange: true,
      // skip: skipArcrEdRateChange,
    }
  );
  const [paramsStartDate, setParamsStartDate] = useState(
    getQueryParams("startDate") || null
  );
  const [paramsEndDate, setParamsEndDate] = useState(
    getQueryParams("endDate") || null
  );

  const [hotelProductivityReportAdmin, setHotelProductivityReportAdmin] =
    useState(false);
  const [hotelProductivityDateRange, setHotelProductivityDateRange] = useState([
    paramsStartDate
      ? formatDate(new Date(paramsStartDate))
      : formatDate(new Date(newDate.getFullYear(), 0, 1), "dd-MM-yyyy"),
    paramsEndDate
      ? formatDate(new Date(paramsEndDate))
      : formatDate(new Date(newDate.getFullYear(), 11, 31), "dd-MM-yyyy"),
  ]);
  const {
    data: hotelProductivityReportData,
    isLoading: hotelProductivityReportLoading,
    isFetching: hotelProductivityReportFetching,
    isSuccess: hotelProductivityReportSuccess,
  } = useHotelProductivityReportQuery(
    {
      userId: UserId(),
      hId: CurrentProperty(),
      startDate: hotelProductivityDateRange[0],
      endDate: hotelProductivityDateRange[1],
      isPrimary: hotelProductivityWhatsApp,
      isSecondary: hotelProductivityReportAdmin,
    },
    { refetchOnMountOrArgChange: true, skip: skipHotelProductivityReport }
  );
  console.log(hotelProductivityReportData);
  const {
    data: useArcrEdRateFluctuationData,
    isFetching: useArcrEdRateFluctuationFetching,
    isLoading: useArcrEdRateFluctuationLoading,
  } = useArcrEdRateFluctuationDataQuery(
    {
      userId: UserId(),
      hId: CurrentProperty(),
      date: format(selectedDate, "yyy-MM-dd"),
      bifercationType: bifercationType,
      dateRangeType: fluctuationDateRangeType.value,
      // asPer: format(selectedInventryDateRange, "yyy-MM-dd"),
      // asOn: format(new Date(), "yyy-MM-dd"),
      // whatsAppNotify: inventoryWhatsApp,
      // admin: inventoryWhatsAppAdmin,
      // otaId: selectOta?.join(", "),
      // mealPlanId: selectMealPlan?.join(", "),
      // otaId: selectOta && selectOta?.value,
    },
    {
      // refetchOnMountOrArgChange: true,
      // skip: skipArcrEdRateFluctuationChange,
    }
  );
  const {
    data: useArcrEdReputationRankReviewData,
    isFetching: useArcrEdReputationRankReviewFetching,
    isLoading: useArcrEdReputationRankReviewLoading,
  } = useArcrEdReputationRankReviewDataQuery(
    {
      userId: UserId(),
      hId: CurrentProperty(),
      date: format(selectedDate, "yyy-MM-dd"),
      bifercationType: bifercationType,
      // asPer: format(selectedInventryDateRange, "yyy-MM-dd"),
      // asOn: format(new Date(), "yyy-MM-dd"),
      // whatsAppNotify: inventoryWhatsApp,
      // admin: inventoryWhatsAppAdmin,
      // otaId: selectOta?.join(", "),
      // mealPlanId: selectMealPlan?.join(", "),
      // otaId: selectOta && selectOta?.value,
    },
    {
      // refetchOnMountOrArgChange: true,
      // skip: skipArcrEdReputationRankReviewChange,
    }
  );

  useEffect(() => {
    if (ratesSuccess && (ratesWhatsApp || ratesWhatsAppAdmin)) {
      setRatesWhatsAppAdmin(false);
      setRatesWhatsApp(false);
      toast.success("Report send to whatsapp successfull", {
        position: "bottom-right",
      });
    }
  }, [ratesLoading, ratesFetching, ratesSuccess]);
  useEffect(() => {
    if (cancellationSuccess && (rateChangeWhatsApp || ratesWhatsAppAdmin)) {
      //   setRateChangeWhatsApp(false);
      setRateChangeWhatsApp(false);
      toast.success("Report send to whatsapp successfull", {
        position: "bottom-right",
      });
    }
  }, [cancellationIsLoading, cancellationIsFetching, cancellationSuccess]);
  const [downloadClick, setDownloadClick] = useState(true);
  const [isLoading, setIsLoading] = useState(
    (yearLoading ||
      monthLoading ||
      parityLoading ||
      paceLoading ||
      sourceLoading ||
      ratesLoading ||
      revenueLoading ||
      quarterlyLoading ||
      inventoryLoading) &&
    downloadClick
  );
  const handleClose = () => {
    setAddReport(false);
    // dorpDownRefetch();
    // setReportData(quickReportData?.data);
    // setOpt(optionss);
  };

  useEffect(() => {
    const downloadReport = async () => {
      if (
        quarterlyData?.data &&
        !quaterlyFetching &&
        !quarterlyLoading &&
        downloadQuaterly
      ) {
        await DownloadQuaterlyReport(quarterlyData?.data);
        setDownloadQuaterly(false);
      }
    };

    downloadReport();
  }, [quarterlyData, quarterlyLoading, quaterlyFetching]);

  useEffect(() => {
    const downloadReport = async () => {
      if (paceData && !paceFetching && !paceLoading && downloadPace) {
        await DownloadPaceReport(paceData);
        setDownloadPace(false);
      }
    };

    downloadReport();
  }, [paceData, paceLoading, paceFetching]);

  useEffect(() => {
    const downloadReport = async () => {
      if (
        monthEndData?.data &&
        !monthFetching &&
        !monthLoading &&
        downloadMonthEnd
      ) {
        await DownloadMonthEndReport(monthEndData?.data);
        setDownloadMonthEnd(false);
      }
    };

    downloadReport();
  }, [monthEndData?.data, monthLoading, monthFetching]);
  useEffect(() => {
    setIsLoading(
      (yearLoading ||
        monthLoading ||
        parityLoading ||
        paceLoading ||
        sourceLoading ||
        ratesLoading ||
        quarterlyLoading ||
        revenueLoading ||
        pickupLoading ||
        inventoryLoading) &&
      downloadClick
    );
  }, [
    yearLoading ||
    monthLoading ||
    parityLoading ||
    paceLoading ||
    revenueLoading ||
    sourceLoading ||
    ratesLoading ||
    quarterlyLoading ||
    pickupLoading,
    inventoryLoading,
    quarterlyLoading,
  ]);
  useEffect(() => {
    const downloadReport = async () => {
      if (
        revenueData?.revenueReport &&
        !revenueIsFetching &&
        !revenueLoading &&
        downloadRevenue
      ) {
        await DownloadRevenueReport(revenueData?.revenueReport);
        setDownloadRevenue(false);
      }
    };

    downloadReport();
  }, [revenueData?.revenueReport, revenueIsFetching, revenueLoading]);
  useEffect(() => {
    const downloadPickUpReport = async () => {
      if (
        pickUpData?.data &&
        !pickupLoading &&
        !pickupFetching &&
        downloadPickUp
      ) {
        await downloadPickUPReport(pickUpData?.data);
        setDownloadPickUp(false);
      }
    };

    downloadPickUpReport();
  }, [pickUpData?.data, pickupFetching, pickupLoading]);
  console.log(sourceDateRange, "sourceDa");
  useEffect(() => {
    const downloadSourceReport = async () => {
      if (
        sourceData?.data &&
        !sourceLoading &&
        !sourceFetching &&
        downloadSource
      ) {
        await DownloadSourceReport(sourceData?.data, sourceDateRange);
        setDownloadSource(false);
      }
    };

    downloadSourceReport();
  }, [sourceData?.data, sourceLoading, sourceFetching]);
  useEffect(() => {
    const downloadReport = async () => {
      if (
        segmentData?.data &&
        !segmentFetching &&
        !segmentLoading &&
        downloadSegment
      ) {
        DownloadSegmentReport(segmentData?.data);
        setDownloadSegment(false);
      }
    };

    downloadReport();
  }, [segmentData?.data, segmentFetching, segmentLoading]);
  useEffect(() => {
    const downloadReport = async () => {
      if (
        parityData?.data &&
        !parityFetching &&
        !parityLoading &&
        downloadParity
      ) {
        DownloadParityReport(parityData?.data, parityData?.asOn);
        setDownloadParity(false);
      }
    };

    downloadReport();
  }, [parityData?.data, parityFetching, parityLoading]);
  useEffect(() => {
    const downloadReport = async () => {
      if (
        yearEndData?.data &&
        !yearFetching &&
        !yearLoading &&
        downloadYearEnd
      ) {
        YearEndReportdownload(yearEndData?.data);
        setDownloadYearEnd(false);
      }
    };

    downloadReport();
  }, [yearEndData?.data, yearFetching, yearLoading]);
  useEffect(() => {
    const downloadReport = async () => {
      if (
        getInventory?.data &&
        !inventoryFetching &&
        !inventoryLoading &&
        donwloadInventory
      ) {
        DownloadOccupencyReport(getInventory, selectedInventryDateRange);
        setDonwloadInventory(false);
      }
    };

    downloadReport();
  }, [getInventory?.data, inventoryFetching, inventoryLoading]);
  const handleDownload = async (downloadComponent) => {
    setDownloadClick(true);
    if (downloadComponent === "Pace Report") {
      setSkipPace(false);
      setDownloadPace(true);
      paceData && DownloadPaceReport(paceData);
    } else if (downloadComponent === "Month End Report") {
      setSkipMonthEnd(false);
      setDownloadMonthEnd(true);
      monthEndData?.data && DownloadMonthEndReport(monthEndData?.data);
    } else if (downloadComponent === "Revenue Report") {
      setSkipRevenue(false);
      setDownloadRevenue(true);
      revenueData?.revenueReport &&
        DownloadRevenueReport(revenueData?.revenueReport);
    } else if (downloadComponent === "Source Report") {
      setSkipSource(false);
      setDownloadSource(true);
      sourceData?.data &&
        DownloadSourceReport(sourceData?.data, sourceDateRange);
    } else if (downloadComponent === "Segment Report") {
      setSkipSegment(false);
      setDownloadSegment(true);
      segmentData?.data && DownloadSegmentReport(segmentData?.data);
    } else if (downloadComponent === "Quarterly Report") {
      setSkipQuaterly(false);
      setDownloadQuaterly(true);
      quarterlyData?.data && DownloadQuaterlyReport(quarterlyData?.data);
    } else if (downloadComponent === "Parity Report") {
      setSkipParity(false);
      setDownloadParity(true);
      parityData?.data &&
        DownloadParityReport(parityData?.data, parityData?.asOn);
    } else if (downloadComponent === "Year End Report") {
      setSkipYearEnd(false);
      setDownloadYearEnd(true);
      yearEndData?.data && YearEndReportdownload(yearEndData?.data);
    } else if (downloadComponent === "Rates Report") {
      setSkipRates(false);
      setDownloadRates(true);
      ratesData?.data &&
        ratesReportDownload(
          ratesData?.data,
          ratesData?.data[0].hotelName,
          ratesDateRange[0].startDate,
          ratesDateRange[0].endDate
        );
    } else if (downloadComponent === "Pick Up Report") {
      setSkipPickUp(false);
      setDownloadPickUp(true);
      pickUpData?.data && downloadPickUPReport(pickUpData?.data);
    } else if (downloadComponent === "Occupancy Report") {
      setSkipInventory(false);
      setDonwloadInventory(true);
      getInventory?.data && DownloadOccupencyReport(getInventory);
    } else if (downloadComponent === "Cancellation report") {
      setSkipInventory(false);
      setDonwloadInventory(true);
      cancelllationData?.rateChangeReport &&
        DownloadCancellationReport(
          cancelllationData?.rateChangeReport?.cancellationData
        );
    } else if (downloadComponent === "Hotel Revenue Deck") {
      setSkipRevenueDeck(false);
      setDonwloadInventory(true);
      cancelllationData?.rateChangeReport &&
        DownloadCancellationReport(
          cancelllationData?.rateChangeReport?.cancellationData
        );
    }
  };

  var optionss = dropDownData?.data.map((item, index) => ({
    value: item.reportName,
    label: item.reportName,
    reportId: item.reportId,
    reportName: item.reportName,
    preDefined: item.predefined,
  }));
  const filteredArray = useMemo(() => {
    return optionss?.filter(
      (option) =>
        !reportData?.some((report) => report?.reportId === option?.reportId)
    );
  }, [optionss, reportData]);

  const [intiailRender, setInitialRender] = useState(true);

  useEffect(() => {
    if (filteredArray && intiailRender) {
      setOpt(filteredArray);
      setInitialRender(false);
    }
  }, [filteredArray]);
  const [opt, setOpt] = useState([]);

  // if (filteredArray && opt && optionss) {
  //   setOpt(filteredArray)
  // }
  //  useEffect(()=>{

  //      setOpt(filteredArray)
  //    },[filteredArray])
  const handleDropDown = (e) => {
    if (reportData?.length < 7) {
      setOpt(opt.filter((option) => option.reportId !== e.reportId));
      setReportData([
        ...reportData,
        {
          reportId: e.reportId,
          preDefined: e.preDefined,
          reportName: e.reportName,
        },
      ]);
      setError("");
    } else {
      setError("Maximum Report Limit Reached");
    }
  };

  const handlePostQuickReport = () => {
    postQuickReport({
      hId: hId,
      userId: userId,
      reports: reportData,
    })
      .unwrap()
      .then((res) => {
        toast.success(res.message, { position: "bottom-right" });
        setAddReport(false);

        refetch();
      })
      .catch((err) => {
        toast.error(err.message, { position: "bottom-right" });
      });
  };

  const handleDelete = (e) => {
    setReportData(
      reportData.filter((option) => option.reportId !== e.reportId)
    );

    setOpt([
      ...opt,
      {
        reportId: e.reportId,
        preDefined: e.preDefined,
        value: e.reportName,
        label: e.reportName,
        reportName: e.reportName,
      },
    ]);
  };
  const handleIntitalAPICall = (ApiCall) => {
    setDownloadClick(false);
    if (ApiCall === "Pace Report") {
      setSkipPace(false);
    } else if (ApiCall === "Month End Report") {
      setSkipMonthEnd(false);
    } else if (ApiCall === "Revenue Report") {
      setSkipRevenue(false);
    } else if (ApiCall === "Source Report") {
      setSkipSource(false);
    } else if (ApiCall === "Segment Report") {
      setSkipSegment(false);
    } else if (ApiCall === "Quarterly Report") {
      setSkipQuaterly(false);
    } else if (ApiCall === "Parity Report") {
      setSkipParity(false);
    } else if (ApiCall === "Year End Report") {
      setSkipYearEnd(false);
    } else if (ApiCall === "Rates Report") {
      setSkipRates(false);
    } else if (ApiCall === "Pick Up Report") {
      setSkipPickUp(false);
    } else if (ApiCall === "Occupancy Report") {
      setSkipInventory(false);
    } else if (ApiCall === "Rate Change Report") {
      setSkipRateChange(false)
    } else if (ApiCall === "Hotel Revenue Deck") {
      setSkipRevenueDeck(false)
    }
  };

  return (
    <div>
      {viewQuickReport && (
        <Backdrop>
          <div className="w-[80%] mx-auto mt-5 bg-black dark:bg-white h-[80%] rounded-lg relative p-4 pb-0">
            <div
              onClick={() => setViewQuickReport(false)}
              className="absolute z-30 flex items-center gap-2  px-2 rounded-lg bg-red-50 text-red-400 hover:bg-red-400 hover:text-red-50 right-3 top-3 cursor-pointer transition-all ease-in-out duration-100"
            >
              close
            </div>
            <div
              className={`scrollHide  overflow-y-scroll ${renderComponent == "Rates Report" || renderComponent == "Parity Report" ? "h-[550px]" : "h-auto"}   max-h-full`}
            >
              {renderComponent == "Rate Change Report" && (
                <RateChangeReport
                  metricData={useArcrIdMetricsData}
                  isMetricDataLoading={
                    useArcrIdMetricsLoading || useArcrIdMetricsLoading
                  }
                  metricSourceSelector={metricSourceSelector}
                  metricDateRangeSelector={metricDateRangeSelector}
                  setMetricSourceSelector={setMetricSourceSelector}
                  setMetricDateRangeSelector={setMetricDateRangeSelector}
                  paceSourceSelector={paceSourceSelector}
                  setPaceSourceSelector={setPaceSourceSelector}
                  paceDateRangeSelector={paceDateRangeSelector}
                  setPaceDateRangeSelector={setPaceDateRangeSelector}
                  fluctuationDateRangeType={fluctuationDateRangeType}
                  setFluctuationDateRangeType={setFluctuationDateRangeType}
                  paceData={useArcrIdPaceData}
                  isPaceDataLoading={
                    useArcrIdPaceFetching || useArcrIdPaceLoading
                  }
                  rateData={useArcrEdRateData}
                  isRateDataLoading={
                    useArcrEdRateLoading || useArcrEdRateFetching
                  }
                  fluctuationData={useArcrEdRateFluctuationData}
                  isFluctuationDataLoading={
                    useArcrEdRateFluctuationFetching ||
                    useArcrEdRateFluctuationLoading
                  }
                  reputationData={useArcrEdReputationRankReviewData}
                  isReputationDataLoading={
                    useArcrEdReputationRankReviewLoading ||
                    useArcrEdReputationRankReviewFetching
                  }
                  setDateRange={setSelectedDate}
                  dateRange={selectedDate}
                  bifercationType={bifercationType}
                  setBifercationType={setBifercationType}
                />
              )}
              {renderComponent == "Month End Report" && (
                <MonthEndTable
                  data={monthEndData?.data}
                  isLoading={monthFetching || monthLoading}
                  dateRange={monthEndDateRange}
                  setDateRange={setMonthEndDateRange}
                  setIsWhatsApp={() => {
                    setMonthEndWhatsApp(true);
                    // setMonthEndWhatsApp(false);
                  }}
                  sendToWhatsappAdmin={() => {
                    setMonthEndWhatsAppAdmin(true);
                  }}
                  monthEndWhatsAppAdmin={monthEndWhatsAppAdmin}
                />
              )}
              {renderComponent == "Pace Report" && (
                <PaceReport
                  data={paceData}
                  setDateRange={setPaceDateRange}
                  dateRange={paceDateRange}
                  isLoading={paceLoading || paceFetching}
                  setIsWhatsApp={() => {
                    setPaceWhatsApp(true);
                    // setPaceWhatsApp(false);
                  }}
                  sendToWhatsappAdmin={() => {
                    setPaceWhatsAppAdmin(true);
                  }}
                  paceWhatsAppAdmin={paceWhatsAppAdmin}
                />
              )}
              {renderComponent == "Revenue Report" && (
                <RevenueReportTable
                  dateRange={revenueDateRange}
                  setDateRange={setRevenueDateRange}
                  data={revenueData?.revenueReport}
                  isLoading={revenueIsFetching || revenueLoading}
                  setIsWhatsApp={() => {
                    setRevenueWhatsApp(true);
                    // setRevenueWhatsApp(false);
                  }}
                  sendToWhatsappAdmin={() => {
                    setRevenueWhatsAppAdmin(true);
                  }}
                />
              )}
              {renderComponent == "Source Report" && (
                <SourceReport
                  setDateRange={setSourceDateRange}
                  dateRange={sourceDateRange}
                  data={sourceData?.data}
                  isLoading={sourceLoading || sourceFetching}
                  setIsWhatsApp={() => {
                    setSourceWhatsApp(true);
                    // setSourceWhatsApp(false);
                  }}
                  sendToWhatsappAdmin={() => {
                    setSourceWhatsAppAdmin(true);
                  }}
                />
              )}
              {renderComponent == "Segment Report" && (
                <SegmentReport
                  setSelected2Date={setSegmentDate}
                  selected2Date={segmentDate}
                  data={segmentData?.data}
                  setIsWhatsApp={() => {
                    setSegmentWhatsApp(true);
                    // setSegmentWhatsApp(false);
                  }}
                />
              )}
              {renderComponent == "Quarterly Report" && (
                <QuarterlyReport
                  isLoading={quarterlyLoading || quaterlyFetching}
                  dateRange={quarterlyDateRange}
                  setDateRange={setQuaterlyDateRange}
                  data={quarterlyData?.data}
                  setIsWhatsApp={() => {
                    setQuaterlyWhatsApp(true);
                    // setQuaterlyWhatsApp(false);
                  }}
                  sendToWhatsappAdmin={() => {
                    setQuaterlyWhatsAppAdmin(true);
                  }}
                  QuaterlyWhatsAppAdmin={QuaterlyWhatsAppAdmin}
                />
              )}
              {renderComponent == "Parity Report" && (
                <ParityReport
                  setDateRange={setParityDateRange}
                  dateRange={parityDateRange}
                  data={parityData?.data}
                  isLoading={parityLoading || parityFetching}
                  setIsWhatsApp={() => {
                    setParityWhatsApp(true);
                    // setParityWhatsApp(false);
                  }}
                  sendToWhatsappAdmin={() => {
                    setParityWhatsAppAdmin(true);
                  }}
                  parityWhatsAppAdmin={parityWhatsAppAdmin}
                />
              )}
              {renderComponent == "Pick Up Report" && (
                <PickUpReport

                  setSelected2Date={setPickupDate}
                  selected2Date={pickUpDate}
                  data={pickUpData?.data}
                  setDateRange={setPickUpDateRange}
                  dateRange={pickUpDateRange}
                  isLoading={pickupLoading || pickupFetching}
                  setIsWhatsApp={() => {
                    setPickUpWhatsApp(true);
                    // setParityWhatsApp(false);
                  }}
                  sendToWhatsappAdmin={() => {
                    setPickUpWhatsAppAdmin(true);
                  }}
                  pickUpWhatsApp={pickUpWhatsApp}
                />
              )}
              {renderComponent == "Year End Report" && (
                <YearEndReport
                  setDateRange={setYearDateRange}
                  dateRange={yearDateRange}
                  data={yearEndData?.data}
                  isLoading={yearLoading || yearFetching}
                  setIsWhatsApp={() => {
                    setYearEndWhatsApp(true);
                    // setYearEndWhatsApp(false);
                  }}
                  sendToWhatsappAdmin={() => {
                    setYearEndWhatsAppAdmin(true);
                  }}
                  yearEndWhatsAppAdmin={yearEndWhatsAppAdmin}
                />
              )}
              {renderComponent == "Rates Report" && (
                <RatesReport
                  setDateRange={setRatesDateRange}
                  dateRange={ratesDateRange}
                  data={ratesData?.data}
                  isLoading={ratesLoading || ratesFetching}
                  setIsWhatsApp={() => {
                    setRatesWhatsApp(true);
                    // setParityWhatsApp(false);
                  }}
                  sendToWhatsappAdmin={() => {
                    setRatesWhatsAppAdmin(true);
                  }}
                  parityWhatsAppAdmin={ratesWhatsAppAdmin}
                />
              )}
              {renderComponent == "Occupancy Report" && (
                <OccupencyReport
                  getInventory={getInventory}
                  isLoading={inventoryLoading || inventoryFetching}
                  selectedDate={selectedInventryDateRange}
                  setSelectedDate={setSelectedInventryDateRange}
                />
              )}
              {renderComponent == "Cancellation report" && (
                <CancellationReport
                  data={cancelllationData}
                  isLoading={cancellationIsFetching || cancellationIsLoading}
                  setDateRange={setCancellationDateRange}
                  dateRange={cancellationDateRange}
                  setIsWhatsApp={() => {
                    setRateChangeWhatsApp(true);
                    // setParityWhatsApp(false);
                  }}
                />
              )}
              {renderComponent == "Dynamic Rate Change Report" && (
                <DynamicRateChangeReport
                  data={dynamicRateChangeData?.data}
                  isLoading={
                    dynamicRateChangeFetching || dynamicRateChangeLoading
                  }
                  dateRange={dynamicRateChangeDateRange}
                  setDateRange={setDynamicRateChangeDateRange}
                  setIsWhatsApp={() => {
                    setDynamicRateChangeWhatsApp(true);
                    // setMonthEndWhatsApp(false);
                  }}
                  sendToWhatsappAdmin={() => {
                    setDynamicRateChangeWhatsAppAdmin(true);
                  }}
                  handleDownload={() => {
                    DownloadDynamicRateChangeReport(dynamicRateChangeData);
                  }}
                />
              )}
              {renderComponent === "Hotel Revenue Deck" && (
                <RevenueDeckReport
                  data={revenueDeckReport}
                  isLoading={
                    revenueDeckReportIsFetching || revenueDeckReportIsLoading
                  }
                  dateRange={selectedRevenueDeckDate}
                  setDateRange={setSelectedRevenueDeckDate}
                  setIsWhatsApp={() => {
                    setRateChangeWhatsApp(true);
                    // setMonthEndWhatsApp(false);
                  }}
                  handleDownload={() => {
                    DownloadRevenueDeckReportExcel(revenueDeckReport?.excelData, revenueDeckReport?.hotelName, revenueDeckReport?.dayStart);
                  }}
                />
              )}
              {/* {renderComponent == "Rate Change Report" && (
                <RateChangeReport
                  metricData={useArcrIdMetricsData}
                  isMetricDataLoading={
                    useArcrIdMetricsLoading || useArcrIdMetricsLoading
                  }
                  metricSourceSelector={metricSourceSelector}
                  metricDateRangeSelector={metricDateRangeSelector}
                  setMetricSourceSelector={setMetricSourceSelector}
                  setMetricDateRangeSelector={setMetricDateRangeSelector}
                  paceSourceSelector={paceSourceSelector}
                  setPaceSourceSelector={setPaceSourceSelector}
                  paceDateRangeSelector={paceDateRangeSelector}
                  setPaceDateRangeSelector={setPaceDateRangeSelector}
                  fluctuationDateRangeType={fluctuationDateRangeType}
                  setFluctuationDateRangeType={setFluctuationDateRangeType}
                  paceData={useArcrIdPaceData}
                  isPaceDataLoading={
                    useArcrIdPaceFetching || useArcrIdPaceLoading
                  }
                  rateData={useArcrEdRateData}
                  isRateDataLoading={
                    useArcrEdRateLoading || useArcrEdRateFetching
                  }
                  fluctuationData={useArcrEdRateFluctuationData}
                  isFluctuationDataLoading={
                    useArcrEdRateFluctuationFetching ||
                    useArcrEdRateFluctuationLoading
                  }
                  reputationData={useArcrEdReputationRankReviewData}
                  isReputationDataLoading={
                    useArcrEdReputationRankReviewLoading ||
                    useArcrEdReputationRankReviewFetching
                  }
                  setDateRange={setSelectedDate}
                  dateRange={selectedDate}
                  bifercationType={bifercationType}
                  setBifercationType={setBifercationType}
                />
              )} */}
              {renderComponent === "Hotel Productivity Report" && (
                <HotelProductivityReportTable
                  setDateRange={setHotelProductivityDateRange}
                  dateRange={hotelProductivityDateRange}
                  data={hotelProductivityReportData?.data?.tableData}
                  isLoading={
                    hotelProductivityReportLoading ||
                    hotelProductivityReportFetching
                  }
                  setIsWhatsApp={() => {
                    setHotelProductivityWhatsApp(true);
                    // setYearEndWhatsApp(false);
                  }}
                  sendToWhatsappAdmin={() => {
                    setHotelProductivityReportAdmin(true);
                  }}
                  handleDownload={handleDownload}
                />
              )}
            </div>
            {/* <div>Add</div> */}
          </div>
        </Backdrop>
      )}
      <BackdropLoader loading={isLoading} />
      {addReport && (
        <Backdrop>
          <div
            className={`flex flex-col ${isIpad ? "w-[100%]" : "w-[80%]"}  mx-auto mt-5 bg-white  h-[80%] rounded-lg relative  p-4 pb-0`}
          >
            <div>
              <div>Add Report</div>
              <div>
                <div
                  onClick={handleClose}
                  className="absolute flex items-center gap-2  px-2 rounded-lg bg-red-50 text-red-400 hover:bg-red-400 hover:text-red-50 right-3 top-3 cursor-pointer transition-all ease-in-out duration-100"
                >
                  Close
                </div>
                <div
                  onClick={handlePostQuickReport}
                  className="absolute  right-[15px] outline outline-blue-600 bottom-[16px] bg-[#f9f9f9] text-blue-600 text-sm py-2 px-4 w-32 text-center rounded-md hover:bg-blue-500 hover:text-white cursor-pointer"
                >
                  Save
                </div>
              </div>
            </div>

            <div className="mt-9 ">
              <div className="max-h-auto min-h-auto overflow-y-auto ">
                {Array?.isArray(reportData) &&
                  reportData.map((report) => {
                    return (
                      <div className="p-2 mt-2 flex justify-between rounded-md border border-[#e1e0e089] bg-[#f3f3f388]">
                        <div className="text-sm">{report?.reportName}</div>
                        <div className="flex gap-4 items-center cursor-pointer">
                          <div
                            onClick={() => {
                              handleDelete(report);
                            }}
                          >
                            <AiFillCloseCircle color="red" size={16} />
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>

              <div>
                <div className=" text-xs text-red-600">{error}</div>
                <div className=" mt-2 flex justify-between rounded-md border border-[#e1e0e089] bg-[#f3f3f388]">
                  <Select
                    className="w-[100%]"
                    onChange={handleDropDown}
                    options={opt}
                  />
                </div>
              </div>
            </div>
          </div>
        </Backdrop>
      )}
      <div
        className={`w-[100%] bg-newGradient dark:bg-lightGradient backdrop-blur-lg drop-shadow-lg shadow-lg rounded-lg p-4 relative`}
        style={{ height: `${height}px` }}
      >
        <div className="flex items-center justify-between">
          <div className="text-white font-bold">{title}</div>
          <div>
            <InfoToolTip
              content={
                "The Quick Report serves as a valuable tool for promptly evaluating the operational and financial health of the hotel."
              }
              position={"left"}
              index={"quickRep"}
            />
          </div>
        </div>
        <div className=" h-[340px] scroll-container">
          {Array?.isArray(quickReportData?.data) &&
            quickReportData?.data?.map((report) => {
              return (
                report?.reportName && (
                  <div
                    className="p-2 mt-2 flex justify-between rounded-md "
                    style={{
                      background:
                        "linear-gradient(45deg, #1a386b, transparent)",
                    }}
                  >
                    <div className="text-sm text-white">
                      {report?.reportName}
                    </div>
                    <div className="flex gap-4 items-center cursor-pointer">
                      <div
                        id={report.reportName}
                        onClick={() => {
                          setViewQuickReport(true);
                          setRenderComponent(report?.reportName);
                        }}
                      >
                        <img
                          src={eyeOpen}
                          onClick={() =>
                            handleIntitalAPICall(report?.reportName)
                          }
                        />
                      </div>
                      <div
                        onClick={() => {
                          handleDownload(report.reportName);
                        }}
                      >
                        <img src={downloadBtn} />
                      </div>
                    </div>
                  </div>
                )
              );
            })}
        </div>
        <div
          onClick={() => setAddReport(true)}
          className="p-2 left-[14px] cursor-pointer hover:bg-[#1D2D44] hover:text-white duration-150 transition-all ease-in-out  bottom-4 absolute w-[92%] flex items-center gap-2 justify-center text-[#081439] rounded-md text-sm  border-[#081439] bg-white "
        >
          <AiOutlinePlus /> Add Report
        </div>
      </div>
    </div>
  );
};
export const ForecastedComp = ({
  selectedForcastedRange,
  setSelectedForeCastedRange,
  data,
  isIpad,
}) => {
  const dayFilter = [
    { label: "7 Days", value: "7D" },
    { label: "15 Days", value: "15D" },
    { label: "30 Days", value: "30D" },
    { label: "45 Days", value: "45D" },
    { label: "60 Days", value: "60D" },
  ];
  const revenueOriginalLabel = data && data?.revenue?.originalChartData?.date;
  const revenueOriginalData = data && data?.revenue?.originalChartData?.value;
  const forecastedRevenueLabel =
    data &&
    Array.isArray(data?.revenue?.forecastedChartData) &&
    data?.revenue?.forecastedChartData.map((item) => {
      return format(new Date(item?.date), "dd-MM-yyyy");
    });
  const forecastedRevenueData =
    data &&
    Array.isArray(data?.revenue?.forecastedChartData) &&
    data?.revenue?.forecastedChartData.map((item) => {
      return item?.revenue;
    });
  const roomNightsOriginalLabel =
    data &&
    data?.roomNights?.originalChartData?.date?.map((item, index) => {
      return format(new Date(item), "dd-MM-yyyy");
    });
  const roomNightsOriginalData =
    data && data?.roomNights?.originalChartData?.value;

  const forecastedRoomNightsLabel =
    data &&
    Array.isArray(data?.roomNights?.forecastedChartData) &&
    data?.roomNights?.forecastedChartData.map((item) => {
      return item?.date;
    });
  const forecastedRoomNightsData =
    data &&
    Array.isArray(data?.roomNights?.forecastedChartData) &&
    data?.roomNights?.forecastedChartData.map((item) => {
      return item?.roomNights;
    });

  return (
    <div className="bg-white p-4 min-h-[400px] max-h-max rounded-lg">
      <div className="flex flex-col justify-between items-center">
        <div className="w-[100%] whitespace-nowrap flex items-center gap-2">
          <div>
            Forecast{" "}
            {isIpad ? (
              <div className="text-[12px] text-gray-500">
                as per{" "}
                {data &&
                  data?.asPer &&
                  format(new Date(data?.asPer), "dd MMM yyyy")}
              </div>
            ) : (
              <span className="text-[12px] text-gray-500">
                as per{" "}
                {data &&
                  data?.asPer &&
                  format(new Date(data?.asPer), "dd MMM yyyy")}
              </span>
            )}
          </div>

          <div
            className={`flex gap-2 justify-end items-center w-[100%] ${isIpad && "-ml-[48px]"}`}
          >
            <div className="flex items-center gap-4">
              <Dropdown
                options={dayFilter}
                selectedItem={selectedForcastedRange?.label}
                setSelectedItems={setSelectedForeCastedRange}
                right={"2px"}
              />
              <div>
                <InfoToolTip
                  content={
                    "This forecast provides a comprehensive projection of revenue and room nights for the specified period."
                  }
                  position={"left"}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="text-[#59647bce] font-light w-[100%] text-sm mt-2">
          Here is your property's forecasted data.{" "}
        </div>
        <div
          className={`flex ${isIpad && "flex-col"} justify-between items-center -mt-2 ${!isIpad && "px-3"}  w-[100%]`}
        >
          <div className="w-[100%]">
            <div className={`${isIpad && "mt-[30px]"} flex gap-2 items-center`}>
              <div className="text-xl text-[#4b4c4d]">Revenue</div>
              <div
                className={` ${data?.revenue?.forecasted > data?.revenue?.original ? "text-[#29CC39] bg-[#ECFDF5] " : "bg-[#FEF2F2] text-[#E62E2E]"} py-0 px-2 rounded-md`}
              >
                {calculatePercentage(
                  data?.revenue?.original,
                  data?.revenue?.forecasted
                ).toFixed(2)}
                %
              </div>
            </div>
            <div
              className={`${data?.revenue?.forecasted > data?.revenue?.original ? "text-[#29CC39]" : "text-[#E62E2E]"} text-xl mt-2`}
            >
              {formatCurrency(data?.revenue?.forecasted)}
            </div>
          </div>
          <div className="w-[100%]">
            <AreaChart
              pastSeriesData={revenueOriginalData}
              currentSeriesData={forecastedRevenueData}
              currentSeriesName={revenueOriginalLabel}
              currentLabel={"Forecasted Revenue"}
              perviousLabel={"Original Revenue"}
              isCurrency={true}
            />
          </div>
        </div>
        <div className="text-[#59647B] w-[100%] -mt-4 text-[12px] border-b pb-4 px-3">
          Hover over the chart to see a comparison of our forecasted revenue for
          the current year and the actual revenue from the previous year.
        </div>
        <div
          className={`flex -mt-4 ${isIpad && "flex-col"}  justify-between items-center w-[100%] ${!isIpad && "px-3"}`}
        >
          <div className="w-[100%]">
            <div className={`flex gap-2 ${isIpad && "mt-[30px]"} items-center`}>
              <div className="text-xl text-[#4b4c4d]">Room Nights </div>
              <div
                className={` ${data?.roomNights?.forecasted > data?.roomNights?.original ? "text-[#29CC39] bg-[#ECFDF5] " : "bg-[#FEF2F2] text-[#E62E2E]"} py-0 px-2 rounded-md`}
              >
                {calculatePercentage(
                  data?.roomNights?.original,
                  data?.roomNights?.forecasted
                ).toFixed(2)}
                %
              </div>
            </div>
            <div
              className={`${data?.roomNights?.forecasted > data?.roomNights?.original ? "text-[#29CC39]" : "text-[#E62E2E]"} text-xl mt-2`}
            >
              {data?.roomNights?.forecasted || 0}
            </div>
          </div>
          <div className="w-[100%]">
            <AreaChart
              currentLabel={"Forecasted Room Night"}
              perviousLabel={"Original Room Night"}
              currentSeriesData={forecastedRoomNightsData}
              currentSeriesName={
                forecastedRoomNightsLabel?.length >
                  roomNightsOriginalLabel?.length
                  ? forecastedRoomNightsLabel
                  : roomNightsOriginalLabel
              }
              pastSeriesData={roomNightsOriginalData}
            />
          </div>
        </div>
        <div className="text-[#59647B] w-[100%] text-[12px]  pb-4 -mt-1 px-3">
          Hover over the chart to see a comparison of our forecasted room nights
          for the current year and the actual room nights from the previous
          year.
        </div>
      </div>
    </div>
  );
};
const SimpleCloud = ({ data, options, height }) => {
  const navigate = useNavigate();
  console.log(data);
  return (
    <div className="bg-newGradient dark:bg-lightGradient backdrop-blur-lg drop-shadow-lg shadow-lg rounded-lg p-4 h-[436px] flex flex-col justify-between">
      <div>
        <div className="flex justify-between text-white items-center">
          <div>Sentiment Analysis</div>
          <InfoToolTip
            content={
              "This feature provides insights into guest sentiment by analyzing reviews and feedback from various sources."
            }
            index={"sentiments"}
          />
        </div>
        <div className="text-[#ffffff] text-sm mt-2">
          Discover the most positive and negative tags for your property.
        </div>
        <div className="mt-6 text-wrap">
          {Array.isArray(data) && (
            <TagCloud
              minSize={12}
              maxSize={20}
              tags={data?.slice(0, 80)}
              // onClick={(tag) => alert(`'${tag.value}' was selected!`)}
              colorOptions={options}
              randomSeed={42}
              shuffle={true}
              renderer={(tag, size, color) => {
                const tagColor =
                  tag.sentiment === "positive" ? "aquamarine" : "lightCoral";

                return (
                  <span
                    key={tag.value.trim()} // Remove whitespace in case of empty value
                    style={{
                      fontSize: `${size}px`,
                      margin: "3px",
                      padding: "3px",
                      display: "inline-block",
                      color: tagColor,
                      cursor: "pointer",
                    }}
                    title={tag.value}
                  >
                    {tag.value.trim() || "Unknown"}{" "}
                    {/* Handle empty string case */}
                  </span>
                );
              }}
            />
          )}
        </div>
      </div>
      <div
        onClick={() => {
          navigate("/rate-pulse/reputation");
        }}
        className="w-full text-center text-white py-1 rounded-lg -mb-2 cursor-pointer"
      >
        View All
      </div>
    </div>
  );
};
export const Ratings = ({ rating, asPer }) => {
  const otaOptions = ActiveOtaOptions();
  const navigate = useNavigate();
  const [selectOta, setSelectOta] = useState();
  const { data } = useGetRatingsQuery({
    hId: CurrentProperty(),
    userId: UserId(),
    otaId: selectOta?.value === "All" ? "" : selectOta?.value,
  });
  const ratingData = data?.data[0];
  useEffect(() => {
    if (otaOptions[0]) {
      setSelectOta(otaOptions[0]);
    }
  }, [otaOptions]);
  const isIpad = useIsIpad();
  return (
    <div className="bg-newGradient dark:bg-lightGradient backdrop-blur-lg drop-shadow-lg shadow-lg p-4 rounded-lg h-[436px]">
      <div className="">
        <div className="w-[100%] text-white flex justify-between items-center">
          <div className="font-bold text-white">Reputation</div>
          <div className="flex  items-center  gap-4">
            {!isIpad && <div className="text-sm">Select OTA</div>}
            <div>
              <Dropdown
                options={otaOptions}
                selectedItem={
                  selectOta?.label ? selectOta?.label : "Select OTA"
                }
                setSelectedItems={setSelectOta}
                customWidth={"120px"}
              />
            </div>
            <div>
              <InfoToolTip
                content={
                  "This metric provides an overview of the property's average reputation score as rated by guests across various Online Travel Agencies (OTAs)."
                }
                index={"Reputations"}
                position={"left"}
              />
            </div>
          </div>
        </div>
        <div className="text-[#ffffff] text-sm mt-2">
          {selectOta?.label === "All"
            ? `Your property's average reputation on different OTA`
            : `Your property's reputation on ${selectOta?.label === "Booking" ? "Booking.com" : selectOta?.label}`}
        </div>
        <div className="flex flex-col justify-center items-center mt-8">
          <div className="text-[#eeeff0] text-sm mt-2">Rating scores</div>
          <div className="text-[#e6e7e9] text-[30px] font-light mt-2 ">
            {ratingData?.averageRating}
          </div>
          <div className="-mt-2">
            <ReactStars
              count={5}
              size={30}
              value={ratingData?.averageRating}
              color2={"#FAD13D"}
              edit={false}
            />
          </div>
          <div className="text-[#ffffff] text-[16px] font-light -mt-1 ">
            {ratingData?.totalReviews} Reviews
          </div>
          <div className="w-[90%] h-0.5 my-2 bg-gray-200"></div>
          <div
            className={`flex flex-col justify-center w-[100%] ${isIpad ? "pb-0" : "pb-4"}`}
          >
            <div className="text-[#ffffff] text-sm text-center">
              Guest Engagement
            </div>
            <div className="flex justify-between mx-auto mt-4 w-[90%] items-center">
              <div className="flex justify-center w-[50%] border-r  items-center flex-col">
                <div className="text-[30px] text-[#29CC39] font-light">
                  {(
                    ((ratingData?.totalReviews -
                      ratingData?.emptyResponsesCount) /
                      ratingData?.totalReviews) *
                    100
                  ).toFixed(2) === "NaN" ||
                    (
                      ((ratingData?.totalReviews -
                        ratingData?.emptyResponsesCount) /
                        ratingData?.totalReviews) *
                      100
                    ).toFixed(2) === NaN
                    ? "--"
                    : (
                      ((ratingData?.totalReviews -
                        ratingData?.emptyResponsesCount) /
                        ratingData?.totalReviews) *
                      100
                    ).toFixed(2)}
                  %
                </div>
                <div className="text-[#ffffff] text-[16px] font-light -mt-1 ">
                  Reviews replied
                </div>
              </div>
              {/* <div className="h-[50px] w-0.5 -ml-2 mt-2 border-l"></div>  */}
              <div className="flex justify-center w-[50%] items-center flex-col">
                <div className="text-[30px] text-[#ffffff] font-light">
                  {ratingData?.emptyResponsesCount}
                </div>
                <div className="text-[#ffffff] text-[16px] font-light -mt-1 ">
                  Unreplied
                </div>
              </div>
            </div>
          </div>
          <div
            onClick={() => {
              navigate("/rate-pulse/reputation");
            }}
            className={`w-full text-white text-center ${isIpad ? "py-1" : "py-1 "} rounded-lg mt-3 cursor-pointer`}
          >
            View All
          </div>
        </div>
      </div>
    </div>
  );
};
const AddWidgetCard = ({ height, onClick }) => {
  return (
    <div className="bg-white h-[436px] flex justify-center items-center rounded-lg">
      <div
        className="flex justify-normal items-center flex-col cursor-pointer"
        onClick={onClick}
      >
        <div>
          <AiOutlinePlus size={45} color="#081439" />
        </div>
        <div className="text-[#081439] text-sm">Add New Widget</div>
      </div>
    </div>
  );
};

export const ActionComponent = ({ setActionCount }) => {
  const navigate = useNavigate();
  const { data } = useGetActionsToTakeQuery({
    hId: CurrentProperty(),
    userId: UserId(),
  });
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    if (data) {
      setActionCount(countCategoriesWithSolutions(data));
    }
  }, [data]);
  return (
    <div className="w-[100%] bg-newGradient dark:bg-lightGradient backdrop-blur-lg drop-shadow-lg shadow-lg rounded-lg p-4">
      <div className="w-[100%] flex flex-col">
        <div className="flex justify-between items-center">
          <div className="text-white font-bold">Take Actions </div>
          <div>
            <InfoToolTip
              content={
                "This feature provides a comparative analysis of your hotel's current performance against historical data."
              }
              position={"left"}
            />
          </div>
        </div>
        <div className="text-[#ffffff] flex-col md:flex-row text-sm mt-2">
          The following data display your property’s current performance in
          comparision to the past records.
        </div>
      </div>

      <div className="w-[100%] flex flex-col md:flex-row">
        <div className="w-full md:w-[70%]  mt-8 rounded-l-lg overflow-hidden">
          <div className="">
            <div className="bg-[#f6f7f900] p-4  flex justify-between">
              <div className="w-[35%] text-[#ebebed] text-sm  font-semibold">
                Action Item
              </div>
              <div className="w-[65%] text-[#ebebed] text-sm ml-5   font-semibold">
                Description
              </div>
            </div>
            {Array?.isArray(data?.data) &&
              data?.data.map((action, index) => {
                return (
                  <div
                    onClick={() => {
                      setCurrentIndex(index);
                    }}
                    className={`cursor-pointer ${currentIndex === index ? "bg-[#FF33330A] border-l-4 border-l-[#F43F3F]   border-b border-b-[#F43F3F]" : "bg-[#ffffff00]"} hover:bg-white/20 transition-all ease-in-out duration-100 p-4 cursor-pointer flex justify-between hover:border-l-4 hover:border-l-[#007BFF]`}
                  >
                    <div className="w-[25%] flex items-center gap-2 text-sm ">
                      <div className="text-[#ffffff] flex items-center justify-start gap-2">
                        {action?.taskCategory}
                      </div>
                      {/* <div>
                        <AiOutlineExclamationCircle color="#8794AD" />
                      </div> */}
                    </div>
                    <div className="w-[75%] text-[#ffffff] text-sm flex gap-4 items-center ">
                      <div className="flex items-center justify-between w-[12%]">
                        {/* <div>
                          <span className="text-[#252C32] font-semibold">
                            5
                          </span>{" "}
                          /10
                        </div> */}
                        <div>{/* <AiFillCaretDown color="red" /> */}</div>
                      </div>
                      <div className="w-[60%]">{action?.metrics}</div>
                      {/* <div className="flex text-[#081439] cursor-pointer gap-6 items-center">
                        <div
                          onClick={
                            currentIndex + 1 === data?.data.length
                              ? () => setCurrentIndex(0)
                              : () => setCurrentIndex(index)
                          }
                        >
                          Improve
                        </div>
                        <div>
                          <AiOutlineDown className="-rotate-90" />
                        </div>
                      </div> */}
                    </div>
                  </div>
                );
              })}
          </div>
        </div>

        <SolutionTile data={data} dataIndex={currentIndex} />
      </div>
    </div>
  );
};

export const PushRateModal = ({
  selectedDate,
  setPushRateModal,
  pushRateModal,
  toastAction,
}) => {
  const [rateBifercationData, setRateBifercationData] = useState();
  const [pushRateSelectedDate, setPushRateSelectedDate] = useState();
  const [selectedPushRate, setSelectedPushRate] = useState(selectedDate);
  console.log(selectedPushRate, "setSelectedPushRate");
  const [overrideRate, { isLoading: overideRateLoading }] =
    useOverrideRateMutation();
  const [pushRate, { isLoading: pushRateLoading }] = usePushRateMutation();
  const navigate = useNavigate();
  const location = useLocation();
  const [isTransition, setIsTransition] = useState(false);
  const isIpad = useIsIpad();
  const [isActive, setIsActive] = useState(false);
  const hId = CurrentProperty();
  const userId = UserId();
  const [inputValue, setInputValue] = useState("");
  const [acceptRate, { isLoading }] = useAcceptRateMutation();
  const [verifyRates, { isLoading: verifyRatesIsLoading }] =
    useVerifyRatesMutation();
  const [selectedDropdown, setSelectedDropdown] = useState();
  const [is7DayPrice, setIs7DayPrice] = useState(false);
  const [viewBifercation, setViewBifercation] = useState(false);
  const [pushRateBifercation, { isLoading: pushRateBifercationIsLoading }] =
    usePushRateBifercationMutation();
  const [rateBinfercationIsLoading, setRateBifercationIsLoading] =
    useState(false);

  const [date, setDate] = useState({
    startDate: new Date(selectedDate),
    endDate: new Date(selectedDate),
  });
  console.log(selectedDate, "selectedDate");
  const {
    data: getActualAndSuggestedRates,
    isLoading: getActualAndSuggestedRatesIsLoading,
    isFetching: getActualAndSuggestedRatesIsFetching,
  } = useGetActualAndSuggestedRatesQuery(
    {
      userId: UserId(),
      startDate: format(new Date(date.startDate), "yyyy-MM-dd"),
      endDate: format(new Date(date.endDate), "yyyy-MM-dd"),
      hId: CurrentProperty(),
    },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  const handlePushRateAction = () => {
    let rateDetails = [];
    getActualAndSuggestedRates?.data.map((rateData, index) => {
      rateDetails.push({
        rate: increaseByPercentage(
          parseInt(rateData?.suggestedRate),
          rateData?.discount
        ),
        date: format(new Date(rateData.date), "yyyy-MM-dd"),
      });
    });
    const verifyRateObj = {
      hId: hId,
    };
    const obj = {
      hId: hId,
      rateDetail: rateDetails,
    };
    pushRate(obj)
      .unwrap()
      .then((res) => {
        setPushRateModal(false);
        toastAction(true, "success");
        // refetch();
      })
      .catch((err) => {
        return toastAction(false, err?.data?.data?.message);
      });
  };
  return (
    <div className="w-[100%]">
      <div className="flex flex-row w-[100%] space-between item-center">
        <button
          className=" w-[200px] text-left"
          onClick={() => {
            setPushRateModal(false);
          }}
        >
          <RxCross2 className="text-white text-[24px]" />
        </button>
        <h1 className="w-[100%] text-[24px] text-black text-center font-bold">
          Push Rate
        </h1>{" "}
        <BackdropLoader
          loading={
            overideRateLoading ||
            pushRateLoading ||
            pushRateBifercationIsLoading
          }
        />
        <div className="w-[200px] text-right">
          {getActualAndSuggestedRatesIsLoading ? (
            <button
              className="bg-gray-800 text-white px-4 py-2 rounded-md w-[200px]"
              onClick={() => { }}
            >
              Loading...
            </button>
          ) : !getActualAndSuggestedRatesIsLoading && is7DayPrice ? (
            <div className="flex gap-2">
              {viewBifercation && (
                <div
                  onClick={() => setViewBifercation(false)}
                  className="bg-gray-800 z-40 relative cursor-pointer w-fit rounded-md  text-sm flex justify-center items-center text-white px-4 py-1"
                >
                  back
                </div>
              )}
              <button
                className="bg-gray-800 text-white px-4 py-2 rounded-md w-[200px]"
                onClick={() => {
                  setIs7DayPrice(!is7DayPrice);
                  const today = new Date(selectedDate);
                  const sevenDaysLater = new Date(selectedDate);

                  setDate({ startDate: today, endDate: sevenDaysLater });
                }}
              >
                1 Day Rate
              </button>
            </div>
          ) : (
            !getActualAndSuggestedRatesIsLoading && (
              <div className="flex gap-2 ">
                {viewBifercation && (
                  <div
                    onClick={() => setViewBifercation(false)}
                    className="bg-gray-800 z-40 relative cursor-pointer w-fit rounded-md  text-sm flex justify-center items-center text-white px-4 py-1"
                  >
                    back
                  </div>
                )}
                <button
                  className="bg-gray-800 text-white px-4 py-2 text-[12px] rounded-md w-[200px]"
                  onClick={() => {
                    setIs7DayPrice(!is7DayPrice);
                    const today = new Date();
                    const sevenDaysLater = new Date(today);
                    sevenDaysLater.setDate(today.getDate() + 7);

                    setDate({ startDate: today, endDate: sevenDaysLater });
                  }}
                >
                  7 Day Rate
                </button>
              </div>
            )
          )}
        </div>
      </div>
      {viewBifercation ? (
        <div className="p-4 h-[80vh]  bg-newGradient dark:bg-lightGradient  overflow-y-auto">
          <div className="mt-10  ">
            <div className="text-sm text-white">
              Selected Dates:{" "}
              {!is7DayPrice && format(selectedPushRate, "EEE, dd MMM yy")}{" "}
            </div>
            <div className="max-w-[100%] flex-wrap min-w-[100%] gap-2 max-h-[200px] overflow-y-auto grid grid-cols-4">
              {selectedDate &&
                is7DayPrice &&
                Array.from({ length: 7 }, (_, i) => addDays(selectedDate, i)) // Create an array for 7 days
                  .map((date, index) => {
                    return (
                      <div
                        key={index} // Add a key for each element
                        onClick={() => {
                          setSelectedPushRate(date);
                        }}
                        className={`min-w-[25%] my-2 text-sm flex gap-2 rounded-md items-center justify-between cursor-pointer ${selectedPushRate?.getTime() === date?.getTime()
                            ? "bg-blue-600"
                            : "bg-[#383c4f]"
                          } text-[#ffffff] py-1 px-2`}
                      >
                        <div>{format(date, "EEE, dd MMM yy")}</div>
                      </div>
                    );
                  })}
            </div>
          </div>
          <div className="mt-4 flex flex-col gap-4">
            <div className="text-sm text-white">
              Property Name: {rateBifercationData?.hotelName}
            </div>
            <div className="text-sm text-white">
              Channel Name: {rateBifercationData?.info?.[0]?.channelName}
            </div>
            {rateBinfercationIsLoading && (
              <div className="h-[200px] my-2 w-[100%]">
                <CustomSkeleton height={300} />
              </div>
            )}
            {rateBifercationData?.info?.[0]?.roomInfo?.map((item, index) => (
              <div className="w-[100%] relative max-h-[300px] pb-4 overflow-y-auto rounded-md bg-transparent">
                <h1 className="text-white">{item?.roomName}</h1>
                <div className="flex w-[100%] border-b border-[#E1E1E1] px-4 py-6 bg-[#383c4f] text-white h-[45px] sticky top-0  gap-4  items-center">
                  <div className="text-xs w-[100%] ">Room Plan</div>
                  <div className="text-xs w-[100%] ">Occupancy</div>
                  <div className="text-xs w-[100%] "> Rate</div>
                </div>
                {!rateBinfercationIsLoading ? (
                  item?.roomPlanInfo?.map((roomplan, index) => {
                    if (
                      roomplan?.roomPlan?.date !==
                      format(new Date(selectedPushRate), "yyyy-MM-dd")
                    ) {
                      return;
                    }

                    return (
                      <div
                        className={`flex w-[100%] ${index % 2 === 0 ? "bg-[#f9fafc3a]" : "bg-[#f9fafc58]"} text-white border-[#E1E1E1] group px-4 gap-4 items-center`}
                      >
                        <div className="w-[100%] text-sm">
                          {roomplan?.roomPlan?.roomPlanName}
                        </div>
                        <div className="w-[100%] text-sm">
                          {roomplan?.roomPlan?.occupancyName}
                        </div>
                        <div className="w-[100%] text-sm">
                          {formatCurrency(roomplan?.roomPlan?.rate)}
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="h-[20px] my-2 w-[100%]">
                    <CustomSkeleton height={300} />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="w-[100%] relative h-auto pb-4 overflow-y-auto rounded-md bg-transparent my-[10px]">
          <div className="flex w-[100%] border-b border-[#E1E1E1] px-4 py-6 bg-[#383c4f] text-white h-[45px] sticky top-0  gap-4  items-center">
            <div className="text-xs w-[100%] ">Dates</div>
            <div className="text-xs w-[100%] ">Occupancy</div>
            <div className="text-xs w-[100%] ">Current Rate</div>
            <div className="text-xs w-[100%] ">CM Rates</div>
            <div className="text-xs w-[100%] ">Discount</div>
            <div className="text-xs w-[100%] ">Suggested Rate</div>

            <div className="text-xs w-[100%] ">Suggested Rates in CM</div>
          </div>
          {getActualAndSuggestedRates?.data &&
            !getActualAndSuggestedRatesIsLoading &&
            !getActualAndSuggestedRatesIsFetching ? (
            getActualAndSuggestedRates?.data.map((item, index) => {
              return (
                <div
                  key={index}
                  className={`flex w-[100%] py-[10px] ${index % 2 === 0 ? "bg-newGradient dark:bg-lightGradient" : "bg-newGradient dark:bg-lightGradient"} text-white border-[#E1E1E1] group px-4 gap-4 items-center`}
                >
                  <div className="w-[100%] text-sm">
                    {format(new Date(item?.date), "EEE, dd MMM yy")}
                  </div>
                  <div className="w-[100%] text-sm">
                    <p className="text-[12px]">{item?.occupancy}%</p>
                    <ProgressBar
                      width={120}
                      maxValue={100}
                      value={item?.occupancy}
                    />
                  </div>
                  <div className="w-[100%] text-sm">
                    {formatCurrency(item?.rate)}
                  </div>
                  <div className="w-[100%] text-sm">
                    {formatCurrency(item?.CMRate)}
                  </div>
                  <div className="w-[100%] text-sm">
                    <p className="text-[12px]">{item?.discount}%</p>
                    <ProgressBar
                      width={120}
                      maxValue={100}
                      value={item?.discount}
                    />
                  </div>
                  <div className="w-[100%] text-sm">
                    {formatCurrency(item?.suggestedRate)}
                  </div>

                  <div className="w-[100%] text-sm">
                    {formatCurrency(
                      increaseByPercentage(
                        parseInt(item?.suggestedRate),
                        item?.discount
                      )
                    )}
                  </div>

                  {/* <div className="w-[100%] flex items-center gap-2">
                  {" "}
                  <input
                    type="text"
                    value={item?.overRideRate}
                    onChange={(e) =>
                      handleDifferentPrice(
                        index,
                        e.target.value,
                        item?.discount
                      )
                    }
                    className="w-[100%] placeholder:text-xs border my-1 px-2 border-gray-400 rounded-lg h-10 focus:outline focus:outline-orange-600 focus:border-none"
                    placeholder={`Enter Rate`}
                    step={"0.01"}
                  />
                  <AiFillCopy
                    color="white"
                    onClick={() =>
                      copyRate(
                        differentPriceData,
                        index,
                        setDifferentPriceDate,
                        item?.discount
                      )
                    }
                    className="cursor-pointer group-hover:opacity-100 opacity-0 duration-100 transition-all ease-in-out"
                    size={20}
                  />
                  <AiFillDelete
                    color="red"
                    onClick={() => handleDeleteDate(item?.date)}
                    className="cursor-pointer group-hover:opacity-100 opacity-0 duration-100 transition-all ease-in-out"
                    size={20}
                  />
                </div>
                <div className="w-[100%] text-sm">
                  {formatCurrency(item?.overRiddenInCM)}
                </div> */}
                </div>
              );
            })
          ) : (
            <div className="w-[100%]">
              {is7DayPrice ? (
                <CustomSkeleton height={100} />
              ) : (
                <CustomSkeleton height={300} />
              )}
            </div>
          )}
        </div>
      )}
      {viewBifercation ? (
        <button
          className=" w-[100%] py-5 bg-blue-700 rounded-md text-white "
          onClick={handlePushRateAction}
        >
          Push Rate
        </button>
      ) : (
        <div
          onClick={() => {
            let rateDetails = [];
            setViewBifercation((prev) => !prev);
            getActualAndSuggestedRates?.data.map((rateData, index) => {
              rateDetails.push({
                rate: increaseByPercentage(
                  parseInt(rateData?.suggestedRate),
                  rateData?.discount
                ),
                date: format(new Date(rateData.date), "yyyy-MM-dd"),
              });
            });

            const verifyRateObj = {
              hId: hId,
            };
            const obj = {
              hId: hId,
              rateDetail: rateDetails,
            };
            pushRateBifercation(obj)
              .unwrap()
              .then((res) => {
                setRateBifercationIsLoading(false);
                setRateBifercationData(res?.updatedFindCMRoomDetail);
              })
              .catch((err) => {
                setRateBifercationIsLoading(false);
                toast.error("Error pushing rate bifercation", {
                  position: "bottom-right",
                });
              });
          }}
          className="bg-[#0062ff]  z-40 relative cursor-pointer w-full py-5  rounded-md  mr-10 text-sm flex justify-center items-center text-white px-4 "
        >
          View Bifercation
        </div>
      )}
    </div>
  );
};
const Channel = ({ title, price, img }) => {
  Array.prototype.random = function () {
    return this[Math.floor(Math.random() * this.length)];
  };
  const color = [
    "#1abc9c",
    "#f1c40f",
    "#2ecc71",
    "#2980b9",
    "#fad390",
    "#f8c291",
    "#60a3bc",
    "#4a69bd",
  ];
  const navigate = useNavigate();
  const hId = CurrentProperty();
  const userId = UserId();
  const options = [
    { value: "reservation", label: "Reservation" },
    { value: "roomNights", label: "Room Nights" },
    { value: "revenue", label: "Revenue" },
    { value: "ADR", label: "ADR" },
  ];
  const [selectedItem, setSelectedItems] = useState({
    value: "reservation",
    label: "Reservation",
  });
  const { data, isLoading, isFetching } = useGetChannelQuery({
    userId: userId,
    hId: hId,
    type: selectedItem?.value,
  });

  const channelDetail = data?.data;
  const isIpad = useIsIpad();
  return (
    <>
      {isLoading || isFetching ? (
        <div className="w-[100%] h-[436px]">
          <CustomSkeleton height={436} />
        </div>
      ) : (
        <div className="flex bg-newGradient dark:bg-lightGradient backdrop-blur-lg drop-shadow-lg shadow-lg w-[100%] h-[436px] p-4 rounded-lg">
          <div className="flex flex-col w-full px-2">
            <div
              className={`h-10 text-[#2e343e] px-1 w-full flex  ${isIpad && "flex-col"} items-center justify-between  top-0 z-10`}
            >
              <p className={` text-white font-bold ${isIpad && "-ml-4"}`}>
                {title || "Channel Performance this Month"}
              </p>
              <div
                className={`flex items-center gap-4 ${isIpad && "justify-between w-[100%] mt-2"}`}
              >
                <Dropdown
                  options={options}
                  selectedItem={selectedItem?.label}
                  setSelectedItems={setSelectedItems}
                />
                <InfoToolTip
                  content={
                    "This tooltip offers insights into the performance of various booking channels."
                  }
                  index={"channelPerformance"}
                  position={"left"}
                />
              </div>
            </div>
            <div
              className={`w-full h-[300px] scroll-container ${isIpad ? "mt-10 " : "mt-5 "} overflow-y-scroll`}
            >
              {channelDetail &&
                channelDetail.map((item, index) => {
                  return (
                    <div
                      className="  py-2  group  mb-2 cursor-pointer  hover:bg-[#CCD6E5] rounded-xl "
                      onClick={() => navigate("/hotel_intelligence")}
                    >
                      <div
                        className="flex group-hover:p-1 justify-between
                group-hover:scale-[0.99] group-hover:transition-transform  transition-all ease-in-out duration-300
              "
                      >
                        <div className="flex items-center  lg:w-[100%] md:w-[100%] w-[100%] h-full ml-2 ">
                          {/* <div className="w-[100%]"> */}
                          {/* <img className="h-full w-fit " src={icon} /> */}
                          {/* </div> */}
                          <div className="flex -mt-1  items-center">
                            <div className="flex gap-2 items-center">
                              <div
                                className={`w-8 h-8 uppercase flex rounded-full justify-center text-white items-center text-sm`}
                                style={{ background: color.random() }}
                              >
                                {item?.source?.charAt(0)}
                              </div>
                              <p
                                data-tooltip-id={item.source}
                                className={` text-[#ffffff] truncate min-w-[${isIpad ? "100px max-w-[100px]" : ""}]  text-[14px] whitespace-nowrap font-[400]`}
                              >
                                {item.source}
                                <Tooltip
                                  id={item.source}
                                  content={item.source}
                                />
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="flex text-[14px] w-full gap-2 whitespace-nowrap justify-end items-center font-medium group-hover:bg-[#CCD6E5] group-hover:px-2 ">
                          <p className="text-white">
                            {selectedItem?.label === "Revenue" ||
                              selectedItem?.label === "ADR"
                              ? formatCurrency(item?.value)
                              : item.value}
                          </p>

                          {/* <p className='font-semibold text-[#57F3B1] flex text-sm '>{item?.value} <p className=' text-neutral-dark-20'>/5</p></p> */}
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
            <div
              onClick={() => {
                navigate("/hotel_intelligence");
              }}
              className="w-full text-center text-white rounded-lg mt-4 cursor-pointer"
            >
              View All
            </div>
          </div>
        </div>
      )}
    </>
  );
};
const UpcomingEvent = () => {
  const hId = CurrentProperty();
  const userId = UserId();
  const { data } = useGetUpcomingEventQuery({
    userId: userId,
    hId: hId,
  });
  const eventData = data?.data;

  return (
    <>
      <div className="flex w-[100%] h-[436px] p-4 rounded-lg bg-newGradient dark:bg-lightGradient backdrop-blur-lg drop-shadow-lg shadow-lg">
        <div className="flex flex-col gap-4 w-full px-2">
          <div className="flex justify-between items-center -mt-2  top-0 bg-white py-2 z-10">
            <div className="font-bold">Upcoming Events</div>
            <InfoToolTip
              content={
                "This feature highlights upcoming events and activities relevant to the property's location or target market."
              }
              index={"upcomingEvents"}
            />
            {/* <div>
        <Dropdown />
      </div> */}
          </div>
          <div className="flex flex-col gap-2 bg-white lg:w-[100%] md:w-[100%] w-[100%] h-full overflow-y-scroll scrollHide">
            {eventData?.map((item, index) => (
              <div
                key={index}
                title={item.eventName}
                className="flex flex-col justify-center gap-2 hover:bg-[#F0EBD8] h-14 w-80 rounded-lg"
              >
                <p className="text-[#2e343e] ml-3 text-[14px] font-semibold max-w-[100%] truncate">
                  {item.eventName}
                </p>
                <p className="text-gray-500 ml-3 text-xs flex items-center gap-2 whitespace-nowrap font-[400]">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="#ABABAB"
                    viewBox="0 0 50 50"
                    width="20px"
                    height="20px"
                  >
                    <path d="M 25 2 C 12.309295 2 2 12.309295 2 25 C 2 37.690705 12.309295 48 25 48 C 37.690705 48 48 37.690705 48 25 C 48 12.309295 37.690705 2 25 2 z M 25 4 C 36.609824 4 46 13.390176 46 25 C 46 36.609824 36.609824 46 25 46 C 13.390176 46 4 36.609824 4 25 C 4 13.390176 13.390176 4 25 4 z M 37.039062 10.990234 A 1.0001 1.0001 0 0 0 36.265625 11.322266 L 26.183594 22.244141 A 3 3 0 0 0 25 22 A 3 3 0 0 0 22 25 A 3 3 0 0 0 25 28 A 3 3 0 0 0 25.5 27.958984 L 29.125 34.486328 A 1.0010694 1.0010694 0 1 0 30.875 33.513672 L 27.246094 26.984375 A 3 3 0 0 0 28 25 A 3 3 0 0 0 27.652344 23.599609 L 37.734375 12.677734 A 1.0001 1.0001 0 0 0 37.039062 10.990234 z" />
                  </svg>
                  {format(
                    new Date(item.eventStartDateTime),
                    "dd-MMM-yyyy hh:mm:ss a "
                  )}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};
const CancellationMonth = () => {
  const hId = CurrentProperty();
  const navigate = useNavigate();
  const userId = UserId();
  const { data } = useGetCancellationQuery({
    userId: userId,
    hId: hId,
  });
  const cancelationData = data?.data;

  const initial = cancelationData?.totalCancellationThisYear;
  const final = cancelationData?.totalCancellationLastYear;

  var percentage = ((initial - final) / final) * 100;

  percentage = parseFloat(percentage.toFixed(2));
  return (
    <>
      <div className=" flex flex-col w-[100%] h-[436px] p-4 bg-newGradient dark:bg-lightGradient backdrop-blur-lg drop-shadow-lg shadow-lg rounded-lg justify-between ">
        <div className="flex flex-col gap-4  w-full px-2 ">
          <div className="flex mt-1 justify-between items-center">
            <p className="text-white font-bold">{"Cancellation this Month"}</p>
            <InfoToolTip
              content={
                "This insight highlights the total number of room nights and associated revenue lost due to cancellations within the current calendar month."
              }
              index={"CancellationTooltip"}
              position={"left"}
            />
          </div>
          <div className="flex  items-center">
            <p className="text-[32px] mr-2 text-white font-medium">
              {cancelationData?.totalCancellationThisYear}
            </p>
            <p
              className={`${percentage === Infinity ? "" : percentage > 0 ? "text-red-500" : "text-[#29CC39]"} text-[14px]`}
            >
              {percentage === Infinity
                ? ""
                : percentage > 0
                  ? `+${percentage}`
                  : Math.abs(percentage)}
              {percentage === Infinity ? "" : "%"}
            </p>
            <span></span>
          </div>
          <span className=" flex -mt-2 gap-2">
            <p className="text-white">
              {cancelationData?.totalCancellationLastYear}
            </p>
            <p className="text-white"> Last Year</p>
          </span>
          <span className=" flex h-[200px] scrollHide overflow-y-scroll flex-col justify-start gap-2">
            {cancelationData?.source?.map((item, index) => (
              <div className="flex flex-col mt-1">
                <span className=" flex justify-between">
                  <span className=" flex flex-col">
                    <p className="text-white">{item?.source}</p>
                    <p className="text-white text-xs">
                      {item?.totalCancellations} Booking
                    </p>
                  </span>
                  <p className="text-white">{item?.cancellationPercentage}%</p>
                </span>
              </div>
            ))}
          </span>
        </div>
        <div
          onClick={() => {
            navigate("/reservations", {
              state: {
                status: "Cancelled",
              },
            });
          }}
          className="w-full text-center py-1 text-white rounded-lg mt-2 cursor-pointer"
        >
          View All
        </div>
      </div>
    </>
  );
};
const WidgetModal = ({
  onClick,
  SelectedWidgets,
  refetchWidget,
  widgetIsLoading,
}) => {
  const { data, isLoading: allWidgetIsLoading } = useGetAllWidgetQuery();
  const [border, setBorder] = useState([]);
  const [temp, setTemp] = useState(true);
  const [widgetData, setWidgetData] = useState([]);
  const [postWidget] = usePostWidgetsMutation();

  const hId = CurrentProperty();
  const userId = UserId();
  const handleClick = (widget, index) => {
    if (
      border?.length <= 2 &&
      // border?.length > 0 &&
      !border?.includes(widget?.widgetId)
    ) {
      setBorder([...border, widget?.widgetId]);
      setWidgetData([...widgetData, widget]);
    }

    if (border?.includes(widget?.widgetId) && border?.length > 1) {
      setBorder(border.filter((item) => item !== widget?.widgetId));
      setWidgetData(
        widgetData.filter((item) => item.widgetId !== widget.widgetId)
      );
    }
  };
  const selectedIds = SelectedWidgets?.data.map((widgets) => widgets?.widgetId);
  const alreadySelectedWidget = SelectedWidgets?.data.map((widgets) => widgets);

  useEffect(() => {
    setBorder(selectedIds ? selectedIds : []);
    setWidgetData(alreadySelectedWidget ? alreadySelectedWidget : []);
  }, []);
  const handleAddWidget = () => {
    postWidget({
      hId: hId,
      userId: userId,
      widgets: widgetData,
    });
    onClick();
    refetchWidget();
  };
  return (
    <>
      <Backdrop>
        {allWidgetIsLoading ? (
          <BackdropLoader loading={allWidgetIsLoading} />
        ) : (
          <div className="w-[80%] mx-auto bg-newGradient dark:bg-lightGradient h-auto rounded-lg relative">
            {border?.length <= 3 && border?.length > 0 && (
              <div
                onClick={handleAddWidget}
                className="absolute right-4 bottom-4 bg-blue-400 text-white  py-2 px-6 rounded-lg hover:bg-blue-500 hover:text-white cursor-pointer"
              >
                Add
              </div>
            )}
            <div
              onClick={onClick}
              className="absolute right-2 top-1 text-[#ffc7c7] text-sm py-1 px-2 rounded-md cursor-pointer"
            >
              <AiFillCloseCircle size={28} />
            </div>
            <div className="text-lg font-medium px-5 py-2 text-white">
              Select Widget
            </div>
            <div className="w-[100%] ">
              <div className="grid grid-cols-4 justify-between gap-4 w-[100%] p-4">
                {Array.isArray(data?.data) &&
                  data?.data.map((widget, index) => (
                    <div
                      onClick={() => handleClick(widget, index)}
                      className={`w-[100%] ${border?.includes(widget?.widgetId) ? "border-sky-200 border-4" : ""}  bg-white shadow-md rounded-lg border`}
                    >
                      <img
                        src={
                          widget?.widgetName === "Channel Performance"
                            ? channelImg
                            : widget?.widgetName === "Cancellation"
                              ? cancellationImg
                              : widget?.widgetName === "Sentiment Analysis"
                                ? sentimental
                                : widget?.widgetName === "Reputation"
                                  ? reputationImg
                                  : widget?.widgetName === "Upcoming Event"
                                    ? eventsImg
                                    : ""
                        }
                      />
                    </div>
                  ))}
              </div>
            </div>
          </div>
        )}
      </Backdrop>
    </>
  );
};

const Urgentactions = ({
  data,
  date,
  refetch,
  pushRateModal,
  setPushRateModal,
  setIsToggle,
  isToggled,
}) => {
  const toggleButton = () => {
    setIsToggle(!isToggled);
  };
  const [overrideRate, { isLoading: overideRateLoading }] =
    useOverrideRateMutation();
  const [pushRate, { isLoading: pushRateLoading }] = usePushRateMutation();
  const navigate = useNavigate();
  const location = useLocation();
  const [isTransition, setIsTransition] = useState(false);
  const isIpad = useIsIpad();
  const [isActive, setIsActive] = useState(false);
  const hId = CurrentProperty();
  const userId = UserId();
  const [inputValue, setInputValue] = useState("");
  const [acceptRate, { isLoading }] = useAcceptRateMutation();
  const [verifyRates, { isLoading: verifyRatesIsLoading }] =
    useVerifyRatesMutation();
  const [selectedDropdown, setSelectedDropdown] = useState();
  const { data: singleDayDynamicRate } =
    useGetRateAnalysisDynamicRateSingleDayQuery(
      {
        hId: CurrentProperty(),
        userId: UserId(),
        date: format(new Date(date), "yyyy-MM-dd"),
      },
      {
        skip: isToggled ? false : true,
      }
    );
  const dynamicDate =
    singleDayDynamicRate && singleDayDynamicRate?.data?.dynamicRates[0]?.rate;
  const handleAction = () => {
    const obj = {
      hId: hId,
      userId: userId,
      date: format(new Date(date), "yyyy-MM-dd"),
    };
    const verifyRateObj = {
      hId: hId,
    };
    if (inputValue && inputValue !== 0) {
      const obj = {
        hId: hId,
        userId: userId,
        overRideRates: [
          {
            rate: parseInt(inputValue),
            date: format(new Date(date), "yyyy-MM-dd"),
          },
        ],
      };
      overrideRate(obj)
        .unwrap()
        .then((res) => {
          toast.success("Rates Override Successfully", {
            position: "bottom-right",
          });
          refetch();
        })
        .catch((err) => {
          return toast.error(err?.data?.data?.message, {
            position: "bottom-right",
          });
        });
    } else {
      if (data?.isRateAccepted) {
        verifyRates(verifyRateObj)
          .unwrap()
          .then((resp) => {
            toast.success("Rates Verification Successfully Completed !", {
              position: "bottom-right",
            });
            refetch();
            setIsActive(true);
          })
          .catch((err) => {
            return toast.error(err?.data?.data?.message, {
              position: "bottom-right",
            });
          });
      } else {
        acceptRate(obj)
          .unwrap()
          .then((res) => {
            toast.success("Rate accepted successfully, sent to verification!", {
              position: "bottom-right",
            });
            verifyRates(verifyRateObj)
              .unwrap()
              .then((resp) => {
                toast.success("Rates Verification Successfully Completed !", {
                  position: "bottom-right",
                });
                refetch();
                setIsActive(true);
              })
              .catch((err) => {
                return toast.error(err?.data?.data?.message, {
                  position: "bottom-right",
                });
              });
          })
          .catch((err) => {
            toast.error("Something went wrong! try again after sometime.", {
              position: "bottom-right",
            });
          });
      }
    }
  };

  const handlePushRateAction = () => {
    setPushRateModal(!pushRateModal);
    // const obj = {
    //   hId: hId,
    //   userId: userId,
    //   date: format(new Date(date), "yyyy-MM-dd"),
    // };
    // const verifyRateObj = {
    //   hId: hId,
    // };
    // if (!inputValue && inputValue === 0) {
    //   const obj = {
    //     hId: hId,
    //     rateDetail: [
    //       {
    //         rate: parseInt(inputValue),
    //         date: format(new Date(date), "yyyy-MM-dd"),
    //       },
    //     ],
    //   };
    //   pushRate(obj)
    //     .unwrap()
    //     .then((res) => {
    //       toast.success("Rates Override Successfully", {
    //         position: "bottom-right",
    //       });
    //       refetch();
    //     })
    //     .catch((err) => {
    //       return toast.error(err?.data?.data?.message, {
    //         position: "bottom-right",
    //       });
    //     });
    // } else {
    //   if (data?.isRateAccepted) {
    //     verifyRates(verifyRateObj)
    //       .unwrap()
    //       .then((resp) => {
    //         toast.success("Rates Verification Successfully Completed !", {
    //           position: "bottom-right",
    //         });
    //         refetch();
    //         setIsActive(true);
    //       })
    //       .catch((err) => {
    //         return toast.error(err?.data?.data?.message, {
    //           position: "bottom-right",
    //         });
    //       });
    //   } else {
    //     acceptRate(obj)
    //       .unwrap()
    //       .then((res) => {
    //         toast.success("Rate accepted successfully, sent to verification!", {
    //           position: "bottom-right",
    //         });
    //         verifyRates(verifyRateObj)
    //           .unwrap()
    //           .then((resp) => {
    //             toast.success("Rates Verification Successfully Completed !", {
    //               position: "bottom-right",
    //             });
    //             refetch();
    //             setIsActive(true);
    //           })
    //           .catch((err) => {
    //             return toast.error(err?.data?.data?.message, {
    //               position: "bottom-right",
    //             });
    //           });
    //       })
    //       .catch((err) => {
    //         toast.error("Something went wrong! try again after sometime.", {
    //           position: "bottom-right",
    //         });
    //       });
    //   }
    // }
  };

  useEffect(() => {
    if (isActive) {
      setTimeout(() => {
        setIsActive(false);
      }, [8000]);
    }
  }, [isActive]);

  useEffect(() => {
    setIsTransition(true);
  }, []);

  const WaveContainer = ({ percentage = 50 }) => {
    const [fillPercentage, setFillPercentage] = useState(0);

    useEffect(() => {
      // Animate the wave fill to the specified percentage
      const interval = setInterval(() => {
        setFillPercentage((prev) => {
          if (prev < percentage) {
            return prev + 1;
          }
          clearInterval(interval);
          return prev;
        });
      }, 20);

      return () => clearInterval(interval);
    }, [percentage]);

    return (
      <div className="wave-container">
        <svg
          className="wave-svg"
          viewBox="0 0 100 50"
          preserveAspectRatio="none"
          style={{
            top: `${100 - fillPercentage}%`,
          }}
        >
          <path
            d="M0 30 Q 25 20 50 30 T 100 30 V50 H0 Z"
            fill="#4f8ef7"
            className="wave-path"
          />
        </svg>
        <div className="percentage">{fillPercentage}%</div>
      </div>
    );
  };

  const Card = ({
    type = "default",
    title,
    isInput,
    value,
    setInputValue,
    inputValue,
    percentageDiff,
  }) => {
    const inputRef = useRef(null);
    useEffect(() => {
      if (isInput && inputRef.current) {
        inputRef.current.focus();
      }
    }, [isInput]);
    const handleInput = (e) => {
      const value = e.target.value;
      if (value === "" || /^-?\d{0,6}(\.\d{0,2})?$/.test(value)) {
        setInputValue(value);
      }
    };

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return (
      <>
        {type === "occupancy" ? (
          <div
            style={{
              background: "linear-gradient(1deg, #95C82A, transparent)",
            }}
            className="relative w-[160px] h-[76px]   overflow-hidden flex items-end rounded-2xl"
          >
            {/* Water layers */}
            <div className="absolute inset-0">
              <div
                className="relative w-full water-layer layer-1"
                style={{ height: `${100 - value}%` }}
              ></div>
              <div
                className="absolute w-full top-0 water-layer layer-2"
                style={{ height: `${100 - value}%` }}
              ></div>
              <div
                className="absolute w-full top-0 water-layer layer-3"
                style={{ height: `${100 - value}%` }}
              ></div>
            </div>
            {/* Percentage */}
            <div className="absolute inset-0 flex items-end justify-center">
              <div className="flex h-[76px] flex-col items-center justify-center">
                <span className="text-white text-xl font-semibold z-10">
                  {value}%
                </span>
                <span className="text-xs text-[#ffffff]z-10">{title}</span>
              </div>
            </div>
          </div>
        ) : type === "date" ? (
          <div
            style={{
              background: "linear-gradient(45deg, #1a386b, transparent)",
            }}
            className="p-4 w-[120px] rounded-2xl"
          >
            <div
              className={`text-xl ${title === "Suggested Rates" ? " text-[#95C82A]" : " text-[#ffffff]"}`}
            >
              {value}
            </div>
            <div className="text-xs text-[#ffffff]">{title}</div>
          </div>
        ) : (
          <div
            style={{
              background: "linear-gradient(45deg, #1a386b, transparent)",
            }}
            className=" w-[200px] rounded-2xl flex flex-row items-end space-x-5 justify-between"
          >
            <div className="pl-4 py-4 w-[200px] rounded-2xl flex flex-col items-start h-[100%] ">
              {isInput ? (
                <input
                  placeholder={`₹0.00`}
                  className={`text-xl mb-2  rounded-md focus:outline-none px-2 placeholder:text-sm bg-white max-w-[120px] ${title === "Enter Override Rates" ? " text-[#d8861a]" : " text-[#272A3D]"}`}
                  value={inputValue}
                  onChange={handleInput}
                  type="text"
                  ref={inputRef}
                />
              ) : (
                <div
                  className={`text-xl whitespace-nowrap ${title === "Suggested Rates" ? " text-[#95C82A]" : " text-[#ffffff]"}`}
                >
                  {value}
                </div>
              )}
              <div className="text-xs text-[#ffffff]">{title}</div>
            </div>
            <div className="flex flex-col p-4 items-end justify-end  h-[100%] rounded-2xl ">
              <p className="text-[15px] font-bold">
                {new Date(date).getDate()}
              </p>
              <p className="truncate text-[10px]">
                {monthNames[new Date(date).getMonth()]}
              </p>
            </div>
          </div>
        )}
      </>
    );
  };
  return (
    <div className="min-h-[380px] max-h-[380px] w-[100%] text-white bg-transparent  rounded-l-lg p-4 relative">
      <div className="flex justify-between items-center">
        <div>
          <div className="text-[18px] font-bold">
            Urgent Actions{" "}
            <span className="text-sm text-gray-200">
              {" "}
              for{" "}
              {format(new Date(date), "dd-MMM-yy") ===
                format(new Date(), "dd-MMM-yy")
                ? "today"
                : format(new Date(date), "dd-MMM-yy")}
            </span>
          </div>
          {!data?.isRateAccepted && !data?.isRateVerified && (
            <div className="text-[15px]">
              Set your property price to{" "}
              <span className="font-semibold">
                {isToggled
                  ? formatCurrency(dynamicDate)
                  : formatCurrency(data?.suggestedRate)}
              </span>{" "}
              for{" "}
              {format(new Date(date), "dd-MMM-yy") ===
                format(new Date(), "dd-MMM-yy")
                ? "today"
                : format(new Date(date), "dd-MMM-yy")}{" "}
              to boost bookings and maximize revenue!
            </div>
          )}
        </div>
        <div className="flex items-center gap-4">
          {data?.isRateAccepted && !data?.isRateVerified && (
            <div
              onClick={!isLoading && handleAction}
              className="text-[14px] text-white bg-[#3E5c76] py-1 px-4 rounded-lg cursor-pointer flex gap-2 items-center"
            >
              <AiOutlineCheck size={16} />{" "}
              {verifyRatesIsLoading ? "Verifying..." : "Verify"}
            </div>
          )}
          {/* <div>
            <Dropdown
              options={[
                { label: "Aggressive Mode", value: "Aggressive Mode" },
                { label: "Normal Mode", value: "Normal Mode" },
              ]}
              selectedItem={selectedDropdown?.label}
              setSelectedItems={setSelectedDropdown}
            />
          </div> */}
        </div>
        <div className="flex gap-2 items-center text-white dark:text-white">
          <div className="text-sm">Suggestion</div>
          <CheckBox
            checked={isToggled}
            onChange={toggleButton}
            name={"toggle"}
          />
          <div className="text-sm">Dynamic</div>
        </div>
      </div>
      <div className="mt-4 flex gap-4 items-center">
        {!isActive && !data?.isRateAccepted && !data?.isRateVerified && (
          <>
            {/* <Card
          type={"date"}
            value={(new Date(date)).getDate()}
            title={"September"}
          /> */}
            <Card
              value={formatCurrency(data?.actualRate)}
              title={"Current Rate"}
            />
            <Card
              value={
                isToggled
                  ? formatCurrency(dynamicDate)
                  : formatCurrency(data?.suggestedRate)
              }
              title={isToggled ? "Dynamic Rates" : "Suggested Rates"}
            />
            <Card
              type={"occupancy"}
              value={(data?.occupancy || 0).toFixed(0)}
              title={"Occupancy"}
            />
            {/* <Card
              title={"Enter Override Rates"}
              isInput={true}
              inputValue={inputValue}
              setInputValue={setInputValue}
              value={formatCurrency(data?.suggestedRate)}
            /> */}
            <div className=" flex flex-col gap-2">
              {data?.isRateAccepted === false && (
                <>
                  {/* <div
                    onClick={!isLoading && handleAction}
                    className="text-[14px] text-white bg-[#3E5c76] py-1 px-4 rounded-md cursor-pointer justify-center flex gap-2 items-center"
                  >
                    {verifyRatesIsLoading ? (
                      "Verifying..."
                    ) : overideRateLoading || isLoading ? (
                      "Please wait..."
                    ) : (
                      <span className="flex gap-2">
                        {" "}
                        <AiOutlineCheck size={16} /> Accept
                      </span>
                    )}
                  </div> */}
                  <div
                    onClick={!isLoading && handlePushRateAction}
                    className="text-[14px] text-white bg-[#3E5c76] py-1 px-4 rounded-md cursor-pointer justify-center flex gap-2 items-center"
                  >
                    {verifyRatesIsLoading ? (
                      "Verifying..."
                    ) : overideRateLoading || isLoading ? (
                      "Please wait..."
                    ) : (
                      <span className="flex gap-2">
                        {" "}
                        <AiOutlineCheck size={16} /> Push Rate
                      </span>
                    )}
                  </div>
                </>
              )}
              <div
                onClick={() => {
                  navigate("/rate_suggestions", {
                    state: {
                      date: date,
                      isDynamic: isToggled ? true : false,
                    },
                  });
                }}
                className="text-[14px] relative z-20 whitespace-nowrap rounded-md text-white bg-[#272A3D] py-1 px-4 cursor-pointer flex gap-2 items-center"
              >
                <AiOutlineFileText size={16} />
                See Details
              </div>
            </div>
          </>
        )}
        {
          <div
            className={`absolute animationDiv  duration-500 transition-all ease-in-out  ${isTransition ? "w-[100%]" : "w-[0%]"} flex justify-end left-0 z-10 ${isActive || data?.isRateVerified || data?.isRateAccepted ? "top-[70px]" : `${isIpad ? "top-[180px]" : "top-[130px]"}`}  `}
          // style={{
          //   background:
          //     "linear-gradient(45deg, rgb(17 120 255), rgb(183 183 183))",
          // }}
          >
            <img src={revens} width={isIpad ? 150 : 210} />
          </div>
        }
      </div>
      {/* <div className="mt-4">
        <div className="text-[18px] my-2">Today's Analysis</div>
        <div className="bg-[#F0F0F0] flex gap-2 items-center p-4 w-[260px] rounded-2xl">
          <div className="text-center">
            <div className="text-[10px] text-[#272A3D]">Revenue</div>
            <div className="text-xl text-[#272A3D]">233784</div>
          </div>
          <div className="h-[30px] w-0.5 bg-white"></div>
          <div className="text-center">
            <div className="text-[10px] text-[#272A3D]">Occupancy</div>
            <div className="text-xl text-[#272A3D]">34</div>
          </div>
          <div className="h-[30px] w-0.5 bg-white"></div>
          <div className="text-center">
            <div className="text-[10px] text-[#272A3D]">ADR</div>
            <div className="text-xl text-[#272A3D]">233784</div>
          </div>
        </div>
      </div> */}
      <div
        className={` duration-1000 flex items-center  p-4 text-white  text-lg transition-all ease-in-out  ${isTransition ? "w-[100%]" : "w-[0%]"}  h-[150px] relative ${isActive || data?.isRateVerified || data?.isRateAccepted ? "top-[40px] " : "top-0"} transition-all ease-in-out duration-500  mt-4 rounded-3xl`}
        style={{
          background: data?.isRateVerified
            ? "linear-gradient(45deg, rgb(99 190 11), rgb(240, 235, 216))"
            : data?.isRateAccepted
              ? "linear-gradient(45deg, rgb(204 112 18), rgb(240, 235, 216))"
              : "linear-gradient(45deg, rgb(21, 43, 93), rgb(240 235 216 / 8%))",
        }}
      >
        <div className="w-[80%]">
          {data?.message && <div className="w-[100%]">"{data?.message}"</div>}
        </div>
      </div>
    </div>
  );
};
const Next7DayPricing = ({ setSelectedDate, selectedDate, data }) => {
  const isIpad = useIsIpad();

  function getNext7Days() {
    const days = [];
    const today = new Date();
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const dayNames = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];

    for (let i = 0; i < 8; i++) {
      const nextDay = new Date(today);
      nextDay.setDate(today.getDate() + i);

      const dayOfWeek = dayNames[nextDay.getDay()];
      const month = monthNames[nextDay.getMonth()];
      const date = nextDay.getDate();
      const year = nextDay.getFullYear();
      days.push(`${dayOfWeek}, ${month} ${date}, ${year}`);
    }

    return days;
  }

  return (
    <div className="p-4 pl-0 bg-transparent   rounded-r-lg min-h-[380px] max-h-[380px]">
      <div className="flex flex-col justify-start items-start">
        <div>
          <div className="text-[18px] text-white font-bold">
            Next 7 day pricing
          </div>
        </div>
        <div className="flex gap-2 my-2 items-center scrollHide  min-w-[100%] max-w-[100%] overflow-x-scroll">
          {getNext7Days().map((item, index) => {
            const date = new Date(item);
            const day = item?.split(" ")[2]?.split(",")[0];
            const month = item?.split(" ")[1];
            return (
              <div
                key={index}
                className={`${selectedDate === item || item === format(new Date(selectedDate), "EEEE, MMMM d, yyyy") ? `bg-[#0062ff] text-white  ${isIpad ? "p-5" : "px-4 py-3"}` : `bg-[#1D2D44] text-white  ${isIpad ? "p-2" : "px-3 py-2"}`} cursor-pointer  group transition-all ease-in-out duration-200 text-center  rounded-lg `}
                onClick={() => setSelectedDate(item)}
              >
                {/* ${index === 0 && 'sticky left-0'} */}
                <div
                  className={`${selectedDate === item || item === format(new Date(selectedDate), "EEEE, MMMM d, yyyy") ? `text-[24px]` : `text-[18px]`} group-hover:text-white font-semibold transition-all ease-in-out duration-200`}
                >
                  {day}
                </div>
                <div
                  className={`${selectedDate === item || item === format(new Date(selectedDate), "EEEE, MMMM d, yyyy") ? `text-[15px]` : `text-[10px]`}  group-hover:text-white transition-all ease-in-out duration-200`}
                >
                  {month}
                </div>
              </div>
            );
          })}
        </div>
        <div className="grid grid-cols-2 gap-2 w-[100%]">
          <div
            className="rounded-lg p-4 max-w-[100%] truncate"
            style={{
              background: "linear-gradient(45deg, #1a386b, transparent)",
            }}
          >
            <div className="text-[12px] w-[100%] text-white flex justify-between items-center">
              Revenue{" "}
              {!isIpad && (
                <div
                  className={`text-[11px] group ${data?.revenuePerDiff?.toString()?.includes("-") ? "bg-red-200 text-red-500" : "bg-[#ECFDF5] text-[#29CC39]"} w-fit px-2 py-1 rounded-lg text-[#101010]`}
                >
                  <span className="group-hover:hidden">
                    {data?.revenuePerDiff
                      ? Math.abs(data?.revenuePerDiff)
                      : "--"}
                    %
                  </span>
                  <span className="group-hover:block hidden">
                    {calculateDifference(
                      data?.revenueThisYear,
                      data?.revenueLastYear,
                      true
                    )}
                  </span>
                </div>
              )}
            </div>
            <div className="flex items-center gap-2 justify-between">
              <div
                className={` ${isIpad ? "text-[12px]" : "text-[18px]"}  font-semibold text-[#ffffff]`}
              >
                {formatCurrency(data?.revenueThisYear)}
              </div>
            </div>

            <div
              className={` ${isIpad ? "text-[11px]" : "text-[14px]"}   text-[#ffffff]`}
            >
              {formatCurrency(data?.revenueLastYear)}{" "}
              {isIpad ? (
                <div>Last year</div>
              ) : (
                <span className="text-xs" title="Same day last year">
                  Last year
                </span>
              )}
            </div>
          </div>
          <div
            className=" rounded-lg p-4 w-[100%]"
            style={{
              background: "linear-gradient(45deg, #1a386b, transparent)",
            }}
          >
            <div className="text-[12px] text-white flex justify-between items-center">
              Room Nights{" "}
              {!isIpad && (
                <div
                  className={`text-[11px] group ${data?.roomNightsPerDiff?.toString()?.includes("-") ? "bg-red-200 text-red-500" : "bg-[#ECFDF5] text-[#29CC39]"} w-fit px-2 py-1 rounded-lg text-[#101010]`}
                >
                  <span className="group-hover:hidden block">
                    {data?.roomNightsPerDiff
                      ? Math.abs(data?.roomNightsPerDiff)
                      : "--"}
                    %
                  </span>

                  <span className="group-hover:block hidden">
                    {calculateDifference(
                      data?.roomNightsThisYear,
                      data?.roomNightsLastYear
                    )}
                  </span>
                </div>
              )}
            </div>
            <div className="flex items-center gap-2 justify-between">
              <div
                className={` ${isIpad ? "text-[12px]" : "text-[18px]"}  font-semibold text-[#ffffff]`}
              >
                {data?.roomNightsThisYear}
              </div>
            </div>

            <div
              className={` ${isIpad ? "text-[11px]" : "text-[14px]"}   text-[#ffffff]`}
            >
              {data?.roomNightsLastYear}{" "}
              <span className="text-xs" title="Same day last year">
                Last year
              </span>
            </div>
          </div>
        </div>
        <div className="w-[100%] mt-2 grid grid-cols-2 gap-2">
          <div
            style={{
              background: "linear-gradient(45deg, #1a386b, transparent)",
            }}
            className="rounded-lg p-4"
          >
            <div className="text-[12px] text-white flex justify-between items-center">
              Cancellation{" "}
              {!isIpad && (
                <div
                  className={`text-[11px] group ${data?.cancellationThisYear > data?.cancellationLastYear ? "bg-red-200 text-red-500" : "bg-[#ECFDF5] text-[#29CC39]"} w-fit px-2 py-1 rounded-lg text-[#101010]`}
                >
                  <span className="group-hover:hidden block">
                    {data?.cancellationPerDiff
                      ? Math.abs(data?.cancellationPerDiff)
                      : "--"}
                    %
                  </span>
                  <span className="group-hover:block hidden">
                    {calculateDifference(
                      data?.cancellationThisYear,
                      data?.cancellationLastYear
                    )}
                  </span>
                </div>
              )}
            </div>
            <div className="flex items-center justify-between">
              <div
                className={` ${isIpad ? "text-[12px]" : "text-[18px]"}  font-semibold text-[#ffffff]`}
              >
                {data?.cancellationThisYear}
              </div>
            </div>

            <div
              className={` ${isIpad ? "text-[11px]" : "text-[14px]"}   text-[#ffffff]`}
            >
              {data?.cancellationLastYear}{" "}
              <span className="text-xs" title="Same day last year">
                Last year
              </span>
            </div>
          </div>
          <div
            style={{
              background: "linear-gradient(45deg, #1a386b, transparent)",
            }}
            className="rounded-lg p-4"
          >
            <div className="text-[12px] text-white whitespace-nowrap flex justify-between items-center">
              ADR{" "}
              {!isIpad && (
                <div
                  className={`text-[11px] group ${data?.ADRPerDiff?.toString()?.includes("-") ? "bg-red-200 text-red-500" : "bg-[#ECFDF5] text-[#29CC39]"} w-fit px-2 py-1 rounded-lg text-[#101010]`}
                >
                  <span className="group-hover:hidden block">
                    {data?.ADRPerDiff ? Math.abs(data?.ADRPerDiff) : "--"}%
                  </span>
                  <span className="group-hover:block hidden">
                    {calculateDifference(
                      data?.ADRThisYear,
                      data?.ADRLastYear,
                      true
                    )}
                  </span>
                </div>
              )}
            </div>
            <div className="flex justify-between items-center">
              <div
                className={` ${isIpad ? "text-[12px]" : "text-[18px]"}  font-semibold text-[#ffffff]`}
              >
                {formatCurrency(data?.ADRThisYear)}
              </div>
            </div>

            <div
              className={` ${isIpad ? "text-[11px]" : "text-[14px]"}   text-[#ffffff]`}
            >
              {formatCurrency(data?.ADRLastYear)}{" "}
              <span className="text-xs" title="Same day last year">
                Last year
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const ChannelManagerPasswordModal = ({ hideModal }) => {
  const hid = CurrentProperty();
  const userID = UserId();
  const [updateCMPassword] = useUpdateCMPasswordMutation();
  const { data: channelManagerList } = useChannelManagerListQuery();
  const [selectedCM, setSelectedCM] = useState();
  const [selectedCMId, setSelectedCMId] = useState();
  const [userName, setUserName] = useState();
  const [propertyCode, setPropertyCode] = useState();
  const [password, setPassword] = useState();
  const [showCMlist, setShowCMlist] = useState(false);

  const handleSubmit = () => {
    const channelManagerBody = {
      hId: hid,
      // newhId: status ? propertyData?.hId : newHId,
      cmId: selectedCMId,
      userId: userID,
      userCredential: {
        username: userName,
        password: password,
        propertyCode: propertyCode,
      },
    };
    updateCMPassword(channelManagerBody)
      .unwrap()
      .then((res) => {
        toast.success("Channel Manager Credential Saved Successfully!", {
          position: "bottom-right",
        });
        hideModal();
      })
      .catch(() => {
        toast.error("Something Went Wrong!", {
          position: "bottom-right",
        });
        hideModal();
      });
  };
  return (
    <Backdrop>
      <div className="w-[70%] relative p-6 h-fit rounded-lg bg-white">
        <div className="text-3xl">Password Expired</div>
        <div className="text-xs my-2">
          Looks like your channel manager password is changed.
        </div>
        <div className="text-xs w-[45%]">
          We’re getting troubled in importing your data. Connect your channel
          manager for stream less integration
        </div>

        <div className="mt-6 flex flex-col gap-2">
          <div>
            <div className="text-[16px] my-2">Select Channel Manager</div>
            <div
              className={`border flex justify-between items-center ${showCMlist && "border-blue-400"} text-[16px] w-[400px] border cursor-pointer select-none p-2 text-sm rounded-lg relative`}
              onClick={() => setShowCMlist(!showCMlist)}
            >
              {selectedCM ? selectedCM : "Select Chanel Manager"}
              {showCMlist && (
                <div className="h-[200px] left-0 top-[30px] z-10 bg-white mt-4 absolute w-[400px] shadow-xl drop-shadow-md rounded-md overflow-y-scroll">
                  {channelManagerList?.data ? (
                    channelManagerList?.data?.map((item) => {
                      return (
                        <div
                          onClick={() => {
                            setSelectedCM(item?.cmname);
                            setSelectedCMId(item?.cmid);
                          }}
                          className="text-sm cursor-pointer hover:bg-gray-100 duration-150 ease-in-out p-2"
                        >
                          {item?.cmname}
                        </div>
                      );
                    })
                  ) : (
                    <span className="p-4 mt-2">Loading...</span>
                  )}
                </div>
              )}
              <div>
                <AiOutlineDown
                  className={`${showCMlist ? "rotate-180" : "rotate-0"}  transition-all duration-200 ease-in-out`}
                />
              </div>
            </div>
          </div>

          {selectedCM === "eZee" && (
            <div>
              <div className="text-[16px] my-2">Enter Property Code</div>
              <input
                placeholder="12345"
                value={propertyCode}
                onChange={(e) => setPropertyCode(e.target.value)}
                className={` flex justify-between items-center  text-[16px] w-[400px] border cursor-pointer select-none p-2 text-sm rounded-lg relative`}
              />
            </div>
          )}
          <div>
            <div className="text-[16px] my-2">Enter Username</div>
            <input
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
              placeholder="XYZ12"
              className={` flex justify-between items-center  text-[16px] w-[400px] border cursor-pointer select-none p-2 text-sm rounded-lg relative`}
            />
          </div>
          <div>
            <div className="text-[16px] my-2">Enter Password</div>
            <input
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="*****"
              type="password"
              className={` flex justify-between items-center  text-[16px] w-[400px] border cursor-pointer select-none p-2 text-sm rounded-lg relative`}
            />
          </div>
          <div className="mt-4">
            <button
              onClick={handleSubmit}
              className="w-fit px-2 py-1 bg-blue-500 hover:bg-blue-700 duration-150 ease-in-out transition-all text-white text-sm rounded-lg"
            >
              Save Credential
            </button>
          </div>
        </div>
        <div className="absolute top-0 right-4">
          <img src={passwordExpire} />
        </div>
      </div>
    </Backdrop>
  );
};

const HotelPerformanceTile = ({
  isOpen,
  setHotelPerformanceIsOpen,
  setIsRefreshing,
}) => {
  const [selectedDate, setSelectedDate] = useState(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1)
  );
  // const { data, isLoading, isFetching } = useGetHotelPerformanceDashboardQuery({
  //   hId: CurrentProperty(),
  // });
  const Chip = ({ label, color = "gray" }) => {
    const getBackgroundColor = () => {
      switch (color) {
        case "red":
          return "#f44336";
        case "green":
          return "#c6f0d0";
        case "yellow":
          return "#fff3c8";
        default:
          return "#e0e0e0"; // Default gray color
      }
    };

    const chipStyle = {
      display: "inline-block",
      padding: "2px 6px",
      borderRadius: "16px",
      // backgroundColor: getBackgroundColor(),
      backgroundColor: color,
      color:
        color === "green" ? "#3ca856" : color === "yellow" ? "#f8c059" : "#fff",
      // border:
      //   color === "green"
      //     ? "1px solid #55d875"
      //     : color === "yellow"
      //       ? "1px solid #f8c059"
      //       : "1px solid black",
      fontWeight: "bold",
      fontSize: "8px",
      textAlign: "center",
      cursor: "default",
    };

    return <div style={chipStyle}>{label}</div>;
  };
  const RadialProgress = ({
    percentage,
    size = 100,
    strokeWidth = 10,
    percentData,
    color = "white",
  }) => {
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (percentage / 100) * circumference;

    const getGradient = () => {
      if (percentage < 50) {
        return "url(#gradient-red-yellow)";
      } else if (percentage < 75) {
        return "url(#gradient-yellow-green)";
      } else {
        return "url(#gradient-green)";
      }
    };

    return (
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <defs>
          <linearGradient
            id="gradient-red-yellow"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="100%"
          >
            <stop offset="0%" stopColor="red" />
            <stop offset="100%" stopColor="yellow" />
          </linearGradient>
          <linearGradient
            id="gradient-yellow-green"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="100%"
          >
            <stop offset="0%" stopColor="yellow" />
            <stop offset="100%" stopColor="green" />
          </linearGradient>
          <linearGradient
            id="gradient-green"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="100%"
          >
            <stop offset="0%" stopColor="green" />
            <stop offset="100%" stopColor="darkgreen" />
          </linearGradient>
        </defs>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="#e6e6e6"
          strokeWidth={strokeWidth}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={getGradient()}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />

        {color === "black" ? (
          <text
            x="50%"
            y="50%"
            textAnchor="middle"
            dominantBaseline="middle"
            fontSize={size / 4} // Adjust font size as needed
            fill="black"
            className="font-[700]"
          >
            {percentData}%
          </text>
        ) : (
          <text
            x="50%"
            y="50%"
            textAnchor="middle"
            dominantBaseline="middle"
            fontSize={size / 4} // Adjust font size as needed
            fill="white"
            className="font-[700]"
          >
            {percentData}%
          </text>
        )}
      </svg>
    );
  };
  const RadialInfoComp = ({
    percentage,
    heading,
    description,
    isGreen = false,
    isChip,
    chipLabel,
    chipColor,
    percentData = 0,
  }) => {
    return (
      <div className="flex gap-4 ">
        <div>
          {" "}
          <RadialProgress
            percentData={percentData}
            percentage={percentage}
            size={50}
            strokeWidth={5}
          />
        </div>
        <div className="">
          <div className="flex items-center gap-2 ">
            <div
              className={`font-medium whitespace-nowrap ${isGreen ? "text-green-300" : heading === "Average Performance" ? "text-[#fff3c8]" : heading === "Need Attention" ? "text-[#f44336]" : "text-white"} `}
            >
              {heading}
            </div>
            {isChip && (
              <div className="-mt-2 w-[100%]">
                <Chip label={chipLabel} color={chipColor} />
              </div>
            )}
          </div>
          <div className="text-sm  text-white whitespace-nowrap">
            {description}
          </div>
        </div>
      </div>
    );
  };
  const SemiRadialProgress = ({
    percentage,
    size = 165,
    strokeWidth = 10,
    percentData = 0,
    isCurrency = false,
  }) => {
    const radius = (size - strokeWidth) / 2;
    const circumference = Math.PI * radius; // Half of a full circle's circumference
    const offset = circumference - (percentage / 100) * circumference;

    const getGradient = () => {
      if (percentage < 50) {
        return "url(#gradient-red-yellow)";
      } else if (percentage < 75) {
        return "url(#gradient-yellow-green)";
      } else {
        return "url(#gradient-green)";
      }
    };

    return (
      <svg
        width={size}
        height={size / 2} // Half the height for semi-circle
        viewBox={`0 0 ${size} ${size / 2}`}
        style={{ display: "block", margin: "auto" }}
      >
        <defs>
          <linearGradient
            id="gradient-red-yellow"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="100%"
          >
            <stop offset="0%" stopColor="red" />
            <stop offset="100%" stopColor="yellow" />
          </linearGradient>
          <linearGradient
            id="gradient-yellow-green"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="100%"
          >
            <stop offset="0%" stopColor="yellow" />
            <stop offset="100%" stopColor="green" />
          </linearGradient>
          <linearGradient
            id="gradient-green"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="100%"
          >
            <stop offset="0%" stopColor="green" />
            <stop offset="100%" stopColor="darkgreen" />
          </linearGradient>
        </defs>
        {/* Background circle (grey remaining part) */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="#e6e6e6"
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset="0"
          strokeLinecap="round"
          transform={`rotate(180 ${size / 2} ${size / 2})`} // Rotate 180 degrees to start at the top middle
        />
        {/* Foreground circle (colored part based on percentage) */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={getGradient()}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          transform={`rotate(180 ${size / 2} ${size / 2})`} // Rotate 180 degrees to start at the top middle
        />
        <text
          x="50%"
          y="100%"
          textAnchor="middle"
          dominantBaseline="middle"
          fontSize={size / 10}
          fill="#ffffff"
          dy="-10"
        >
          {isCurrency ? formatCurrency(percentData) : percentData}
        </text>
      </svg>
    );
  };
  const DetailsCard = ({
    title,
    progressPercentage = 0,
    previousPercentage,
    mainValue,
    percentData,
    isCurrency,
  }) => {
    return (
      <div className="p-2 relative  my-[10px] bg-[#1D2D44] text-white min-w-[250px] drop-shadow-sm rounded-2xl">
        <div className="flex items-center gap-2">
          <div>{title}</div>
          <div>
            <InfoToolTip />
          </div>
        </div>
        <div className="flex gap-2  flex-col justify-center items-center">
          <div className="flex gap-2 mt-[15px] flex-col justify-center items-center">
            <Chip label={"Need Attention"} color={"yellow"} />
            <div className="text-xl">
              {isCurrency ? formatCurrency(mainValue) : mainValue}
            </div>
            <div className="text-xs text-gray-300">
              <span
                className={`${previousPercentage?.toString().includes("-") ? "text-red-500" : "text-green-500"}`}
              >
                {previousPercentage}%
              </span>{" "}
              from STLY
            </div>
          </div>
          <div className="absolute bottom-0">
            <SemiRadialProgress
              percentData={percentData}
              percentage={previousPercentage}
              size={165}
              isCurrency={isCurrency}
            />
          </div>
        </div>
      </div>
    );
  };
  const navigate = useNavigate();
  // const {
  //   data: hotelPerformanceData,
  //   isLoading: hotelPerformanceIsLoadingg,
  //   isFetching: hotelPerformanceIsFetchingg,
  // } = useGetHotelPerformanceQuery({
  //   userId: UserId(),
  //   hId: CurrentProperty(),
  //   startDate: format(new Date(selectedDate), "yyyy-MM-dd"),
  //   // endDate: format(new Date(FirstPeriod[0].endDate), "yyyy-MM-dd"),
  //   // startDate1: format(new Date(SecondPeriod[0].startDate), "yyyy-MM-dd"),
  //   // endDate1: format(new Date(SecondPeriod[0].endDate), "yyyy-MM-dd"),
  // });
  const {
    data: hotelPerformanceDashBoardData,
    isLoading: hotelPerformanceIsLoading,
    isFetching: hotelPerformanceIsFetching,
  } = useGetHotelPerformanceDashboardQuery({
    userId: UserId(),
    hId: CurrentProperty(),
    startDate: format(new Date(selectedDate), "yyyy-MM-dd"),
  });
  const personalFormatter = (num) => {
    if (num > 0) {
      return num / 2 + 50;
    } else {
      return Math.abs(Math.abs(num / 2) - 50);
    }
  };
  const isIpad = useIsIpad();
  const svg = (
    <svg
      width="62"
      height="59"
      viewBox="0 0 62 59"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.78322 38.0957C11.4814 39.6044 13.4083 40.8338 15.4921 41.7382L26.3861 34.8974C27.4966 34.2071 28.8074 33.9117 30.1066 34.0589C31.4058 34.2061 32.6173 34.7873 33.5452 35.7085L37.2082 39.3715C42.6989 35.3235 46.1411 28.8471 46.1411 21.8189C46.1411 9.78769 36.3535 0 24.3223 0C12.2911 0 2.50342 9.78769 2.50342 21.8189C2.50392 24.8913 3.15256 27.9291 4.40697 30.7339C5.66138 33.5386 7.49335 36.0472 9.78322 38.0957ZM25.2977 23.7441H23.3469C21.9835 23.7459 20.6689 23.2364 19.6629 22.3162C18.6569 21.3959 18.0326 20.1319 17.9133 18.7737C17.794 17.4155 18.1884 16.062 19.0185 14.9805C19.8487 13.8989 21.0542 13.168 22.3971 12.9322V10.9094C22.3971 10.3988 22.5999 9.90916 22.961 9.54811C23.322 9.18707 23.8117 8.98424 24.3223 8.98424C24.8329 8.98424 25.3226 9.18707 25.6836 9.54811C26.0446 9.90916 26.2475 10.3988 26.2475 10.9094V12.8346H28.8144C29.325 12.8346 29.8147 13.0375 30.1757 13.3985C30.5368 13.7595 30.7396 14.2492 30.7396 14.7598C30.7396 15.2704 30.5368 15.7601 30.1757 16.1211C29.8147 16.4822 29.325 16.685 28.8144 16.685H23.3469C22.9248 16.685 22.52 16.8527 22.2215 17.1512C21.923 17.4496 21.7554 17.8544 21.7554 18.2765C21.7554 19.1801 22.469 19.8937 23.3469 19.8937H25.2977C26.6611 19.8918 27.9756 20.4013 28.9816 21.3216C29.9876 22.2418 30.6119 23.5059 30.7312 24.864C30.8505 26.2222 30.4562 27.5757 29.626 28.6573C28.7959 29.7388 27.5903 30.4697 26.2475 30.7056V32.7257C26.2475 33.2363 26.0446 33.726 25.6836 34.087C25.3226 34.4481 24.8329 34.6509 24.3223 34.6509C23.8117 34.6509 23.322 34.4481 22.961 34.087C22.5999 33.726 22.3971 33.2363 22.3971 32.7257V30.8031H19.8302C19.3196 30.8031 18.8299 30.6003 18.4688 30.2392C18.1078 29.8782 17.905 29.3885 17.905 28.8779C17.905 28.3673 18.1078 27.8776 18.4688 27.5166C18.8299 27.1555 19.3196 26.9527 19.8302 26.9527H25.2977C25.7198 26.9527 26.1246 26.785 26.4231 26.4866C26.7215 26.1881 26.8892 25.7833 26.8892 25.3612C26.8916 25.1504 26.8522 24.9411 26.7734 24.7455C26.6946 24.5499 26.5778 24.3718 26.4299 24.2215C26.282 24.0712 26.1058 23.9516 25.9115 23.8697C25.7172 23.7878 25.5086 23.7451 25.2977 23.7441Z"
        fill="white"
      />
      <path
        d="M58.9766 28.2363H48.7089C48.2013 28.2364 47.7051 28.387 47.2831 28.6691C46.8611 28.9512 46.5322 29.352 46.3379 29.821C46.1437 30.29 46.0929 30.806 46.1919 31.3039C46.2909 31.8017 46.5352 32.2591 46.8941 32.6181L50.2132 35.9371L39.7247 46.4256L31.2718 37.9727C30.8627 37.5639 30.3276 37.3053 29.7531 37.2386C29.1787 37.172 28.5986 37.3013 28.1068 37.6056L1.15407 54.2906C0.596337 54.6583 0.203913 55.2289 0.0601521 55.8813C-0.0836092 56.5337 0.0326181 57.2164 0.384148 57.7845C0.735677 58.3526 1.29481 58.7612 1.9428 58.9236C2.59078 59.0861 3.27656 58.9895 3.85448 58.6544L29.0771 43.0398L37.9073 51.87C38.1455 52.1086 38.4284 52.2979 38.7398 52.427C39.0512 52.5562 39.385 52.6226 39.7221 52.6226C40.0593 52.6226 40.3931 52.5562 40.7045 52.427C41.0159 52.2979 41.2988 52.1086 41.5369 51.87L53.8428 39.5667L57.1618 42.8858C57.5208 43.2447 57.9781 43.489 58.476 43.588C58.9739 43.687 59.4899 43.6362 59.9589 43.442C60.4279 43.2477 60.8287 42.9188 61.1108 42.4968C61.3929 42.0747 61.5435 41.5786 61.5436 41.071V30.8033C61.5436 30.1225 61.2731 29.4696 60.7917 28.9882C60.3103 28.5068 59.6574 28.2363 58.9766 28.2363Z"
        fill="white"
      />
    </svg>
  );

  const NewCard = ({
    title,
    value,
    isCurrency,
    description,
    chipLabel,
    chipColor,
    percentage,
  }) => {
    return (
      <div className="p-4 mb-4 bg-[#00000066] relative rounded-3xl min-w-[300px] flex flex-col text-white ">
        <div className="text-sm font-semibold">{title}</div>
        <div>
          <span className="text-[24px]">{value}</span>
        </div>
        <div
          className="text-sm max-w-[60%] truncate"
          data-tooltip-id={title}
          data-tooltip-content={description}
        >
          {description}
          <Tooltip id={title} />
        </div>
        <div className="w-[50%]">
          <Chip label={chipLabel} color={chipColor} />
        </div>
        <div className=" absolute top-8 right-8">
          <RadialProgress
            percentData={percentage}
            percentage={percentage}
            size={65}
            strokeWidth={6}
          />
        </div>
        <div
          className={`bg-gradient-to-br absolute -right-3 z-30 ${title === "Competitor" ? "p-1" : "p-3"} rounded-lg -bottom-4 from-[#1058B2] to-[#2E98E4]`}
        >
          {title === "Cancellations" ? (
            <svg
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <line
                x1="1.26055"
                y1="24.3273"
                x2="22.1696"
                y2="1.32733"
                stroke="white"
                stroke-width="2"
              />
              <path
                d="M22.979 4.69531C23.3511 4.69531 23.6528 4.39363 23.6528 4.02148C23.6528 3.64934 23.3511 3.34766 22.979 3.34766C22.6069 3.34766 22.3052 3.64934 22.3052 4.02148C22.3052 4.39363 22.6069 4.69531 22.979 4.69531Z"
                fill="white"
              />
              <path
                d="M24.3267 10.1309C24.6988 10.1309 25.0005 9.82918 25.0005 9.45703C25.0005 9.08489 24.6988 8.7832 24.3267 8.7832C23.9545 8.7832 23.6528 9.08489 23.6528 9.45703C23.6528 9.82918 23.9545 10.1309 24.3267 10.1309Z"
                fill="white"
              />
              <path
                d="M13.5454 25C18.457 25 22.8152 21.8255 24.3905 17.1679C24.4866 16.8843 24.3833 16.571 24.1378 16.3993C23.893 16.2289 23.5633 16.2394 23.3291 16.4276C21.8768 17.5982 20.1244 18.2168 18.2622 18.2168C13.8034 18.2168 10.1313 14.5897 10.1313 10.1309C10.1313 7.34278 11.5917 4.74073 13.9633 3.24631C14.2173 3.08639 14.3054 2.77647 14.2219 2.48826C14.139 2.20004 13.8455 2 13.5454 2C7.22895 2 2.00049 7.18354 2.00049 13.5C2.00049 19.8165 7.22895 25 13.5454 25Z"
                fill="white"
              />
              <path
                d="M14.8931 7.43555C16.0078 7.43555 16.9146 8.34234 16.9146 9.45703C16.9146 9.82948 17.2159 10.1309 17.5884 10.1309C17.9608 10.1309 18.2622 9.82948 18.2622 9.45703C18.2622 8.34234 19.169 7.43555 20.2837 7.43555C20.6561 7.43555 20.9575 7.13417 20.9575 6.76172C20.9575 6.38927 20.6561 6.08789 20.2837 6.08789C19.169 6.08789 18.2622 5.13618 18.2622 4.02148C18.2622 3.64904 17.9608 3.34766 17.5884 3.34766C17.2159 3.34766 16.9146 3.64904 16.9146 4.02148C16.9146 5.13618 16.0078 6.08789 14.8931 6.08789C14.5206 6.08789 14.2192 6.38927 14.2192 6.76172C14.2192 7.13417 14.5206 7.43555 14.8931 7.43555Z"
                fill="white"
              />
            </svg>
          ) : title === "Competitor" ? (
            <svg
              width="42"
              height="43"
              viewBox="0 0 42 43"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.371582"
                y="0.925781"
                width="41.6284"
                height="41.6284"
                rx="8.32568"
                fill="url(#paint0_linear_5983_7824)"
              />
              <path
                d="M7.00049 22.9093C7.00049 25.8227 8.00187 28.6452 9.82276 30.9213L10.1871 31.331L20.4752 21.0429L28.1684 13.3041L27.7587 12.9853C22.2961 8.56981 14.2841 9.43467 9.86834 14.8974C8.00187 17.1735 7.00049 19.996 7.00049 22.9093ZM15.7407 15.8078L15.7862 15.6257H19.1548L19.2004 15.8078C19.246 16.2174 19.1548 16.6271 18.9272 16.9459L18.3811 17.7652V19.2676H16.5602V17.7652L16.0139 16.9459C15.7862 16.6271 15.6953 16.2174 15.7407 15.8078ZM16.0138 14.7153C16.4235 13.8958 17.3795 13.5772 18.199 13.9869C18.5176 14.1234 18.7908 14.3966 18.9272 14.7153H16.0138ZM16.1959 20.1779H17.0154V23.1825L14.7393 25.4586V23.3646H13.8288V26.369L12.0079 28.1899V23.137C12.0079 22.6362 12.2811 22.1354 12.7817 21.9077L16.1959 20.1779ZM17.9259 22.272V20.178H18.7452L19.6101 20.5877L17.9259 22.272ZM20.2476 19.9504L19.2916 19.4496V18.0383L19.7012 17.4467C20.0653 16.9459 20.202 16.3086 20.1109 15.6713L20.0199 15.0794C19.8377 13.6682 18.5176 12.7123 17.1519 12.8944C16.0139 13.0765 15.1489 13.9413 14.9669 15.0794L14.8758 15.6713C14.7849 16.3086 14.9213 16.9459 15.2854 17.4467L15.6953 18.0383V19.4495L12.3721 21.0885C11.5983 21.4525 11.0975 22.272 11.0975 23.137V29.1457L10.2326 30.0108C6.36323 24.7302 7.45577 17.3099 12.6908 13.3952C16.8787 10.2995 22.6146 10.2995 26.7572 13.3952L20.2476 19.9504ZM31.1729 13.5773L13.1461 31.6041L13.5557 31.9227C19.0184 36.3384 27.0303 35.5189 31.4915 30.0562C35.2699 25.3674 35.2699 18.6757 31.4915 13.9869L31.1729 13.5773ZM26.2564 24.275H29.625L29.7161 24.9123C29.7161 25.0034 29.7161 25.1399 29.625 25.231L28.8512 26.4144V28.1899L27.9408 29.1004L27.0303 28.1899V26.4144L26.2564 25.231C26.2108 25.1399 26.1655 25.0034 26.1655 24.9123L26.2564 24.275ZM26.3931 23.3646L26.484 22.8638C26.5295 22.6362 26.7116 22.4541 26.9392 22.4541H28.9877C29.2153 22.4541 29.3974 22.6362 29.443 22.8638L29.5341 23.3645L26.3931 23.3646ZM26.484 28.9181L27.4856 29.9197V32.2414C25.9378 33.1518 24.2535 33.6526 22.4781 33.7891V31.1942C22.4781 31.0122 22.569 30.8758 22.7513 30.7846L26.484 28.9181ZM28.396 31.6495V29.9198L29.3974 28.9182L30.6721 29.5557C29.9893 30.375 29.2609 31.0579 28.396 31.6495V31.6495ZM31.2183 28.8273L29.7617 28.0988V26.6876L30.399 25.7316C30.581 25.4586 30.6721 25.0943 30.6266 24.7758L30.3534 22.7273C30.2625 22.0444 29.6706 21.5437 28.9877 21.5437H26.9392C26.2564 21.5437 25.6647 22.0444 25.5736 22.7273L25.3004 24.7758C25.255 25.0943 25.3459 25.4586 25.528 25.7316L26.1655 26.6876V28.0988L22.387 30.0108C21.9318 30.2384 21.6132 30.6937 21.6132 31.2398V33.8347C19.064 33.8347 16.6058 33.0151 14.5573 31.513L31.1274 14.9429C34.1319 19.0399 34.1772 24.6391 31.2183 28.8273Z"
                fill="white"
              />
              <path
                d="M28.993 19.8474L30.8278 18.0125L31.4714 18.6564L29.6368 20.4911L28.993 19.8474ZM17.61 31.6852L18.9621 30.3333L19.6059 30.977L18.254 32.3291L17.61 31.6852ZM19.893 28.4919L22.6292 25.7557L23.273 26.3997L20.537 29.1357L19.893 28.4919ZM28.5356 12.1108L29.8875 10.7589L30.5312 11.4026L29.1793 12.7548L28.5356 12.1108ZM26.7191 10.2855L29.0046 8L29.6483 8.64374L27.3631 10.9292L26.7191 10.2855ZM9.42285 35.3201L12.1591 32.5841L12.8028 33.2278L10.0668 35.964L9.42285 35.3201ZM12.6025 35.327L13.9547 33.9751L14.5984 34.6188L13.2465 35.9707L12.6025 35.327ZM22.1625 14.3869L23.5144 13.035L24.1581 13.6787L22.8062 15.0306L22.1625 14.3869ZM9.6656 19.6322L12.1764 17.1215L12.8202 17.7652L10.3096 20.2761L9.6656 19.6322ZM24.2985 31.1037H26.1194V32.0142H24.2985V31.1037Z"
                fill="white"
              />
              <defs>
                {/* <linearGradient id="paint0_linear_5983_7824" x1="21.1858" y1="0.925781" x2="21.1858" y2="42.5542" gradientUnits="userSpaceOnUse">
<stop stop-color="#1058B2"/>
<stop offset="1" stop-color="#2E98E4"/>
</linearGradient> */}
              </defs>
            </svg>
          ) : title === "Ranks" ? (
            <svg
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.84182 15.8948H2.50213C1.12623 15.8948 0.000488281 17.0205 0.000488281 18.3964V24.6505C0.000488281 25.3385 0.563357 25.9014 1.25131 25.9014H5.84182C6.52977 25.9014 7.09264 25.3385 7.09264 24.6505V17.1456C7.09264 16.4577 6.52977 15.8948 5.84182 15.8948ZM14.1723 10.8915H10.8326C9.45669 10.8915 8.33095 12.0173 8.33095 13.3932V24.6505C8.33095 25.3385 8.89382 25.9014 9.58177 25.9014H15.4231C16.1111 25.9014 16.6739 25.3385 16.6739 24.6505V13.3932C16.6739 12.7297 16.4104 12.0934 15.9412 11.6242C15.4721 11.1551 14.8358 10.8915 14.1723 10.8915ZM22.5153 19.6473H19.1756C18.4876 19.6473 17.9247 20.2101 17.9247 20.8981V24.6505C17.9247 25.3385 18.4876 25.9014 19.1756 25.9014H23.7661C24.454 25.9014 25.0169 25.3385 25.0169 24.6505V22.1489C25.0169 20.773 23.8912 19.6473 22.5153 19.6473ZM16.2737 4.44979C16.6614 4.06204 16.8115 3.59924 16.6864 3.19897C16.5614 2.79871 16.1736 2.51102 15.6232 2.42346L14.4224 2.22333C14.3724 2.22333 14.2598 2.13578 14.2348 2.08574L13.5719 0.759874C13.0716 -0.253291 11.9333 -0.253291 11.433 0.759874L10.7701 2.08574C10.7575 2.13578 10.645 2.22333 10.5949 2.22333L9.39415 2.42346C8.84379 2.51102 8.46854 2.79871 8.33095 3.19897C8.20587 3.59924 8.35597 4.06204 8.74372 4.44979L9.66933 5.38791C9.71936 5.42543 9.75689 5.57553 9.74438 5.62557L9.48171 6.77632C9.28158 7.63939 9.60679 8.02714 9.81943 8.17724C10.0321 8.32734 10.4949 8.52747 11.2579 8.07717L12.3836 7.41424C12.4336 7.37671 12.5963 7.37671 12.6463 7.41424L13.7595 8.07717C14.1097 8.28981 14.3974 8.35235 14.6226 8.35235C14.8853 8.35235 15.0729 8.25229 15.1854 8.17724C15.3981 8.02714 15.7233 7.63939 15.5232 6.77632L15.2605 5.62557C15.248 5.56302 15.2855 5.42543 15.3355 5.38791L16.2737 4.44979Z"
                fill="white"
              />
            </svg>
          ) : title === "Room Nights" ? (
            <svg
              width="26"
              height="26"
              viewBox="0 0 512 512"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M467 60C475.284 60 482 53.2843 482 45C482 36.7157 475.284 30 467 30C458.716 30 452 36.7157 452 45C452 53.2843 458.716 60 467 60Z"
                fill="white"
              />
              <path
                d="M497 181C505.284 181 512 174.284 512 166C512 157.716 505.284 151 497 151C488.716 151 482 157.716 482 166C482 174.284 488.716 181 497 181Z"
                fill="white"
              />
              <path
                d="M257 512C366.336 512 463.353 441.332 498.421 337.65C500.56 331.337 498.26 324.364 492.796 320.541C487.347 316.747 480.008 316.981 474.793 321.171C442.464 347.23 403.455 361 362 361C262.742 361 181 280.258 181 181C181 118.935 213.509 61.011 266.302 27.744C271.956 24.184 273.919 17.285 272.059 10.869C270.213 4.453 263.68 0 257 0C116.39 0 0 115.39 0 256C0 396.61 116.39 512 257 512Z"
                fill="white"
              />
              <path
                d="M287 121C311.814 121 332 141.186 332 166C332 174.291 338.709 181 347 181C355.291 181 362 174.291 362 166C362 141.186 382.186 121 407 121C415.291 121 422 114.291 422 106C422 97.709 415.291 91 407 91C382.186 91 362 69.814 362 45C362 36.709 355.291 30 347 30C338.709 30 332 36.709 332 45C332 69.814 311.814 91 287 91C278.709 91 272 97.709 272 106C272 114.291 278.709 121 287 121Z"
                fill="white"
              />
            </svg>
          ) : title === "Lead" ? (
            <svg
              width="26"
              height="26"
              viewBox="0 0 512 512"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_6096_9665)">
                <path
                  d="M437.02 74.981C388.668 26.629 324.38 0 256 0C187.62 0 123.332 26.629 74.98 74.981C26.628 123.333 0 187.62 0 256C0 324.38 26.628 388.668 74.98 437.019C123.332 485.37 187.62 512 256 512C324.38 512 388.668 485.371 437.02 437.019C485.372 388.667 512 324.38 512 256C512 187.62 485.372 123.332 437.02 74.981ZM256 461.752C142.547 461.752 50.248 369.452 50.248 256C50.248 255.814 50.254 255.63 50.255 255.446C50.255 255.399 50.248 255.354 50.248 255.307C50.248 255.228 50.258 255.152 50.26 255.074C50.759 142.981 141.346 51.784 253.204 50.284C253.438 50.273 253.67 50.249 253.907 50.249C254.049 50.249 254.187 50.266 254.328 50.27C254.886 50.266 255.442 50.249 256.001 50.249C369.454 50.249 461.753 142.549 461.753 256.001C461.753 369.453 369.453 461.752 256 461.752Z"
                  fill="white"
                />
                <path
                  d="M412.287 268.36C403.921 268.36 397.139 261.578 397.139 253.212C397.139 244.846 403.921 238.064 412.287 238.064H430.546C421.97 153.988 353.784 87.2913 269.054 81.0293V96.9243C269.054 105.29 262.272 112.072 253.906 112.072C245.54 112.072 238.758 105.29 238.758 96.9243V81.3913C155.282 89.5713 88.7891 156.493 81.2661 240.157H97.6181C105.984 240.157 112.766 246.939 112.766 255.305C112.766 263.671 105.984 270.453 97.6181 270.453H81.1421C88.1071 355.464 155.933 423.498 240.852 430.795V411.592C240.852 403.226 247.634 396.444 256 396.444C264.366 396.444 271.148 403.226 271.148 411.592V430.795C356.762 423.438 425.001 354.344 431.015 268.36H412.287ZM317.32 216.102L266.712 266.711C265.306 268.118 263.636 269.234 261.798 269.995C259.96 270.757 257.99 271.149 256.001 271.149C254.012 271.149 252.042 270.757 250.204 269.995C248.366 269.234 246.697 268.118 245.29 266.711L157.197 178.618C151.281 172.703 151.281 163.112 157.197 157.196C163.112 151.28 172.703 151.28 178.619 157.196L256.002 234.578L295.9 194.68C301.815 188.764 311.406 188.764 317.322 194.68C323.236 200.595 323.236 210.187 317.32 216.102Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_6096_9665">
                  <rect width="512" height="512" fill="white" />
                </clipPath>
              </defs>
            </svg>
          ) : title === "Reputation" ? (
            <svg
              width="26"
              height="26"
              viewBox="0 0 512 512"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M217.007 17.8196L230.628 53.6946C230.818 54.2146 231.159 54.6661 231.607 54.9915C232.055 55.3169 232.59 55.5015 233.143 55.5216L271.471 57.3896C274.078 57.5166 275.145 60.8006 273.111 62.4356L243.201 86.4756C242.765 86.8172 242.441 87.2808 242.27 87.8072C242.099 88.3337 242.089 88.8992 242.24 89.4316L252.308 126.461C252.993 128.979 250.2 131.009 248.016 129.579L215.909 108.562C215.45 108.253 214.909 108.088 214.355 108.088C213.801 108.088 213.26 108.253 212.801 108.562L180.695 129.579C178.511 131.009 175.718 128.979 176.403 126.461L186.47 89.4306C186.622 88.8983 186.611 88.3328 186.441 87.8063C186.27 87.2798 185.946 86.8162 185.51 86.4746L155.6 62.4346C153.566 60.7996 154.633 57.5156 157.24 57.3886L195.568 55.5206C196.121 55.5003 196.656 55.3157 197.104 54.9903C197.552 54.6649 197.893 54.2135 198.083 53.6936L211.704 17.8186C212.623 15.3936 216.087 15.3936 217.007 17.8196ZM402.322 321.654C450.466 321.654 489.495 360.683 489.495 408.827C489.495 456.971 450.466 496 402.322 496C354.178 496 315.149 456.971 315.149 408.827C315.149 360.683 354.178 321.654 402.322 321.654ZM390.872 416.516L371.394 397.038C366.346 391.99 358.157 391.99 353.108 397.038C348.06 402.086 348.06 410.275 353.108 415.323L381.757 443.972C386.805 449.02 394.994 449.02 400.042 443.972C417.31 426.704 434.383 409.241 451.571 391.893C456.583 386.835 456.567 378.672 451.515 373.648C446.462 368.623 438.277 368.637 433.259 373.705L390.872 416.516ZM70.891 449.21L307.355 449.209C302.074 436.806 299.15 423.158 299.15 408.827C299.15 387.031 305.915 366.818 317.451 350.161C290.058 325.738 253.944 310.892 214.357 310.892C138.154 310.892 74.801 365.887 61.807 438.351C61.5622 439.68 61.6136 441.047 61.9575 442.355C62.3015 443.662 62.9296 444.878 63.7971 445.915C64.6646 446.952 65.75 447.785 66.9762 448.354C68.2024 448.924 69.5391 449.216 70.891 449.21ZM214.357 144.159C257.637 144.159 292.723 179.245 292.723 222.525C292.723 265.805 257.637 300.891 214.357 300.891C171.077 300.891 135.991 265.805 135.991 222.525C135.99 179.245 171.076 144.159 214.357 144.159ZM349.036 68.5996C348.115 66.1736 344.651 66.1736 343.73 68.5996L330.109 104.475C329.919 104.995 329.578 105.446 329.13 105.772C328.682 106.097 328.147 106.282 327.594 106.302L289.266 108.17C286.659 108.297 285.592 111.581 287.626 113.216L317.536 137.256C317.972 137.597 318.296 138.061 318.467 138.587C318.638 139.114 318.648 139.679 318.496 140.212L308.429 177.242C307.744 179.761 310.537 181.79 312.721 180.36L344.827 159.343C345.286 159.034 345.827 158.869 346.381 158.869C346.935 158.869 347.476 159.034 347.935 159.343L380.042 180.36C382.226 181.79 385.019 179.76 384.334 177.242L374.266 140.213C374.114 139.68 374.124 139.115 374.295 138.588C374.466 138.062 374.79 137.598 375.226 137.257L405.136 113.217C407.17 111.582 406.103 108.298 403.496 108.171L365.168 106.303C364.615 106.282 364.08 106.098 363.632 105.772C363.184 105.447 362.843 104.996 362.653 104.476L349.036 68.5996ZM84.978 68.5996C84.057 66.1736 80.593 66.1736 79.673 68.5996L66.052 104.475C65.8619 104.995 65.5211 105.446 65.0731 105.772C64.6252 106.097 64.0903 106.282 63.537 106.302L25.209 108.17C22.602 108.297 21.535 111.581 23.569 113.216L53.479 137.256C53.9147 137.597 54.2387 138.061 54.4097 138.587C54.5807 139.114 54.5909 139.679 54.439 140.212L44.372 177.242C43.687 179.761 46.48 181.79 48.664 180.36L80.77 159.343C81.2294 159.034 81.7704 158.869 82.324 158.869C82.8776 158.869 83.4187 159.034 83.878 159.343L115.985 180.36C118.169 181.79 120.962 179.76 120.277 177.242L110.21 140.213C110.058 139.68 110.068 139.115 110.239 138.588C110.41 138.062 110.734 137.598 111.17 137.257L141.08 113.217C143.114 111.582 142.047 108.298 139.44 108.171L101.112 106.303C100.559 106.282 100.024 106.098 99.5761 105.772C99.1282 105.447 98.7873 104.996 98.597 104.476L84.978 68.5996Z"
                fill="white"
              />
            </svg>
          ) : title === "ADR" ? (
            <svg
              width="26"
              height="26"
              viewBox="0 0 512 512"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M52.496 153.011C45.32 148.866 36.148 151.327 32.008 158.499C27.863 165.675 30.324 174.847 37.496 178.987C44.668 183.132 53.844 180.671 57.984 173.499C62.129 166.323 59.668 157.151 52.496 153.011ZM434.996 121.003H419.996V106.003C419.996 97.7135 413.289 91.0035 404.996 91.0035C396.707 91.0035 389.996 97.7135 389.996 106.003V121.003H374.996C366.707 121.003 359.996 127.713 359.996 136.003C359.996 144.296 366.707 151.003 374.996 151.003H389.996V166.003C389.996 174.292 396.707 181.003 404.996 181.003C413.289 181.003 419.996 174.292 419.996 166.003V151.003H434.996C443.286 151.003 449.996 144.296 449.996 136.003C449.996 127.713 443.286 121.003 434.996 121.003ZM30 75.0035C30 83.2965 36.707 90.0035 45 90.0035C53.29 90.0035 60 83.2965 60 75.0035V60.0035H75C83.29 60.0035 90 53.2965 90 45.0035C90 36.7135 83.29 30.0035 75 30.0035H60V15.0035C60 6.71347 53.29 0.00346548 45 0.00346548C36.707 0.00346548 30 6.71347 30 15.0035V30.0035H15C6.71 30.0035 0 36.7135 0 45.0035C0 53.2965 6.71 60.0035 15 60.0035H30V75.0035ZM124.746 28.0425C139.023 56.6045 146.953 88.1365 148.949 120.002H301.051C303.043 88.1405 310.973 56.6045 325.25 28.0425L328.414 21.7145C329.822 18.8988 330.309 15.7113 329.804 12.6039C329.299 9.49639 327.829 6.62664 325.602 4.40147C321.047 -0.168535 314.074 -1.29753 308.289 1.58947L257.957 26.7535L235.602 4.40147C229.742 -1.45753 220.25 -1.45753 214.391 4.40147L192.039 26.7535L141.707 1.58547C135.907 -1.29753 128.98 -0.184535 124.395 4.40147C122.168 6.62636 120.697 9.49607 120.192 12.6036C119.687 15.7112 120.174 18.8988 121.582 21.7145L124.746 28.0425ZM316.836 151.003H133.156L74.59 221.886C45.836 256.706 30 301.779 30 347.003C30 447.237 106.54 511.999 224.996 511.999C343.457 511.999 419.996 447.237 419.996 347.003C419.996 301.78 404.16 257.706 375.391 222.886L316.836 151.003ZM224.836 306.397C249.652 306.397 269.836 326.581 269.836 351.397C269.836 370.867 257.336 387.323 239.996 393.581V407.003C239.996 415.292 233.289 422.003 224.996 422.003C216.707 422.003 210 415.292 210 407.003V393.683C192.492 387.515 179.836 370.983 179.836 351.397C179.836 343.104 186.546 336.397 194.836 336.397C203.129 336.397 209.836 343.104 209.836 351.397C209.836 359.675 216.562 366.397 224.836 366.397C233.113 366.397 239.836 359.675 239.836 351.397C239.836 343.12 233.113 336.397 224.836 336.397C200.023 336.397 179.836 316.21 179.836 291.397C179.836 271.807 192.492 255.28 210 249.112V227.002C210 218.714 216.707 212.002 224.996 212.002C233.289 212.002 239.996 218.714 239.996 227.002V249.214C257.336 255.472 269.836 271.929 269.836 291.397C269.836 299.69 263.129 306.397 254.836 306.397C246.546 306.397 239.836 299.69 239.836 291.397C239.836 283.124 233.113 276.397 224.836 276.397C216.562 276.397 209.836 283.124 209.836 291.397C209.836 299.675 216.559 306.397 224.836 306.397Z"
                fill="white"
              />
            </svg>
          ) : (
            <svg
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.96757 15.4503C4.6563 16.0622 5.43779 16.5608 6.28289 16.9276L10.7011 14.1532C11.1515 13.8732 11.6831 13.7534 12.21 13.8131C12.737 13.8728 13.2283 14.1085 13.6046 14.4821L15.0902 15.9677C17.317 14.326 18.7131 11.6994 18.7131 8.84898C18.7131 3.96955 14.7436 0 9.86412 0C4.98469 0 1.01514 3.96955 1.01514 8.84898C1.01534 10.0951 1.2784 11.3271 1.78715 12.4646C2.2959 13.6021 3.03888 14.6195 3.96757 15.4503ZM10.2597 9.62978H9.46852C8.91557 9.63053 8.38245 9.42389 7.97445 9.05067C7.56646 8.67745 7.31326 8.1648 7.26487 7.61397C7.21648 7.06314 7.37643 6.5142 7.71311 6.07556C8.04979 5.63693 8.53872 5.34051 9.08333 5.24484V4.42449C9.08333 4.21741 9.16559 4.01882 9.31202 3.87239C9.45844 3.72596 9.65704 3.6437 9.86412 3.6437C10.0712 3.6437 10.2698 3.72596 10.4162 3.87239C10.5627 4.01882 10.6449 4.21741 10.6449 4.42449V5.20528H11.686C11.8931 5.20528 12.0916 5.28755 12.2381 5.43397C12.3845 5.5804 12.4668 5.779 12.4668 5.98608C12.4668 6.19316 12.3845 6.39175 12.2381 6.53818C12.0916 6.68461 11.8931 6.76687 11.686 6.76687H9.46852C9.29733 6.76687 9.13316 6.83487 9.01211 6.95592C8.89107 7.07697 8.82306 7.24114 8.82306 7.41232C8.82306 7.77878 9.11248 8.06819 9.46852 8.06819H10.2597C10.8127 8.06744 11.3458 8.27408 11.7538 8.6473C12.1618 9.02052 12.415 9.53317 12.4634 10.084C12.5118 10.6348 12.3518 11.1838 12.0151 11.6224C11.6785 12.061 11.1895 12.3575 10.6449 12.4531V13.2724C10.6449 13.4795 10.5627 13.6781 10.4162 13.8245C10.2698 13.971 10.0712 14.0532 9.86412 14.0532C9.65704 14.0532 9.45844 13.971 9.31202 13.8245C9.16559 13.6781 9.08333 13.4795 9.08333 13.2724V12.4927H8.04227C7.83519 12.4927 7.63659 12.4104 7.49017 12.264C7.34374 12.1176 7.26148 11.919 7.26148 11.7119C7.26148 11.5048 7.34374 11.3062 7.49017 11.1598C7.63659 11.0134 7.83519 10.9311 8.04227 10.9311H10.2597C10.4309 10.9311 10.5951 10.8631 10.7161 10.742C10.8372 10.621 10.9052 10.4568 10.9052 10.2856C10.9061 10.2001 10.8902 10.1153 10.8582 10.0359C10.8262 9.9566 10.7789 9.88437 10.7189 9.82342C10.6589 9.76246 10.5875 9.71397 10.5087 9.68073C10.4298 9.6475 10.3452 9.63018 10.2597 9.62978Z"
                fill="white"
              />
              <path
                d="M23.9189 11.4512H19.7547C19.5488 11.4512 19.3476 11.5123 19.1764 11.6267C19.0053 11.7411 18.8719 11.9037 18.7931 12.0939C18.7143 12.2841 18.6937 12.4934 18.7338 12.6953C18.774 12.8972 18.8731 13.0827 19.0186 13.2283L20.3647 14.5743L16.111 18.8281L12.6828 15.3999C12.5169 15.2341 12.2998 15.1292 12.0669 15.1022C11.8339 15.0752 11.5986 15.1276 11.3992 15.251L0.468053 22.0179C0.241854 22.167 0.0827003 22.3985 0.0243956 22.663C-0.033909 22.9276 0.0132288 23.2045 0.155797 23.4349C0.298365 23.6653 0.525132 23.831 0.787932 23.8969C1.05073 23.9628 1.32886 23.9236 1.56324 23.7877L11.7927 17.4549L15.3739 21.0362C15.4705 21.1329 15.5852 21.2097 15.7115 21.2621C15.8378 21.3145 15.9732 21.3414 16.1099 21.3414C16.2467 21.3414 16.382 21.3145 16.5083 21.2621C16.6346 21.2097 16.7494 21.1329 16.846 21.0362L21.8368 16.0464L23.1829 17.3925C23.3285 17.538 23.514 17.6371 23.7159 17.6773C23.9178 17.7175 24.1271 17.6968 24.3173 17.6181C24.5075 17.5393 24.67 17.4059 24.7844 17.2347C24.8988 17.0636 24.9599 16.8623 24.96 16.6565V12.4922C24.96 12.2161 24.8503 11.9513 24.655 11.7561C24.4598 11.5609 24.195 11.4512 23.9189 11.4512Z"
                fill="white"
              />
            </svg>
          )}
        </div>
      </div>
    );
  };

  const currentDate = new Date();
  const previousMonthDate = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    1
  ); // Sets date to the 1st of the previous month

  const [selectedMonth, setSelectedMonth] = useState(
    new Date(previousMonthDate).getMonth()
  );
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  console.log(selectedMonth);
  function getNextMonth(dateInput) {
    // Create a Date object from the input
    const date = new Date(dateInput);

    // Check if the date is valid
    if (isNaN(date)) {
      return "Invalid date";
    }

    // Move to the next month
    const nextMonth = new Date(date.getFullYear(), date.getMonth() + 1, 1);
    setSelectedMonth(nextMonth.getMonth());
    setSelectedYear(nextMonth.getFullYear());
    return nextMonth;
  }

  function getPreviousMonth(dateInput) {
    // Create a Date object from the input
    const date = new Date(dateInput);

    // Check if the date is valid
    if (isNaN(date)) {
      return "Invalid date";
    }

    // Move to the previous month
    const previousMonth = new Date(date.getFullYear(), date.getMonth() - 1, 1);

    // Set the selected month and year
    setSelectedMonth(previousMonth.getMonth());
    setSelectedYear(previousMonth.getFullYear());

    return previousMonth;
  }

  useEffect(() => {
    if (
      hotelPerformanceIsLoading ||
      // hotelPerformanceIsLoadingg ||
      hotelPerformanceIsFetching
      // hotelPerformanceIsFetchingg
    ) {
      setIsRefreshing(false);
    } else {
      setIsRefreshing(false);
    }
  }, [
    hotelPerformanceIsLoading ||
    // hotelPerformanceIsLoadingg ||
    hotelPerformanceIsFetching,
    // hotelPerformanceIsFetchingg,
  ]);

  return (
    <>
      {hotelPerformanceIsLoading ? (
        <CustomSkeleton className={100} height={120} />
      ) : (
        <div
          className={`${isOpen ? "h-auto" : "h-[180px]"} scrollingElement gap-4 flex  p-4 bg-newGradient  dark:bg-lightGradient  backdrop-blur-lg drop-shadow-lg shadow-lg  border-white/20 max-w-[100%] scrollHide overflow-x-scroll items-center rounded-lg overflow-y-hidden`}
        >
          <div className="min-w-[320px] min-h-[150px] flex">
            <div className="bg-[#101010] rounded-l-2xl min-w-[130px]">
              <div className="text-white p-2 text-md flex justify-between items-center">
                <div
                  onClick={() =>
                    setSelectedDate(getPreviousMonth(selectedDate))
                  }
                  className="cursor-pointer"
                >
                  <FaChevronLeft />
                </div>
                <div>{format(new Date(selectedDate), "MMM yyyy")}</div>
                {
                  <div
                    onClick={
                      new Date(selectedDate)?.getMonth() >=
                        new Date()?.getMonth()
                        ? null
                        : () => setSelectedDate(getNextMonth(selectedDate))
                    }
                    className={`cursor-pointer ${new Date(selectedDate)?.getMonth() >= new Date()?.getMonth() && "invisible"}`}
                  >
                    <FaChevronRight />
                  </div>
                }
              </div>
              <div className="px-4 mt-1">
                <div className="font-semibold text-sm text-white">
                  {getDayOfDate(format(new Date(), "yyyy-MM-dd"))}
                </div>
                <div className="font-semibold text-[42px] -mt-1 text-white">
                  {format(new Date(), "dd")}
                </div>
              </div>
              {/* <div className="flex text-white px-4 text-sm items-center gap-1">
                <LiaMapMarkerAltSolid /> Delhi, IN
              </div> */}
            </div>
            <div className="bg-[#232323] rounded-r-2xl min-w-[190px]">
              <div className="grid grid-cols-7 p-2">
                {getAllDatesOfMonth(selectedYear, selectedMonth)?.map(
                  (date, index) => {
                    return (
                      <div
                        onClick={() => {
                          toast.error(
                            "Performance is compared monthly, you can switch between months!",
                            { position: "bottom-right" }
                          );
                        }}
                        className={` cursor-pointer ${format(new Date(date), "dd") === format(new Date(selectedDate), "dd") && "bg-blue-500 text-white rounded-l-full"} 
                    ${getAllDatesOfMonth(selectedYear, selectedMonth)?.length === index + 1 && "bg-blue-500 text-white rounded-r-full"} ${(index + 1) % 7 === 0 && "rounded-r-lg"}  mb-1 bg-blue-100 text-black text-xs w-6 h-6 flex justify-center items-center `}
                      >
                        {format(new Date(date), "dd")}
                      </div>
                    );
                  }
                )}
              </div>
            </div>
          </div>

          {Array.isArray(hotelPerformanceDashBoardData?.data) &&
            hotelPerformanceDashBoardData?.data?.map((data, index) => {
              if (data?.title === "OverallOutcome") {
                return (
                  <div className="bg-[#00000066] h-[132px] -mt-3.5 min-w-[230px] rounded-3xl relative pt-4">
                    <div className="px-4">
                      <div className="flex gap-4 items-center">
                        <DynamicHeartIcon height={40} width={40} />
                        <div className="text-[34px] font-semibold text-white ">
                          {data?.value}%
                        </div>
                      </div>
                      {/* <div className="text-sm text-[#0DA858]">
                        Congratulations
                      </div> */}
                      <div className="text-sm text-white">{data?.status}</div>
                    </div>
                    <div className="absolute bottom-0 -right-[85px]">
                      <DynamicPathIcon width={300} />
                    </div>
                  </div>
                );
              } else {
                return (
                  <NewCard
                    chipLabel={data?.status}
                    chipColor={data?.colorCode}
                    percentage={data?.percentage}
                    description={data?.description}
                    value={data?.value}
                    title={data?.title === "Room" ? "Room Nights" : data?.title}
                  />
                );
              }
            })}
        </div>
      )}
    </>
  );
};

const DynamicHeartIcon = ({
  color1 = "#FF2323",
  color2 = "#FB8500",
  width = 66,
  height = 62,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 33 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4529 0.578368C11.4434 0.608493 12.4025 0.781449 13.3318 1.09749H13.4246C13.4874 1.12736 13.5346 1.16038 13.5661 1.19025C13.9135 1.30189 14.2422 1.42768 14.5566 1.60063L15.1541 1.86793C15.39 1.99371 15.673 2.22799 15.8302 2.3239C15.9874 2.41667 16.1604 2.51258 16.3019 2.62107C18.0488 1.28617 20.1698 0.562896 22.3554 0.578368C23.3475 0.578368 24.3381 0.718556 25.2799 1.03459C31.0834 2.92139 33.1745 9.28931 31.4277 14.8553C30.4371 17.6997 28.8176 20.2956 26.6966 22.4167C23.6604 25.3569 20.3286 27.967 16.7422 30.2154L16.3491 30.4528L15.9403 30.1997C12.3412 27.967 8.99059 25.3569 5.92612 22.4009C3.81921 20.2799 2.19814 17.6997 1.19185 14.8553C-0.584883 9.28931 1.50631 2.92139 7.37266 1.00158C7.82864 0.844343 8.29877 0.73428 8.77046 0.672959H8.95914C9.40097 0.608493 9.83965 0.578368 10.2799 0.578368H10.4529Z"
        fill="url(#paint0_linear)"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="0.578613"
          y1="0.578125"
          x2="32.0255"
          y2="30.4528"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.306611" stopColor={color1} />
          <stop offset="1" stopColor={color2} />
        </linearGradient>
      </defs>
    </svg>
  );
};

const DynamicPathIcon = ({
  color1 = "#FF9926",
  color2 = "#FF2323",
  width = 125,
  height = 35,
  strokeWidth = 3.93,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 125 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 45.5778C5.71312 45.7339 10.1104 25.8753 19.482 32.1468C30.1725 39.3009 40.3329 45.4807 47.273 21.1906C52.9729 1.24085 64.3501 -2.72254 71.7826 7.22577C76.0986 13.0027 84.3952 22.6697 95.1523 12.6407C111.93 -3.00175 118.776 17.4856 125.524 17.4856"
        stroke="url(#paint0_linear)"
        strokeWidth={strokeWidth}
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="125.524"
          y1="45.5787"
          x2="36.034"
          y2="7.80847"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0001" stopColor={color1} />
          <stop offset="1" stopColor={color2} />
        </linearGradient>
      </defs>
    </svg>
  );
};

function getAllDatesOfMonth(year, month) {
  console.log(year);
  console.log(month);
  // Create an array to store all the dates
  const dates = [];

  // Create a date object representing the first day of the given month
  let date = new Date(year, month, 1);

  // Get the month index (0-based, so January is 0, February is 1, etc.)
  const monthIndex = date.getMonth();

  // Loop through all the days of the month
  while (date.getMonth() === monthIndex) {
    dates.push(new Date(date)); // Add a copy of the current date to the array
    date.setDate(date.getDate() + 1); // Move to the next day
  }

  return dates;
}

function getDayOfDate(dateInput) {
  // Create a Date object from the input
  const date = new Date(dateInput);

  // Check if the date is valid
  if (isNaN(date)) {
    return "Invalid date";
  }

  // Array of days of the week
  const daysOfWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  // Get the day of the week as a number (0 = Sunday, 6 = Saturday)
  const dayIndex = date.getDay();

  // Return the name of the day
  return daysOfWeek[dayIndex];
}

const LazyLoadItem = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // Stop observing once it's visible
        }
      },
      { threshold: 0.1 } // Load when 10% of the component is in view
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) observer.disconnect();
    };
  }, []);

  return <div ref={ref}>{isVisible ? children : <div>Loading...</div>}</div>;
};